{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            copyright (c) 2024                                      }
{            Email : info@tmssoftware.com                            }
{            Web : https://www.tmssoftware.com                       }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit WEBLib.TMSFNCChartSeriesEditor;

{$I WEBLib.TMSFNCDefines.inc}

{$IFDEF FMXLIB}
{$WARNINGS OFF}
{$HINTS OFF}
{$IF COMPILERVERSION > 30}
{$DEFINE DELPHIBERLIN}
{$IFEND}
{$HINTS ON}
{$WARNINGS ON}
{$ENDIF}

{$IFDEF VCLLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}
{$IFDEF CMNLIB}
{$DEFINE CMNWEBLIB}
{$ENDIF}
{$IFDEF WEBLIB}
{$DEFINE CMNWEBLIB}
{$DEFINE VCLWEBLIB}
{$ENDIF}

interface

uses
  Classes, WEBLib.TMSFNCCustomComponent, WEBLib.TMSFNCCustomControl, WEBLib.Controls,
  WEBLib.TMSFNCTypes, WEBLib.StdCtrls, WEBLib.ExtCtrls, WEBLib.Forms, WEBLib.TMSFNCGraphics, WEBLib.TMSFNCGraphicsTypes,
  WEBLib.TMSFNCChart, WEBLib.TMSFNCEditorButton, WEBLib.TMSFNCEditorPanel, WEBLib.TMSFNCEditorListView, WEBLib.TMSFNCBitmapEditor
  {$IFDEF FMXLIB}
  ,FMX.Types, FMX.Memo, FMX.ListBox, FMX.ComboEdit, FMX.SpinBox, FMX.Colors, FMX.Text, FMX.Edit, FMX.Layouts
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.Samples.Spin
  {$ENDIF}
  {$IFDEF LCLLIB}
  , Spin, ColorBox
  {$ENDIF}
  {$IFDEF VCLLIB}
  , Vcl.ComCtrls
  {$ENDIF}
  {$IFNDEF LCLLIB}
  {$IFNDEF WEBLIB}
  ,UITypes
  {$ENDIF}
  ,Types
  {$ENDIF}
  ;

const
  MAJ_VER = 1; // Major version nr.
  MIN_VER = 0; // Minor version nr.
  REL_VER = 0; // Release nr.
  BLD_VER = 0; // Build nr.

  // version history
  // v1.0.0.0 : First Release

  {$IFDEF VCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 5;
  MIDHEIGHTSPAC = 10;
  BIGHEIGHTSPAC = 15;
  {$ENDIF}
  {$IFDEF LCLLIB}
  CHECKBOXSIZE = 13;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF WEBLIB}
  CHECKBOXSIZE = 17;
  CHECKBOXOFFSET = 6;
  SMALLHEIGHTSPAC = 15;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  {$IFDEF FMXLIB}
  CHECKBOXSIZE = 15;
  SMALLHEIGHTSPAC = 10;
  MIDHEIGHTSPAC = 15;
  BIGHEIGHTSPAC = 20;
  {$ENDIF}
  BIGDIV = 30;
  SMALLLBLSPACE = 10;
  MIDLBLSPACE = 20;
  BIGLBLSPACE = 30;
  SMALLHORSPACE = 60;
  MIDHORSPACE = 70;
  BIGHORSPACE = 80;
  SERIESLARGECONTROLWIDTH = 100;
  LARGECONTROLWIDTH = 100;
  SMALLCONTROLWIDTH = 45;
  VALUE_MBYES = 6;
  SELECTORSIZE = 70;

  TTMSFNCADDBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9z'
    + 'dmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjRweCIgaGVpZ2h0PS'
    + 'IyNHB4IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIHN0'
    + 'eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm87ZmlsbDojMDA3N2JlOyIgZD0iTSAxMiAwIEMgNS4zOD'
    + 'I4MTIgMCAwIDUuMzgyODEyIDAgMTIgQyAwIDE4LjYxNzE4OCA1LjM4MjgxMiAyNCAxMiAyNCBDIDE4LjYxNzE4OCAy'
    + 'NCAyNCAxOC42MTcxODggMjQgMTIgQyAyNCA1LjM4MjgxMiAxOC42MTcxODggMCAxMiAwIFogTSAxMiAyMi4xNDA2Mj'
    + 'UgQyA2LjQxMDE1NiAyMi4xNDA2MjUgMS44NTkzNzUgMTcuNTkzNzUgMS44NTkzNzUgMTIgQyAxLjg1OTM3NSA2LjQw'
    + 'NjI1IDYuNDEwMTU2IDEuODU5Mzc1IDEyIDEuODU5Mzc1IEMgMTcuNTg5ODQ0IDEuODU5Mzc1IDIyLjE0MDYyNSA2Lj'
    + 'QwNjI1IDIyLjE0MDYyNSAxMiBDIDIyLjE0MDYyNSAxNy41OTM3NSAxNy41OTM3NSAyMi4xNDA2MjUgMTIgMjIuMTQw'
    + 'NjI1IFogTSAxMiAyMi4xNDA2MjUgIi8+CjxwYXRoIHN0eWxlPSIgc3Ryb2tlOm5vbmU7ZmlsbC1ydWxlOm5vbnplcm'
    + '87ZmlsbDojMDA3N2JlO2ZpbGwtb3BhY2l0eToxOyIgZD0iTSAxNi42NDg0MzggMTAuOTg4MjgxIEwgMTIuOTI5Njg4'
    + 'IDEwLjk4ODI4MSBMIDEyLjkyOTY4OCA3LjI2OTUzMSBDIDEyLjkyOTY4OCA2Ljc1MzkwNiAxMi41MTU2MjUgNi4zMz'
    + 'k4NDQgMTIgNi4zMzk4NDQgQyAxMS40ODQzNzUgNi4zMzk4NDQgMTEuMDcwMzEyIDYuNzUzOTA2IDExLjA3MDMxMiA3'
    + 'LjI2OTUzMSBMIDExLjA3MDMxMiAxMC45ODgyODEgTCA3LjM1MTU2MiAxMC45ODgyODEgQyA2LjgzOTg0NCAxMC45OD'
    + 'gyODEgNi40MjE4NzUgMTEuNDAyMzQ0IDYuNDIxODc1IDExLjkxNzk2OSBDIDYuNDIxODc1IDEyLjQyOTY4OCA2Ljgz'
    + 'OTg0NCAxMi44NDc2NTYgNy4zNTE1NjIgMTIuODQ3NjU2IEwgMTEuMDcwMzEyIDEyLjg0NzY1NiBMIDExLjA3MDMxMi'
    + 'AxNi41NjI1IEMgMTEuMDcwMzEyIDE3LjA3ODEyNSAxMS40ODQzNzUgMTcuNDkyMTg4IDEyIDE3LjQ5MjE4OCBDIDEy'
    + 'LjUxNTYyNSAxNy40OTIxODggMTIuOTI5Njg4IDE3LjA3ODEyNSAxMi45Mjk2ODggMTYuNTYyNSBMIDEyLjkyOTY4OC'
    + 'AxMi44NDc2NTYgTCAxNi42NDg0MzggMTIuODQ3NjU2IEMgMTcuMTYwMTU2IDEyLjg0NzY1NiAxNy41NzgxMjUgMTIu'
    + 'NDI5Njg4IDE3LjU3ODEyNSAxMS45MTc5NjkgQyAxNy41NzgxMjUgMTEuNDAyMzQ0IDE3LjE2MDE1NiAxMC45ODgyOD'
    + 'EgMTYuNjQ4NDM4IDEwLjk4ODI4MSBaIE0gMTYuNjQ4NDM4IDEwLjk4ODI4MSAiLz4KPC9nPgo8L3N2Zz4K';

  TTMSFNCREMOVEBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PHN2ZyBpZD0iSWNvbnMiIGhlaWdodD0iNTEyIiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSI1MTIiIH'
    + 'htbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iIzAwNzdiZSIgZD0ibTEyIDFhMTEgMTEgMCAxIDAg'
    + 'MTEgMTEgMTEuMDEzIDExLjAxMyAwIDAgMCAtMTEtMTF6bTAgMjBhOSA5IDAgMSAxIDktOSA5LjAxIDkuMDEgMCAwIDEgLTkgOXoiLz'
    + '48cGF0aCBmaWxsPSIjMDA3N2JlIiBkPSJtMTYgMTFoLThhMSAxIDAgMCAwIDAgMmg4YTEgMSAwIDAgMCAwLTJ6Ii8+PC9zdmc+';

  TTMSFNCCLEARBITMAP = {$IFDEF WEBLIB}'data:image/svg+xml;base64,' + {$ENDIF} 'PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vc'
    + 'mcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjRweCIgaGVpZ2h0PSIyNHB4I'
    + 'iB2aWV3Qm94PSIwIDAgMjQgMjQiIHZlcnNpb249IjEuMSI+CjxnIGlkPSJzdXJmYWNlMSI+CjxwYXRoIGZpbGw9IiMwMDc3QkUiIGQ9Ik0gM'
    + 'jAuNDkyMTg4IDMuNTExNzE5IEMgMTUuODEyNSAtMS4xNjc5NjkgOC4xOTUzMTIgLTEuMTY3OTY5IDMuNTE1NjI1IDMuNTExNzE5IEMgMS4yN'
    + 'SA1Ljc4MTI1IDAgOC43OTI5NjkgMCAxMiBDIDAgMTUuMjA3MDMxIDEuMjUgMTguMjE4NzUgMy41MTU2MjUgMjAuNDg4MjgxIEMgNS44NTU0N'
    + 'jkgMjIuODI4MTI1IDguOTI5Njg4IDIzLjk5NjA5NCAxMi4wMDM5MDYgMjMuOTk2MDk0IEMgMTUuMDc4MTI1IDIzLjk5NjA5NCAxOC4xNDg0M'
    + 'zggMjIuODI4MTI1IDIwLjQ5MjE4OCAyMC40ODgyODEgQyAyNS4xNjc5NjkgMTUuODA4NTk0IDI1LjE2Nzk2OSA4LjE5MTQwNiAyMC40OTIxO'
    + 'DggMy41MTE3MTkgWiBNIDE5LjE3NTc4MSAxOS4xNzE4NzUgQyAxNS4yMTg3NSAyMy4xMjg5MDYgOC43ODUxNTYgMjMuMTI4OTA2IDQuODI4M'
    + 'TI1IDE5LjE3MTg3NSBDIDIuOTE0MDYyIDE3LjI1NzgxMiAxLjg1OTM3NSAxNC43MTA5MzggMS44NTkzNzUgMTIgQyAxLjg1OTM3NSA5LjI5M'
    + 'jk2OSAyLjkxNDA2MiA2Ljc0MjE4OCA0LjgyODEyNSA0LjgyODEyNSBDIDguNzg1MTU2IDAuODcxMDk0IDE1LjIxODc1IDAuODc1IDE5LjE3N'
    + 'Tc4MSA0LjgyODEyNSBDIDIzLjEyODkwNiA4Ljc4MTI1IDIzLjEyODkwNiAxNS4yMTg3NSAxOS4xNzU3ODEgMTkuMTcxODc1IFogTSAxOS4xN'
    + 'zU3ODEgMTkuMTcxODc1ICIvPgo8cGF0aCBmaWxsPSIjMDA3N0JFIiBkPSJNIDE2LjAwNzgxMiAxNC41NzAzMTIgTCAxMy4zNzg5MDYgMTEuO'
    + 'TQxNDA2IEwgMTYuMDA3ODEyIDkuMzEyNSBDIDE2LjM3MTA5NCA4Ljk0OTIxOSAxNi4zNzEwOTQgOC4zNjMyODEgMTYuMDExNzE5IDggQyAxN'
    + 'S42NDg0MzggNy42MzI4MTIgMTUuMDU4NTk0IDcuNjM2NzE5IDE0LjY5NTMxMiA3Ljk5NjA5NCBMIDEyLjA2MjUgMTAuNjI4OTA2IEwgOS40M'
    + 'jU3ODEgNy45OTYwOTQgQyA5LjA2MjUgNy42MzY3MTkgOC40NzY1NjIgNy42MzI4MTIgOC4xMDkzNzUgOCBDIDcuNzUgOC4zNjMyODEgNy43N'
    + 'SA4Ljk0OTIxOSA4LjExMzI4MSA5LjMxMjUgTCAxMC43NDIxODggMTEuOTQxNDA2IEwgOC4xMTMyODEgMTQuNTcwMzEyIEMgNy43NSAxNC45M'
    + 'zM1OTQgNy43NSAxNS41MTk1MzEgOC4xMDkzNzUgMTUuODg2NzE5IEMgOC4yOTI5NjkgMTYuMDY2NDA2IDguNTMxMjUgMTYuMTU2MjUgOC43N'
    + 'jk1MzEgMTYuMTU2MjUgQyA5LjAwNzgxMiAxNi4xNTYyNSA5LjI0NjA5NCAxNi4wNjY0MDYgOS40MjU3ODEgMTUuODg2NzE5IEwgMTIuMDYyN'
    + 'SAxMy4yNTM5MDYgTCAxNC42OTUzMTIgMTUuODg2NzE5IEMgMTQuODc1IDE2LjA2NjQwNiAxNS4xMTMyODEgMTYuMTU2MjUgMTUuMzUxNTYyI'
    + 'DE2LjE1NjI1IEMgMTUuNTg5ODQ0IDE2LjE1NjI1IDE1LjgyODEyNSAxNi4wNjY0MDYgMTYuMDExNzE5IDE1Ljg4NjcxOSBDIDE2LjM3MTA5N'
    + 'CAxNS41MTk1MzEgMTYuMzcxMDk0IDE0LjkzMzU5NCAxNi4wMDc4MTIgMTQuNTcwMzEyIFogTSAxNi4wMDc4MTIgMTQuNTcwMzEyICIvPgo8L'
    + '2c+Cjwvc3ZnPgo=';

resourcestring
  sTMSFNCChartSeriesEditorOK = 'OK';
  sTMSFNCChartSeriesEditorCancel = 'Cancel';
  sTMSFNCChartSeriesEditorApply = 'Apply';
  sTMSFNCChartSeriesEditorReset = 'Reset';
  sTMSFNCChartSeriesEditorLegend = '&Legend';
  sTMSFNCChartSeriesEditorLegendText = 'Legend';
  sTMSFNCChartSeriesEditorGeneral = '&General';
  sTMSFNCChartSeriesEditorGeneralText = 'General';
  sTMSFNCChartSeriesEditorSeries = '&Series';
  sTMSFNCChartSeriesEditorTitle = '&Title';
  sTMSFNCChartSeriesEditorTitleText = 'Title';
  sTMSFNCChartSeriesEditorXAxis = '&X-Axis';
  sTMSFNCChartSeriesEditorYAxis = '&Y-Axis';
  sTMSFNCChartSeriesEditorAppearance = 'Appearance';
  sTMSFNCChartSeriesEditorSerieMargins = 'Series Margins';
  sTMSFNCChartSeriesEditorLeft = 'Left';
  sTMSFNCChartSeriesEditorTop = 'Top';
  sTMSFNCChartSeriesEditorRight = 'Right';
  sTMSFNCChartSeriesEditorBottom = 'Bottom';
  sTMSFNCChartSeriesEditorCenter = 'Center';
  sTMSFNCChartSeriesEditorFill = 'Fill';
  sTMSFNCChartSeriesEditorStroke = 'Stroke';
  sTMSFNCChartSeriesEditorColor = 'Color';
  sTMSFNCChartSeriesEditorColorTo = 'Color To';
  sTMSFNCChartSeriesEditorKind = 'Kind';
  sTMSFNCChartSeriesEditorGradient = 'Gradient';
  sTMSFNCChartSeriesEditorOpacity = 'Opacity';
  sTMSFNCChartSeriesEditorWidth = 'Width';
  sTMSFNCChartSeriesEditorPosition = 'Position';
  sTMSFNCChartSeriesEditorInteraction = 'Interaction';
  sTMSFNCChartSeriesEditorEnabled = 'Enabled';
  sTMSFNCChartSeriesEditorPanning = 'Panning';
  sTMSFNCChartSeriesEditorScaleMode = 'Scale Mode';
  sTMSFNCChartSeriesEditorSample = 'Sample';
  sTMSFNCChartSeriesEditorInitialize = '&Initialize';
  sTMSFNCChartSeriesEditorInitText = 'Initializes the chart with 3 series and random data';
  sTMSFNCChartSeriesEditorValue = 'Value';
  sTMSFNCChartSeriesEditorValues = 'Values';
  sTMSFNCChartSeriesEditorShow = 'Show';
  sTMSFNCChartSeriesEditorVisible = 'Visible';
  sTMSFNCChartSeriesEditorAutosize = 'Autosize';
  sTMSFNCChartSeriesEditorFont = 'Font';
  sTMSFNCChartSeriesEditorName = 'Name';
  sTMSFNCChartSeriesEditorSize = 'Size';
  sTMSFNCChartSeriesEditorHAlign = 'H-Align';
  sTMSFNCChartSeriesEditorVAlign = 'V-Align';
  sTMSFNCChartSeriesEditorBorder = 'Border';
  sTMSFNCChartSeriesEditorLine = 'Line';
  sTMSFNCChartSeriesEditorHeight = 'Height';
  sTMSFNCChartSeriesEditorText = 'Text';
  sTMSFNCChartSeriesEditorTextMargins = 'Text Margins';
  sTMSFNCChartSeriesEditorDisplayAtReference = 'Display at Reference';
  sTMSFNCChartSeriesEditorReference = 'Reference';
  sTMSFNCChartSeriesEditorType = 'Type';
  sTMSFNCChartSeriesEditorLabels = 'Labels';
  sTMSFNCChartSeriesEditorMarkers = 'Markers';
  sTMSFNCChartSeriesEditorPoints = 'Points';
  sTMSFNCChartSeriesEditorXGrid = 'X-Grid';
  sTMSFNCChartSeriesEditorXValues = 'X-Values';
  sTMSFNCChartSeriesEditorYGrid = 'Y-Grid';
  sTMSFNCChartSeriesEditorYValues = 'Y-Values';
  sTMSFNCChartSeriesEditorPie = 'Pie';
  sTMSFNCChartSeriesEditor3D = '3D';
  sTMSFNCChartSeriesEditorOffsetX = 'Offset X';
  sTMSFNCChartSeriesEditorOffsetY = 'Offset Y';
  sTMSFNCChartSeriesEditorGroup = 'Group';
  sTMSFNCChartSeriesEditorMode = 'Mode';
  sTMSFNCChartSeriesEditorRange = 'Range';
  sTMSFNCChartSeriesEditorXRange = 'X-Range';
  sTMSFNCChartSeriesEditorYRange = 'Y-Range';
  sTMSFNCChartSeriesEditorZRV = 'Zero Ref';
  sTMSFNCChartSeriesEditorMinX = 'Min X';
  sTMSFNCChartSeriesEditorMaxX = 'Max X';
  sTMSFNCChartSeriesEditorMinY = 'Min Y';
  sTMSFNCChartSeriesEditorMaxY = 'Max Y';
  sTMSFNCChartSeriesEditorMinXOffset = 'Min X Off.';
  sTMSFNCChartSeriesEditorMaxXOffset = 'Max X Off.';
  sTMSFNCChartSeriesEditorMinYOffset = 'Min Y Off.';
  sTMSFNCChartSeriesEditorMaxYOffset = 'Max Y Off.';
  sTMSFNCChartSeriesEditorAnimation = 'Animation';
  sTMSFNCChartSeriesEditorFactor = 'Factor';
  sTMSFNCChartSeriesEditorFlow = 'Flow';
  sTMSFNCChartSeriesEditorBar = 'Bar';
  sTMSFNCChartSeriesEditorSpacing = 'Spacing';
  sTMSFNCChartSeriesEditorMultiPoint = 'Multi-Point';
  sTMSFNCChartSeriesEditorIncreaseFill = 'Inc Fill';
  sTMSFNCChartSeriesEditorDecreaseFill = 'Dec Fill';
  sTMSFNCChartSeriesEditorIncreaseStroke = 'Inc Stroke';
  sTMSFNCChartSeriesEditorDecreaseStroke = 'Dec Stroke';
  sTMSFNCChartSeriesEditorLineTypes = 'Line Types';
  sTMSFNCChartSeriesEditorAreaTypes = 'Area Types';
  sTMSFNCChartSeriesEditorBarTypes = 'Bar Types';
  sTMSFNCChartSeriesEditorMultiPointTypes = 'Multi-Point Types';
  sTMSFNCChartSeriesEditorOtherTypes = 'Other Types';
  sTMSFNCChartSeriesEditorFormat = 'Format';
  sTMSFNCChartSeriesEditorBitmap = 'Bitmap';
  sTMSFNCChartSeriesEditorShape = 'Shape';
  sTMSFNCChartSeriesEditorVisibility = 'Visibility';
  sTMSFNCChartSeriesEditorExtended = 'Extended';
  sTMSFNCChartSeriesEditorMajorStroke = 'Major Stroke';
  sTMSFNCChartSeriesEditorMinorStroke = 'Minor Stroke';
  sTMSFNCChartSeriesEditorSpider = 'Spider';
  sTMSFNCChartSeriesEditorAngle = 'Angle';
  sTMSFNCChartSeriesEditorMajorFont = 'Major Font';
  sTMSFNCChartSeriesEditorMinorFont = 'Minor Font';
  sTMSFNCChartSeriesEditorMajorTickmark = 'Major Tickmark';
  sTMSFNCChartSeriesEditorMinorTickmark = 'Minor Tickmark';
  sTMSFNCChartSeriesEditorMajorFormat = 'Major Format';
  sTMSFNCChartSeriesEditorMinorFormat = 'Minor Format';
  sTMSFNCChartSeriesEditorMajor = 'Major';
  sTMSFNCChartSeriesEditorMinor = 'Minor';
  sTMSFNCChartSeriesEditorMajorSpacing = 'Maj Spacing';
  sTMSFNCChartSeriesEditorMinorSpacing = 'Min Spacing';
  sTMSFNCChartSeriesEditorAuto = 'Auto';
  sTMSFNCChartSeriesEditorUnits = 'Units';
  sTMSFNCChartSeriesEditorSmartLabels = 'Smart Labels';
  sTMSFNCChartSeriesEditorSmartEnabled = 'Enabled';
  sTMSFNCChartSeriesEditorSmartAutoRotate = 'Auto Rotate';
  sTMSFNCChartSeriesEditorSmartMinSpacing = 'Min Spacing';
  sTMSFNCChartSeriesEditorSmartMinLabels = 'Min Labels';
  sTMSFNCChartSeriesEditorSmartMaxLabels = 'Max Labels';
  sTMSFNCChartSeriesEditorMargins = 'Margins';
  sTMSFNCChartSeriesEditorInnerSize = 'Inner Size';
  sTMSFNCChartSeriesEditorStartAngle = 'Start Angle';
  sTMSFNCChartSeriesEditorSweepAngle = 'Sweep Angle';
  sTMSFNCChartSeriesEditorStacked = 'Stacked';
  sTMSFNCChartSeriesEditorLayout = 'Layout';
  sTMSFNCChartSeriesEditorAnnotations = 'Annotations';
  sTMSFNCChartSeriesEditorXValue = 'X-Value';
  sTMSFNCChartSeriesEditorYValue = 'Y-Value';
  sTMSFNCChartSeriesEditorXValueText = 'X-Value Text';
  sTMSFNCChartSeriesEditorTextLegend = 'Legend Text';
  sTMSFNCChartSeriesEditorExplode = 'Explode';
  sTMSFNCChartSeriesEditorYValueVariable = 'Y-Value Variable';
  sTMSFNCChartSeriesEditorYValueSecond = 'Y-Value Second';
  sTMSFNCChartSeriesEditorYValueHigh = 'Y-Value High';
  sTMSFNCChartSeriesEditorYValueOpen = 'Y-Value Open';
  sTMSFNCChartSeriesEditorYValueLow = 'Y-Value Low';
  sTMSFNCChartSeriesEditorYValueClose = 'Y-Value Close';
  sTMSFNCChartSeriesEditorYValueMed = 'Y-Value Median';
  sTMSFNCChartSeriesEditorPoint = 'Point';
  sTMSFNCChartSeriesEditorCorner = 'Corner';
  sTMSFNCChartSeriesEditorArrow = 'Arrow';
  sTMSFNCChartSeriesEditorWordWrap = 'Wordwrap';
  sTMSFNCChartSeriesEditorAnno = 'Anno';
  sTMSFNCChartSeriesEditorTypeProperties = 'Type Specific';
  sTMSFNCChartSeriesEditorAdd = 'Add a new series to the Chart.';
  sTMSFNCChartSeriesEditorRemove = 'Remove the selected series from the Chart.';
  sTMSFNCChartSeriesEditorClear = 'Remove all series from the Chart.';
  sTMSFNCChartSeriesEditorNavigateSeriesMessage = 'Do you want to navigate to the series page?';
  sTMSFNCChartSeriesEditorClearSeriesMessage = 'Are you sure you want to clear the existing Series?';
  sTMSFNCChartSeriesEditorClearPointsMessage = 'Are you sure you want to clear the existing Points?';
  sTMSFNCChartSeriesEditorSaveChartMessage = 'Are you sure you want to save the changes made?';
  sTMSFNCChartSeriesEditorCancelChartMessage = 'Are you sure you don''t want to save the changes made?';
  sTMSFNCChartSeriesEditorResetChartMessage = 'Are you sure you want to revert to the last saved settings?';
type
  TTMSFNCChartSeriesEditor = class;

  TTMSFNCChartEditorSelector = class(TTMSFNCChartSelector)
  public
    constructor Create(AOwner: TComponent); override;
  end;

  {$IFDEF FMXLIB}
  TTMSFNCChartSeriesEditorParent = TFmxObject;
  TTMSFNCChartSeriesEditorComboBox = class(TComboBox);
  TTMSFNCChartSeriesEditorSpinEdit = class(TSpinBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  TTMSFNCChartSeriesEditorColorCombo = class(TComboColorBox);
  TTMSFNCChartSeriesEditorAlphaTrackBar = class(TAlphaTrackBar);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  TTMSFNCChartSeriesEditorParent = TWinControl;
  TTMSFNCChartSeriesEditorComboBox = class(TComboBox)
  public
    constructor Create(AOwner: TComponent); override;
  end;
  {$IFNDEF LCLLIB}
  TTMSFNCChartSeriesEditorSpinEdit = class(TSpinEdit);
  {$ENDIF}
  {$IFDEF LCLLIB}
  TTMSFNCChartSeriesEditorSpinEdit = class(TFloatSpinEdit);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  TTMSFNCChartSeriesEditorColorCombo = class(TColorBox);
  {$ENDIF}
  {$IFDEF WEBLIB}
  TTMSFNCChartSeriesEditorColorCombo = class(TWebColorPicker);
  {$ENDIF}
  {$ENDIF}

  {$IFNDEF LCLLIB}
  [ComponentPlatformsAttribute(TMSPlatformsDesktop)]
  {$ENDIF}
  TTMSFNCChartSeriesEditor = class(TTMSFNCCustomComponent)
  private
    FBitmapEditor: TTMSFNCBitmapEditor;
    FSerieIndex, FPointIndex, FAnnoIndex: Integer;
    {$IFNDEF FMXLIB}
    FVertScrlBox: TScrollBox;
    {$ENDIF}
    {$IFDEF FMXLIB}
    FVertScrlBox: TVertScrollBox;
    {$ENDIF}
    FSeriesPanel:TTMSFNCEditorPanel;

    FSeriesSelectCombo:  TTMSFNCChartSeriesEditorComboBox;

    FSeriesTopPanel,
    FSeriesGeneralPanel, FSeriesLegendPanel, FSeriesTypePanel, FSeriesLabelsPanel, FSeriesMarkersPanel: TTMSFNCEditorPanel;
    FSeriesXGridPanel, FSeriesXValuesPanel, FSeriesYGridPanel, FSeriesYValuesPanel, FSeriesPiePanel: TTMSFNCEditorPanel;

    FAddSeriesButton, FDeleteSeriesButton, FClearSeriesButton: TTMSFNCEditorButton;
    FSeriesButtonGeneral, FSeriesButtonLegend, FSeriesButtonType, FSeriesButtonLabels, FSeriesButtonMarkers: TTMSFNCEditorButton;
    FSeriesButtonXGrid, FSeriesButtonXValues, FSeriesButtonYGrid, FSeriesButtonYValues, FSeriesButtonPie: TTMSFNCEditorButton;

    FGenSeriesFillCol1, FGenSeriesFillCol2, FGenSeriesStrokeCol: TTMSFNCChartSeriesEditorColorCombo;
    FGenSeriesIncFill, FGenSeriesDecFill, FGenSeriesIncStroke, FGenSeriesDecStroke: TTMSFNCChartSeriesEditorColorCombo;
    FGenSeriesFillKind, FGenSeriesFillGradient, FGenSeriesStrokeKind, FGenSeriesMode: TTMSFNCChartSeriesEditorComboBox;
    FGenSeriesXRange, FGenSeriesYRange, FGenSeriesBarType, FGenSeriesMultiType: TTMSFNCChartSeriesEditorComboBox;
    FGenSeriesZRV, FGenSeriesMinX,FGenSeriesMaxX, FGenSeriesMinY, FGenSeriesMaxY, FGenSeriesMinXOff,FGenSeriesMaxXOff, FGenSeriesMinYOff, FGenSeriesMaxYOff: TTMSFNCChartSeriesEditorSpinEdit;
    FGenSeriesFactor, FGenSeriesBarWidth, FGenSeriesBarSpacing, FGenSeriesMultiWidth: TTMSFNCChartSeriesEditorSpinEdit;
    FGenSeriesFlowCheck: TCheckBox;
    FGenSeriesStrokeWidth, FGenSeriesOffsetX, FGenSeriesOffsetY, FGenSeriesGroup: TTMSFNCChartSeriesEditorSpinEdit;
    FGenSeriesVisibleCheck, FGenSeriesEnabledCheck: TCheckBox;

    FLegSeriesFillCol1, FLegSeriesFillCol2, FLegSeriesStrokeCol, FLegSeriesFontCol: TTMSFNCChartSeriesEditorColorCombo;
    FLegSeriesFillKind, FLegSeriesFillGradient,FLegSeriesStrokeKind, FLegSeriesValue, FLegSeriesFontName: TTMSFNCChartSeriesEditorComboBox;
    FLegSeriesAppLeft, FLegSeriesAppTop, FLegSeriesSize, FLegSeriesStrokeWidth :TTMSFNCChartSeriesEditorSpinEdit;
    FLegSeriesText: TEdit;

    FLegSeriesVisibleCheck, FLegSeriesShowCheck: TCheckBox;

    FLabelSeriesFillCol1, FLabelSeriesFillCol2, FLabelSeriesStrokeCol, FLabelSeriesFontCol: TTMSFNCChartSeriesEditorColorCombo;
    FLabelSeriesFillKind, FLabelSeriesFillGradient,FLabelSeriesStrokeKind, FLabelSeriesType, FLabelSeriesMode, FLabelSeriesFontName: TTMSFNCChartSeriesEditorComboBox;
    FLabelSeriesOffsetX, FLabelSeriesOffsetY, FLabelSeriesSize, FLabelSeriesStrokeWidth :TTMSFNCChartSeriesEditorSpinEdit;
    FLabelSeriesText: TEdit;
    FLabelSeriesVisibleCheck: TCheckBox;
    FImage: TTMSFNCCustomControl;

    FMarkersSeriesFillCol1, FMarkersSeriesFillCol2, FMarkersSeriesStrokeCol: TTMSFNCChartSeriesEditorColorCombo;
    FMarkersSeriesFillKind, FMarkersSeriesFillGradient, FMarkersSeriesStrokeKind, FMarkersSeriesShape: TTMSFNCChartSeriesEditorComboBox;
    FMarkersSeriesWidth, FMarkersSeriesHeight, FMarkersSeriesStrokeWidth :TTMSFNCChartSeriesEditorSpinEdit;
    FMarkersSeriesVisibleCheck: TCheckBox;

    FXGridSeriesVisibleCheck, FXGridSeriesExtendedCheck, FYGridSeriesVisibleCheck, FYGridSeriesExtendedCheck, FYGridSeriesSpiderVisibleCheck, FYGridSeriesLegendTextCheck: TCheckBox;
    FXGridSeriesMajorStrokeCol, FXGridSeriesMinorStrokeCol, FYGridSeriesMajorStrokeCol, FYGridSeriesMinorStrokeCol: TTMSFNCChartSeriesEditorColorCombo;
    FXGridSeriesMajorStrokeKind, FXGridSeriesMinorStrokeKind, FYGridSeriesMajorStrokeKind, FYGridSeriesMinorStrokeKind, FYGridSeriesSpiderKind: TTMSFNCChartSeriesEditorComboBox;
    FXGridSeriesMajorStrokeWidth, FXGridSeriesMinorStrokeWidth, FYGridSeriesMajorStrokeWidth, FYGridSeriesMinorStrokeWidth: TTMSFNCChartSeriesEditorSpinEdit;

    FXValSeriesTopCheck, FXValSeriesCenterCheck, FXValSeriesBottomCheck, FXValSeriesAutoCheck: TCheckBox;
    FXValSeriesMajSpacing, FXValSeriesMinSpacing, FXValSeriesAngle, FXValSeriesUnitMajor, FXValSeriesUnitMinor: TTMSFNCChartSeriesEditorSpinEdit;
    FXValSeriesMajFontSize, FXValSeriesMinFontSize, FXValSeriesMajTickSize, FXValSeriesMinTickSize, FXValSeriesTitleFontSize: TTMSFNCChartSeriesEditorSpinEdit;
    FXValSeriesTextLeft, FXValSeriesTextTop, FXValSeriesTextRight, FXValSeriesTextBottom: TTMSFNCChartSeriesEditorSpinEdit;
    FXValSeriesMajFontCol, FXValSeriesMajTickCol, FXValSeriesMinFontCol, FXValSeriesMinTickCol, FXValSeriesTitleFontCol :TTMSFNCChartSeriesEditorColorCombo;
    FXValSeriesMajFontName, FXValSeriesMinFontName, FXValSeriesTitleFontName: TTMSFNCChartSeriesEditorComboBox;
    FXValSeriesMajFormatType, FXValSeriesMinFormatType, FXValSeriesTitleVAlign, FXValSeriesTitleHAlign: TTMSFNCChartSeriesEditorComboBox;
    FXValSeriesMajFormatValue, FXValSeriesMinFormatValue, FXValSeriesTitleValue: TEdit;

    FXValSeriesSmartEnabledCheck, FXValSeriesSmartAutoRotateCheck: TCheckBox;
    FXValSeriesSmartMinSpacing, FXValSeriesSmartMinLabels, FXValSeriesSmartMaxLabels: TTMSFNCChartSeriesEditorSpinEdit;

    FYValSeriesLeftCheck, FYValSeriesCenterCheck, FYValSeriesRightCheck, FYValSeriesAutoCheck, FYValSeriesValuesCheck: TCheckBox;
    FYValSeriesMajSpacing, FYValSeriesMinSpacing, FYValSeriesUnitMajor, FYValSeriesUnitMinor: TTMSFNCChartSeriesEditorSpinEdit;
    FYValSeriesMajFontSize, FYValSeriesMinFontSize, FYValSeriesMajTickSize, FYValSeriesMinTickSize, FYValSeriesTitleFontSize: TTMSFNCChartSeriesEditorSpinEdit;
    FYValSeriesTextLeft, FYValSeriesTextTop, FYValSeriesTextRight, FYValSeriesTextBottom: TTMSFNCChartSeriesEditorSpinEdit;
    FYValSeriesMajFontCol, FYValSeriesMajTickCol, FYValSeriesMinFontCol, FYValSeriesMinTickCol, FYValSeriesTitleFontCol: TTMSFNCChartSeriesEditorColorCombo;
    FYValSeriesMajFontName, FYValSeriesMinFontName, FYValSeriesTitleFontName: TTMSFNCChartSeriesEditorComboBox;
    FYValSeriesMajFormatType, FYValSeriesMinFormatType, FYValSeriesTitleVAlign, FYValSeriesTitleHAlign: TTMSFNCChartSeriesEditorComboBox;
    FYValSeriesMajFormatValue, FYValSeriesMinFormatValue, FYValSeriesTitleValue: TEdit;

    FYValSeriesSmartEnabledCheck, FYValSeriesSmartAutoRotateCheck: TCheckBox;
    FYValSeriesSmartMinSpacing, FYValSeriesSmartMinLabels, FYValSeriesSmartMaxLabels: TTMSFNCChartSeriesEditorSpinEdit;

    FChartSelectorLine, FChartSelectorDigitalLine, FChartSelectorArea, FChartSelectorStackedArea, FChartSelectorStackedPercArea, FChartSelectorBar: TTMSFNCChartEditorSelector;
    FChartSelectorStackedBar, FChartSelectorPercBar, FChartSelectorMarker, FChartSelectorXYLine, FChartSelectorXYMarker, FChartSelectorPie: TTMSFNCChartEditorSelector;
    FChartSelectorVarRadiusPie, FChartSelectorSizedPie, FChartSelectorSpider, FChartSelectorBand, FChartSelectorOHLC, FChartSelectorCandleStick, FChartSelectorBoxPlot: TTMSFNCChartEditorSelector;

    FPieSeriesLeft, FPieSeriesTop, FPieSeriesRight, FPieSeriesBottom: TTMSFNCChartSeriesEditorSpinEdit;
    FPieSeriesSize, FPieSeriesInnerSize, FPieSeriesStartAngle, FPieSeriesSweepAngle: TTMSFNCChartSeriesEditorSpinEdit;
    FPieSeriesAutoSizeCheck, FPieSeriesStackedCheck :TCheckBox;
    FPieSeriesPosition: TTMSFNCChartSeriesEditorComboBox;

    {$IFDEF FMXLIB}
    FGenSeriesFillOpacity, FGenSeriesStrokeOpacity, FLegSeriesFillOpacity, FLegSeriesStrokeOpacity: TTMSFNCChartSeriesEditorAlphaTrackBar;
    FLabelSeriesFillOpacity, FLabelSeriesStrokeOpacity, FMarkersSeriesFillOpacity, FMarkersSeriesStrokeOpacity: TTMSFNCChartSeriesEditorAlphaTrackBar;
    FXGridSeriesMajorStrokeOpacity, FXGridSeriesMinorStrokeOpacity, FYGridSeriesMajorStrokeOpacity, FYGridSeriesMinorStrokeOpacity: TTMSFNCChartSeriesEditorAlphaTrackBar;
    {$ENDIF}

    frm: TTMSFNCCustomDesignerForm;
    FTopPanel, FPanel: TTMSFNCEditorPanel;
    FSeriesButtonsPanel: TTMSFNCEditorPanel;
    FChart: TTMSFNCChart;
    FCopyChart: TTMSFNCChart;
    FButtonOk, FButtonCancel: TTMSFNCEditorButton;
    FModified: Boolean;
    FSerie: TTMSFNCChartSerie;
    procedure SetChart(const Value: TTMSFNCChart);
    function CancelChartMessage: Boolean;
    function SaveChartMessage: Boolean;
    function ClearSeriesMessage: Boolean;
    procedure SetSeriesEvents;
    procedure UpdateSeriesCombo(AIndex: Integer = -1);
    procedure SetSerie(const Value: TTMSFNCChartSerie);
  protected
    {$IFDEF CMNWEBLIB}
    procedure SetColorComboStyle(AColorcombo: TTMSFNCChartSeriesEditorColorCombo);
    {$ENDIF}
    function GetInstance: NativeUInt; override;
    procedure RegisterRuntimeClasses; override;
    procedure Notification(AComponent: TComponent; AOperation: TOperation); override;
    procedure BuildEditor(AParent: TTMSFNCChartSeriesEditorParent); virtual;
    procedure Initialize; virtual;
    procedure SetAppearance; virtual;
    procedure FillFonts;
    procedure BuildSeriesSelectionPanel(AParent: TTMSFNCChartSeriesEditorParent);
    procedure BuildSeriesPanels(AParent: TTMSFNCChartSeriesEditorParent);
    {$IFNDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
    {$ENDIF}
    {$IFDEF FMXLIB}
    procedure DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
    {$ENDIF}
    procedure DoAddSeries(Sender: TObject); virtual;
    procedure DoDeleteSeries(Sender: TObject); virtual;
    procedure DoClearSeries(Sender: TObject); virtual;
    procedure DoSeriesChangeTab(Sender: TObject); virtual;

    procedure DoOpenFile(Sender: TObject); virtual;
    procedure DoAfterDraw(Sender: TObject; AGraphics: TTMSFNCGraphics; ARect: TRectF); virtual;
    procedure DoSeriesComboChange(Sender: TObject); virtual;

    procedure InitSeriesValues;

    procedure DoGenSeriesFillChange(Sender: TObject); virtual;
    procedure DoGenSeriesStrokeChange(Sender: TObject); virtual;
    procedure DoGenSeries3DChange(Sender: TObject); virtual;
    procedure DoGenSeriesOtherChange(Sender: TObject); virtual;
    procedure DoGenSeriesRangeChange(Sender: TObject); virtual;
    procedure DoGenSeriesRangeMinMax(Sender: TObject); virtual;
    procedure DoGenSeriesRangeOffsetChange(Sender: TObject); virtual;
    procedure DoGenSeriesBarChange(Sender: TObject); virtual;
    procedure DoGenSeriesMultiPointChange(Sender: TObject); virtual;
    procedure DoGenSeriesAnimationChange(Sender: TObject); virtual;
    procedure DoLegSeriesPositionChange(Sender: TObject); virtual;
    procedure DoLegSeriesFillChange(Sender: TObject); virtual;
    procedure DoLegSeriesStrokeChange(Sender: TObject); virtual;
    procedure DoLegSeriesFontChange(Sender: TObject); virtual;
    procedure DoLegSeriesTextChange(Sender: TObject); virtual;
    procedure DoChartSelectorClick(Sender: TObject); virtual;
    procedure DoLblSeriesPositionChange(Sender: TObject); virtual;
    procedure DoLblSeriesFillChange(Sender: TObject); virtual;
    procedure DoLblSeriesStrokeChange(Sender: TObject); virtual;
    procedure DoLblSeriesFontChange(Sender: TObject); virtual;
    procedure DoLblSeriesFormatChange(Sender: TObject); virtual;
    procedure DoMarkersSeriesSizeChange(Sender: TObject); virtual;
    procedure DoMarkersSeriesFillChange(Sender: TObject); virtual;
    procedure DoMarkersSeriesStrokeChange(Sender: TObject); virtual;
    procedure DoMarkersSeriesShapeChange(Sender: TObject); virtual;
    procedure DoXGridSeriesVisibilityChange(Sender: TObject); virtual;
    procedure DoXGridSeriesMajorStrokeChange(Sender: TObject); virtual;
    procedure DoXGridSeriesMinorStrokeChange(Sender: TObject); virtual;
    procedure DoXValSeriesPositionChange(Sender: TObject); virtual;
    procedure DoXValSeriesMajorTickmarkChange(Sender: TObject); virtual;
    procedure DoXValSeriesMajorFontChange(Sender: TObject); virtual;
    procedure DoXValSeriesMajorFormatChange(Sender: TObject); virtual;
    procedure DoXValSeriesMinorTickmarkChange(Sender: TObject); virtual;
    procedure DoXValSeriesMinorFontChange(Sender: TObject); virtual;
    procedure DoXValSeriesMinorFormatChange(Sender: TObject); virtual;
    procedure DoXValSeriesUnitsChange(Sender: TObject); virtual;
    procedure DoXValSeriesTitleChange(Sender: TObject); virtual;
    procedure DoXValSeriesTextMarginsChange(Sender: TObject); virtual;
    procedure DoXValSeriesTitleFontChange(Sender: TObject); virtual;
    procedure DoXValSeriesSmartLabelsChange(Sender: TObject); virtual;
    procedure DoYGridSeriesVisibilityChange(Sender: TObject); virtual;
    procedure DoYGridSeriesMajorStrokeChange(Sender: TObject); virtual;
    procedure DoYGridSeriesMinorStrokeChange(Sender: TObject); virtual;
    procedure DoYGridSeriesSpiderChange(Sender: TObject); virtual;
    procedure DoYValSeriesPositionChange(Sender: TObject); virtual;
    procedure DoYValSeriesMajorTickmarkChange(Sender: TObject); virtual;
    procedure DoYValSeriesMajorFontChange(Sender: TObject); virtual;
    procedure DoYValSeriesMajorFormatChange(Sender: TObject); virtual;
    procedure DoYValSeriesMinorTickmarkChange(Sender: TObject); virtual;
    procedure DoYValSeriesMinorFontChange(Sender: TObject); virtual;
    procedure DoYValSeriesMinorFormatChange(Sender: TObject); virtual;
    procedure DoYValSeriesUnitsChange(Sender: TObject); virtual;
    procedure DoYValSeriesTitleChange(Sender: TObject); virtual;
    procedure DoYValSeriesTextMarginsChange(Sender: TObject); virtual;
    procedure DoYValSeriesTitleFontChange(Sender: TObject); virtual;
    procedure DoYValSeriesSmartLabelsChange(Sender: TObject); virtual;
    procedure DoPieSeriesMarginsChange(Sender: TObject); virtual;
    procedure DoPieSeriesLayoutChange(Sender: TObject); virtual;

    procedure ClearSeriesEvents; virtual;

    procedure SetCharTypeSelector(AChartType: TTMSFNCChartSerieType);

    procedure DoButtonOKClick(Sender: TObject); virtual;
    procedure DoButtonCancelClick(Sender: TObject); virtual;
    procedure CreateBottomPanel(AParent: TTMSFNCChartSeriesEditorParent);
    {$IFDEF WEBLIB}
    procedure ApplyCSS(ACSS: string); virtual;
    procedure AssignBitmapCallBack(AValue: TModalResult);
    {$ENDIF}
    function GetDocURL: string; override;
    function GetTipsURL: string; override;
  public
    constructor Create(AOwner: TComponent); override;
    destructor Destroy; override;
    {$IFDEF WEBLIB}
    procedure Execute(AProc: TModalResultProc = nil);
    {$ELSE}
    function Execute: TModalResult;
    {$ENDIF}
    procedure Assign(Source: TPersistent); override;
  published
    property Chart: TTMSFNCChart read FChart write SetChart;
    property Series: TTMSFNCChartSerie read FSerie write SetSerie;
  end;

  TTMSFNCChartSeriesEditorForm = class(TTMSFNCCustomDesignerForm)
  {$IFDEF WEBLIB}
  private
    FChartEditor: TTMSFNCChartSeriesEditor;
  protected
    procedure Loaded; override;
    procedure LoadDFMValues; override;
  public
    constructor CreateDialogNew(AChartEditor: TTMSFNCChartSeriesEditor; ACaption: string); reintroduce; virtual;
  {$ENDIF}
  end;

  TTMSFNCChartSeriesEditorDialog = class(TTMSFNCChartSeriesEditor);

implementation

uses
  WEBLib.TMSFNCUtils, WEBLib.Graphics, SysUtils, WEBLib.TMSFNCEditorsTools
  {$IFDEF FMXLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF VCLLIB}
  ,VCL.Dialogs, VCL.Themes
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.Dialogs
  {$ENDIF}
  {$IFDEF LCLLIB}
  ,Dialogs
  {$ENDIF}
  {$IFDEF WEBLIB}
  ,WEBLib.WebTools
  {$ENDIF}
  {$IFNDEF FMXMOBILE}
  {$IFDEF DELPHIBERLIN}
  ,FMX.DialogService.Sync
  {$ENDIF}
  {$ENDIF}
  ;

type
  TTMSFNCChartOpen = class(TTMSFNCChart);

//{$R TMSFNCChartSeriesEditor.res}

{ TTMSFNCChartSeriesEditor }

function TranslateTextEx(AText: String): String;
begin
  {$IFDEF FMXLIB}
  Result := TranslateText(AText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Result := AText;
  {$ENDIF}
end;

procedure TTMSFNCChartSeriesEditor.Notification(AComponent: TComponent;
  AOperation: TOperation);
begin
  inherited;
  if (AOperation = opRemove) and (AComponent = FChart) then
    FChart := nil;
end;

procedure TTMSFNCChartSeriesEditor.RegisterRuntimeClasses;
begin
  inherited;
  RegisterClass(TTMSFNCChartSeriesEditor);
end;

procedure TTMSFNCChartSeriesEditor.Assign(Source: TPersistent);
begin
  if (Source is TTMSFNCChartSeriesEditor) then
    FChart := (Source as TTMSFNCChartSeriesEditor).Chart;
end;

procedure TTMSFNCChartSeriesEditor.BuildEditor(AParent: TTMSFNCChartSeriesEditorParent);
begin
  if Assigned(AParent) then
  begin
    {$IFDEF FMXLIB}
    FVertScrlBox := TVertScrollBox.Create(AParent);
    FVertScrlBox.Align := TAlignLayout.Client;
    {$ENDIF}
    {$IFDEF CMNWEBLIB}
    FVertScrlBox := TScrollBox.Create(AParent);
    FVertScrlBox.Align := alClient;
    FVertScrlBox.Top := 0;
    {$IFDEF LCLLIB}
    FVertScrlBox.HorzScrollBar.Visible:= False;
    {$ENDIF}
    {$ENDIF}
    FVertScrlBox.Parent := AParent;
    {$IFDEF CMNWEBLIB}
    FVertScrlBox.BorderStyle := bsNone;
    if IsLightTheme then
      FVertScrlBox.Color := EDITORSUBBACKCOLORLIGHT
    else
      FVertScrlBox.Color := EDITORSUBBACKCOLORDARK;
    {$ENDIF}
    {$IFNDEF VCLLIB}
    BuildSeriesSelectionPanel(AParent);
    BuildSeriesPanels(AParent);
    {$ENDIF}
    {$IFDEF VCLLIB}
    BuildSeriesPanels(AParent);
    BuildSeriesSelectionPanel(AParent);
    {$ENDIF}
    //                     Bottom Panel
    //-------------------------------------------------------

    CreateBottomPanel(AParent);

    if Assigned(FSerie) then
    begin
      FSerieIndex := FSerie.Index;
      FSeriesSelectCombo.ItemIndex := FSerieIndex;
    end;

    FillFonts;
    Initialize;
    SetAppearance;
    DoSeriesChangeTab(nil);
  end;
end;

procedure TTMSFNCChartSeriesEditor.BuildSeriesPanels(AParent: TTMSFNCChartSeriesEditorParent);
var
  lbl1, lbl2, lbl3, lbl4, lbl5, lbl6: TLabel;
begin
  FSeriesPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  FSeriesPanel.PanelPosition := eppCenter;
  {$IFDEF FMXLIB}
  FSeriesPanel.Align := TAlignLayout.Client;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesPanel.Align := alClient;
  {$ENDIF}
  FSeriesPanel.Parent := FVertScrlBox;

  FSeriesTopPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FSeriesTopPanel.Align := TAlignLayout.Top;
  FSeriesTopPanel.PanelPosition := eppTop;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesTopPanel.PanelPosition := eppTop;
  FSeriesTopPanel.Align := alTop;
  FSeriesTopPanel.Top := 0;
  {$ENDIF}
  FSeriesTopPanel.Parent := AParent;
  FSeriesTopPanel.Height := 37;

  FSeriesButtonPie:= TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonPie.Parent := FSeriesTopPanel;
  FSeriesButtonPie.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTypeProperties);
  FSeriesButtonPie.Width := 80;
  {$IFDEF FMXLIB}
  FSeriesButtonPie.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonPie.Align := alLeft;
  FSeriesButtonPie.Left := 90;
  {$IFDEF VCLLIB}
  FSeriesButtonPie.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonPie.BorderSpacing.Right := 0;
  FSeriesButtonPie.BorderSpacing.Top := 5;
  FSeriesButtonPie.BorderSpacing.Bottom := 5;
  FSeriesButtonPie.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonPie.Margins.Right := 0;
  FSeriesButtonPie.Margins.Top := 5;
  FSeriesButtonPie.Margins.Bottom := 5;
  FSeriesButtonPie.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonPie.GroupName := 'SeriesTabs';
  FSeriesButtonPie.Toggle := True;
  FSeriesButtonPie.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonYValues	:= TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonYValues.Parent := FSeriesTopPanel;
  FSeriesButtonYValues.Text := TranslateTextEx(sTMSFNCChartSeriesEditorYValues);
  FSeriesButtonYValues.Width := 55;
  {$IFDEF FMXLIB}
  FSeriesButtonYValues.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonYValues.Align := alLeft;
  FSeriesButtonYValues.Left := 90;
  {$IFDEF VCLLIB}
  FSeriesButtonYValues.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonYValues.BorderSpacing.Right := 0;
  FSeriesButtonYValues.BorderSpacing.Top := 5;
  FSeriesButtonYValues.BorderSpacing.Bottom := 5;
  FSeriesButtonYValues.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonYValues.Margins.Right := 0;
  FSeriesButtonYValues.Margins.Top := 5;
  FSeriesButtonYValues.Margins.Bottom := 5;
  FSeriesButtonYValues.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonYValues.GroupName := 'SeriesTabs';
  FSeriesButtonYValues.Toggle := True;
  FSeriesButtonYValues.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonYGrid	:= TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonYGrid.Parent := FSeriesTopPanel;
  FSeriesButtonYGrid.Text := TranslateTextEx(sTMSFNCChartSeriesEditorYGrid);
  FSeriesButtonYGrid.Width := 50;
  {$IFDEF FMXLIB}
  FSeriesButtonYGrid.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonYGrid.Align := alLeft;
  FSeriesButtonYGrid.Left := 80;
  {$IFDEF VCLLIB}
  FSeriesButtonYGrid.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonYGrid.BorderSpacing.Right := 0;
  FSeriesButtonYGrid.BorderSpacing.Top := 5;
  FSeriesButtonYGrid.BorderSpacing.Bottom := 5;
  FSeriesButtonYGrid.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonYGrid.Margins.Right := 0;
  FSeriesButtonYGrid.Margins.Top := 5;
  FSeriesButtonYGrid.Margins.Bottom := 5;
  FSeriesButtonYGrid.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonYGrid.GroupName := 'SeriesTabs';
  FSeriesButtonYGrid.Toggle := True;
  FSeriesButtonYGrid.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonXValues	:= TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonXValues.Parent := FSeriesTopPanel;
  FSeriesButtonXValues.Text := TranslateTextEx(sTMSFNCChartSeriesEditorXValues);
  FSeriesButtonXValues.Width := 55;
  {$IFDEF FMXLIB}
  FSeriesButtonXValues.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonXValues.Align := alLeft;
  FSeriesButtonXValues.Left := 90;
  {$IFDEF VCLLIB}
  FSeriesButtonXValues.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonXValues.BorderSpacing.Right := 0;
  FSeriesButtonXValues.BorderSpacing.Top := 5;
  FSeriesButtonXValues.BorderSpacing.Bottom := 5;
  FSeriesButtonXValues.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonXValues.Margins.Right := 0;
  FSeriesButtonXValues.Margins.Top := 5;
  FSeriesButtonXValues.Margins.Bottom := 5;
  FSeriesButtonXValues.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonXValues.GroupName := 'SeriesTabs';
  FSeriesButtonXValues.Toggle := True;
  FSeriesButtonXValues.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonXGrid := TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonXGrid.Parent := FSeriesTopPanel;
  FSeriesButtonXGrid.Text := TranslateTextEx(sTMSFNCChartSeriesEditorXGrid);
  FSeriesButtonXGrid.Width := 50;
  {$IFDEF FMXLIB}
  FSeriesButtonXGrid.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonXGrid.Align := alLeft;
  FSeriesButtonXGrid.Left := 80;
  {$IFDEF VCLLIB}
  FSeriesButtonXGrid.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonXGrid.BorderSpacing.Right := 0;
  FSeriesButtonXGrid.BorderSpacing.Top := 5;
  FSeriesButtonXGrid.BorderSpacing.Bottom := 5;
  FSeriesButtonXGrid.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonXGrid.Margins.Right := 0;
  FSeriesButtonXGrid.Margins.Top := 5;
  FSeriesButtonXGrid.Margins.Bottom := 5;
  FSeriesButtonXGrid.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonXGrid.GroupName := 'SeriesTabs';
  FSeriesButtonXGrid.Toggle := True;
  FSeriesButtonXGrid.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonMarkers := TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonMarkers.Parent := FSeriesTopPanel;
  FSeriesButtonMarkers.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMarkers);
  FSeriesButtonMarkers.Width := 50;
  {$IFDEF FMXLIB}
  FSeriesButtonMarkers.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonMarkers.Align := alLeft;
  FSeriesButtonMarkers.Left := 50;
  {$IFDEF VCLLIB}
  FSeriesButtonMarkers.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonMarkers.BorderSpacing.Right := 0;
  FSeriesButtonMarkers.BorderSpacing.Top := 5;
  FSeriesButtonMarkers.BorderSpacing.Bottom := 5;
  FSeriesButtonMarkers.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonMarkers.Margins.Right := 0;
  FSeriesButtonMarkers.Margins.Top := 5;
  FSeriesButtonMarkers.Margins.Bottom := 5;
  FSeriesButtonMarkers.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonMarkers.GroupName := 'SeriesTabs';
  FSeriesButtonMarkers.Toggle := True;
  FSeriesButtonMarkers.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonLabels	:= TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonLabels.Parent := FSeriesTopPanel;
  FSeriesButtonLabels.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLabels);
  FSeriesButtonLabels.Width := 40;
  {$IFDEF FMXLIB}
  FSeriesButtonLabels.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonLabels.Align := alLeft;
  FSeriesButtonLabels.Left := 40;
  {$IFDEF VCLLIB}
  FSeriesButtonLabels.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonLabels.BorderSpacing.Right := 0;
  FSeriesButtonLabels.BorderSpacing.Top := 5;
  FSeriesButtonLabels.BorderSpacing.Bottom := 5;
  FSeriesButtonLabels.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonLabels.Margins.Right := 0;
  FSeriesButtonLabels.Margins.Top := 5;
  FSeriesButtonLabels.Margins.Bottom := 5;
  FSeriesButtonLabels.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonLabels.GroupName := 'SeriesTabs';
  FSeriesButtonLabels.Toggle := True;
  FSeriesButtonLabels.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonType	:= TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonType.Parent := FSeriesTopPanel;
  FSeriesButtonType.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  FSeriesButtonType.Width := 40;
  {$IFDEF FMXLIB}
  FSeriesButtonType.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonType.Align := alLeft;
  FSeriesButtonType.Left := 30;
  {$IFDEF VCLLIB}
  FSeriesButtonType.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonType.BorderSpacing.Right := 0;
  FSeriesButtonType.BorderSpacing.Top := 5;
  FSeriesButtonType.BorderSpacing.Bottom := 5;
  FSeriesButtonType.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonType.Margins.Right := 0;
  FSeriesButtonType.Margins.Top := 5;
  FSeriesButtonType.Margins.Bottom := 5;
  FSeriesButtonType.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonType.GroupName := 'SeriesTabs';
  FSeriesButtonType.Toggle := True;
  FSeriesButtonType.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonLegend := TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonLegend.Parent := FSeriesTopPanel;
  FSeriesButtonLegend.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLegendText);
  FSeriesButtonLegend.Width := 50;
  {$IFDEF FMXLIB}
  FSeriesButtonLegend.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonLegend.Align := alLeft;
  FSeriesButtonLegend.Left := 20;
  {$IFDEF VCLLIB}
  FSeriesButtonLegend.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonLegend.BorderSpacing.Right := 0;
  FSeriesButtonLegend.BorderSpacing.Top := 5;
  FSeriesButtonLegend.BorderSpacing.Bottom := 5;
  FSeriesButtonLegend.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonLegend.Margins.Right := 0;
  FSeriesButtonLegend.Margins.Top := 5;
  FSeriesButtonLegend.Margins.Bottom := 5;
  FSeriesButtonLegend.Margins.Left := 5;
  {$ENDIF}
  FSeriesButtonLegend.GroupName := 'SeriesTabs';
  FSeriesButtonLegend.Toggle := True;
  FSeriesButtonLegend.OnButtonClick := @DoSeriesChangeTab;

  FSeriesButtonGeneral := TTMSFNCEditorButton.Create(FSeriesTopPanel);
  FSeriesButtonGeneral.Parent := FSeriesTopPanel;
  FSeriesButtonGeneral.Text := TranslateTextEx(sTMSFNCChartSeriesEditorGeneralText);
  FSeriesButtonGeneral.Width := 50;
  {$IFDEF FMXLIB}
  FSeriesButtonGeneral.Align := TAlignLayout.Left;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonGeneral.Align := alLeft;
  FSeriesButtonGeneral.Left := 10;
  {$IFDEF VCLLIB}
  FSeriesButtonGeneral.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FSeriesButtonGeneral.Margins.Right := 0;
  FSeriesButtonGeneral.Margins.Top := 5;
  FSeriesButtonGeneral.Margins.Bottom := 5;
  FSeriesButtonGeneral.Margins.Left := BIGLBLSPACE;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FSeriesButtonGeneral.BorderSpacing.Right := 0;
  FSeriesButtonGeneral.BorderSpacing.Top := 5;
  FSeriesButtonGeneral.BorderSpacing.Bottom := 5;
  FSeriesButtonGeneral.BorderSpacing.Left := BIGLBLSPACE;
  {$ENDIF}
  FSeriesButtonGeneral.Toggle := True;
  FSeriesButtonGeneral.Selected := True;
  FSeriesButtonGeneral.GroupName := 'SeriesTabs';
  FSeriesButtonGeneral.OnButtonClick := @DoSeriesChangeTab;

  //           Series General Panel
  //-----------------------------------------------

  FSeriesGeneralPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesGeneralPanel.Align := TAlignLayout.Top;
  FSeriesGeneralPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesGeneralPanel.PanelPosition := eppCenter;
  FSeriesGeneralPanel.Align := alTop;
  FSeriesGeneralPanel.Top := 0;
  {$ENDIF}
  FSeriesGeneralPanel.Height := 400;
  FSeriesGeneralPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesGeneralPanel);
  lbl1.Parent := FSeriesGeneralPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesFillCol1 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesGeneralPanel);
  FGenSeriesFillCol1.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesFillCol1.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FGenSeriesFillCol1.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesFillCol1.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FGenSeriesFillCol1);
  FGenSeriesFillCol1.Left := lbl3.Left + SMALLHORSPACE;
  FGenSeriesFillCol1.Top := lbl3.Top + (lbl3.Height - FGenSeriesFillCol1.Height) div 2;
  {$ENDIF}
  FGenSeriesFillCol1.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesGeneralPanel);
  lbl4.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FGenSeriesFillCol2 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesGeneralPanel);
  FGenSeriesFillCol2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesFillCol2.Position.X := lbl4.Position.X + SMALLHORSPACE;
  FGenSeriesFillCol2.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenSeriesFillCol2.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FGenSeriesFillCol2);
  FGenSeriesFillCol2.Left := lbl4.Left + SMALLHORSPACE;
  FGenSeriesFillCol2.Top := lbl4.Top + (lbl4.Height - FGenSeriesFillCol2.Height) div 2;;
  {$ENDIF}
  FGenSeriesFillCol2.Width := FGenSeriesFillCol1.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesFillKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesGeneralPanel);
  FGenSeriesFillKind.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesFillKind.Position.X := FGenSeriesFillCol2.Position.X;
  FGenSeriesFillKind.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesFillKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesFillKind.Left := FGenSeriesFillCol2.Left;
  FGenSeriesFillKind.Top := lbl3.Top + (lbl3.Height - FGenSeriesFillKind.Height) div 2;
  {$ENDIF}
  FGenSeriesFillKind.Items.Add('None');
  FGenSeriesFillKind.Items.Add('Solid');
  FGenSeriesFillKind.Items.Add('Gradient');
  FGenSeriesFillKind.Width := FGenSeriesFillCol1.Width;

  lbl5 := TLabel.Create(FSeriesGeneralPanel);
  lbl5.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl3.Position.X;
  lbl5.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl3.Left;
  lbl5.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FGenSeriesFillGradient := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesGeneralPanel);
  FGenSeriesFillGradient.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesFillGradient.Position.X := FGenSeriesFillKind.Position.X;
  FGenSeriesFillGradient.Position.Y := lbl5.Position.Y + (lbl5.Height - FGenSeriesFillGradient.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesFillGradient.Left := FGenSeriesFillKind.Left;
  FGenSeriesFillGradient.Top := lbl5.Top + (lbl5.Height - FGenSeriesFillGradient.Height) div 2;
  {$ENDIF}
  FGenSeriesFillGradient.Items.Add('Horizontal');
  FGenSeriesFillGradient.Items.Add('Vertical');
  FGenSeriesFillGradient.Width := LARGECONTROLWIDTH;

  {$IFDEF FMXLIB}
  lbl4 := TLabel.Create(FSeriesGeneralPanel);
  lbl4.Parent := FSeriesGeneralPanel;
  lbl4.Position.X := lbl5.Position.X;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);

  SetEditorLabelAppearance(lbl4);

  FGenSeriesFillOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesGeneralPanel);
  FGenSeriesFillOpacity.Parent := FSeriesGeneralPanel;
  FGenSeriesFillOpacity.Position.X := FGenSeriesFillKind.Position.X;
  FGenSeriesFillOpacity.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenSeriesFillOpacity.Height)/2;
  FGenSeriesFillOpacity.Width := FGenSeriesFillKind.Width;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + BIGHEIGHTSPAC + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl5.Left;
  lbl3.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesVisibleCheck := TCheckBox.Create(FSeriesGeneralPanel);
  FGenSeriesVisibleCheck.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesVisibleCheck.Position.X := FGenSeriesFillKind.Position.X;
  FGenSeriesVisibleCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesVisibleCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesVisibleCheck.Height := CHECKBOXSIZE;
  FGenSeriesVisibleCheck.Width := CHECKBOXSIZE;
  FGenSeriesVisibleCheck.Left := FGenSeriesFillKind.Left;
  FGenSeriesVisibleCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := FGenSeriesFillCol1.Position.X + FGenSeriesFillCol1.Width + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  lbl3.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := FGenSeriesFillCol1.Left + FGenSeriesFillCol1.Width + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  {$ENDIF}
  lbl3.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl3);

  lbl4 := TLabel.Create(FSeriesGeneralPanel);
  lbl4.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X + SMALLLBLSPACE;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left + SMALLLBLSPACE;
  lbl4.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FGenSeriesStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesGeneralPanel);
  FGenSeriesStrokeCol.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesStrokeCol.Position.X := lbl4.Position.X + SMALLHORSPACE;
  FGenSeriesStrokeCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenSeriesStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FGenSeriesStrokeCol);
  FGenSeriesStrokeCol.Left := lbl4.Left + SMALLHORSPACE;
  FGenSeriesStrokeCol.Top := lbl4.Top + (lbl4.Height - FGenSeriesStrokeCol.Height) div 2;
  {$ENDIF}
  FGenSeriesStrokeCol.Width := FGenSeriesFillCol1.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesGeneralPanel);
  FGenSeriesStrokeKind.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesStrokeKind.Position.X := FGenSeriesStrokeCol.Position.X;
  FGenSeriesStrokeKind.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesStrokeKind.Left := FGenSeriesStrokeCol.Left;
  FGenSeriesStrokeKind.Top := lbl3.Top + (lbl3.Height - FGenSeriesStrokeKind.Height) div 2;
  {$ENDIF}
  FGenSeriesStrokeKind.Items.Add('None');
  FGenSeriesStrokeKind.Items.Add('Solid');
  FGenSeriesStrokeKind.Items.Add('Dash');
  FGenSeriesStrokeKind.Items.Add('Dot');
  FGenSeriesStrokeKind.Items.Add('DashDot');
  FGenSeriesStrokeKind.Items.Add('DashDotDot');
  FGenSeriesStrokeKind.Width := FGenSeriesStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl4 := TLabel.Create(FSeriesGeneralPanel);
  lbl4.Parent := FSeriesGeneralPanel;
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);

  SetEditorLabelAppearance(lbl4);

  FGenSeriesStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesGeneralPanel);
  FGenSeriesStrokeOpacity.Parent := FSeriesGeneralPanel;
  FGenSeriesStrokeOpacity.Position.X := FGenSeriesStrokeKind.Position.X;
  FGenSeriesStrokeOpacity.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenSeriesStrokeOpacity.Height)/2;
  FGenSeriesStrokeOpacity.Width := FGenSeriesStrokeCol.Width;
  {$ENDIF}

  lbl6 := TLabel.Create(FSeriesGeneralPanel);
  lbl6.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl6.Position.X := lbl4.Position.X;
  lbl6.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl6.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl6.Left := lbl3.Left;
  lbl6.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl6.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl6);

  FGenSeriesStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesStrokeWidth.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesStrokeWidth.Min := 0;
  FGenSeriesStrokeWidth.DecimalDigits := 1;
  FGenSeriesStrokeWidth.Position.X := FGenSeriesStrokeKind.Position.X;
  FGenSeriesStrokeWidth.Position.Y := lbl6.Position.Y + (lbl6.Height - FGenSeriesStrokeWidth.Height)/2;
  FGenSeriesStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesStrokeWidth.MinValue := 0;
  FGenSeriesStrokeWidth.Left := FGenSeriesStrokeKind.Left;
  FGenSeriesStrokeWidth.Top := lbl6.Top + (lbl6.Height - FGenSeriesStrokeWidth.Height) div 2;
  {$ENDIF}
  FGenSeriesStrokeWidth.Width := FGenSeriesStrokeCol.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl5.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorGroup);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl5.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorGroup);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesGroup	:= TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesGroup.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesGroup.Position.X := FGenSeriesStrokeKind.Position.X;
  FGenSeriesGroup.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesGroup.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesGroup.Left := FGenSeriesStrokeKind.Left;
  FGenSeriesGroup.Top := lbl3.Top + (lbl3.Height - FGenSeriesGroup.Height) div 2;
  {$ENDIF}
  FGenSeriesGroup.Width := FGenSeriesStrokeCol.Width;

  lbl4 := TLabel.Create(FSeriesGeneralPanel);
  lbl4.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := FGenSeriesStrokeWidth.Position.X + FGenSeriesStrokeWidth.Width + 10;
  lbl4.Position.Y := lbl2.Position.Y;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditor3d);
  lbl4.StyledSettings := lbl4.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := FGenSeriesStrokeWidth.Left + FGenSeriesStrokeWidth.Width + 10;
  lbl4.Top := lbl2.Top;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditor3d);
  {$ENDIF}
  lbl4.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl4);

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorEnabled);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left + SMALLLBLSPACE;
  lbl3.Top := lbl4.Top + lbl4.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorEnabled);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesEnabledCheck := TCheckBox.Create(FSeriesGeneralPanel);
  FGenSeriesEnabledCheck.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesEnabledCheck.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FGenSeriesEnabledCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesEnabledCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesEnabledCheck.Height := CHECKBOXSIZE;
  FGenSeriesEnabledCheck.Width := CHECKBOXSIZE;
  FGenSeriesEnabledCheck.Left := lbl3.Left + SMALLHORSPACE;
  FGenSeriesEnabledCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesGeneralPanel);
  lbl4.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetX);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetX);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FGenSeriesOffsetX	:= TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesOffsetX.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesOffsetX.DecimalDigits := 1;
  FGenSeriesOffsetX.Position.X := FGenSeriesEnabledCheck.Position.X;
  FGenSeriesOffsetX.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenSeriesOffsetX.Height)/2;
  FGenSeriesOffsetX.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesOffsetX.Left := FGenSeriesEnabledCheck.Left;
  FGenSeriesOffsetX.Top := lbl4.Top + (lbl4.Height - FGenSeriesOffsetX.Height) div 2;
  {$ENDIF}
  FGenSeriesOffsetX.Width := FGenSeriesStrokeCol.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetY);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetY);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesOffsetY := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesOffsetY.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesOffsetY.DecimalDigits := 1;
  FGenSeriesOffsetY.Position.X := FGenSeriesOffsetX.Position.X;
  FGenSeriesOffsetY.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesOffsetY.Height)/2;
  FGenSeriesOffsetY.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesOffsetY.Left := FGenSeriesOffsetX.Left;
  FGenSeriesOffsetY.Top := lbl3.Top + (lbl3.Height - FGenSeriesOffsetY.Height) div 2;
  {$ENDIF}
  FGenSeriesOffsetY.Width := FGenSeriesStrokeCol.Width;

  lbl4 := TLabel.Create(FSeriesGeneralPanel);
  lbl4.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl5.Position.Y;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMode);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl5.Top;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMode);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FGenSeriesMode := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesGeneralPanel);
  FGenSeriesMode.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMode.Position.X := FGenSeriesOffsetY.Position.X;
  FGenSeriesMode.Position.Y := lbl4.Position.Y + (lbl4.Height - FGenSeriesMode.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMode.Left := FGenSeriesOffsetY.Left;
  FGenSeriesMode.Top := lbl4.Top + (lbl4.Height - FGenSeriesMode.Height) div 2;
  {$ENDIF}
  FGenSeriesMode.Items.Add('Mathematical');
  FGenSeriesMode.Items.Add('Statistical');
  FGenSeriesMode.Width := FGenSeriesStrokeCol.Width;

  lbl1 := TLabel.Create(FSeriesGeneralPanel);
  lbl1.Parent := FSeriesGeneralPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FGenSeriesMode.Position.Y + FGenSeriesMode.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorRange);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FGenSeriesVisibleCheck.Top + FGenSeriesVisibleCheck.Height + BIGHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorRange);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + BIGHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorXRange);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + BIGHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorXRange);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesXRange := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesGeneralPanel);
  FGenSeriesXRange.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesXRange.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesXRange.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesFillCol1.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesXRange.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesXRange.Top := lbl2.Top + (lbl2.Height - FGenSeriesFillCol1.Height) div 2;
  {$ENDIF}
  FGenSeriesXRange.Items.Add('Disabled');
  FGenSeriesXRange.Items.Add('Enabled');
  FGenSeriesXRange.Items.Add('Enabled Zero Based');
  FGenSeriesXRange.Items.Add('Common');
  FGenSeriesXRange.Items.Add('Common Zero Based');
  FGenSeriesXRange.Width := SERIESLARGECONTROLWIDTH + SMALLLBLSPACE;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorYRange);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorYRange);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesYRange := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesGeneralPanel);
  FGenSeriesYRange.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesYRange.Position.X := FGenSeriesXRange.Position.X;
  FGenSeriesYRange.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesFillCol2.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesYRange.Left := FGenSeriesXRange.Left;
  FGenSeriesYRange.Top := lbl3.Top + (lbl3.Height - FGenSeriesFillCol2.Height) div 2;
  {$ENDIF}
  FGenSeriesYRange.Items.Add('Disabled');
  FGenSeriesYRange.Items.Add('Enabled');
  FGenSeriesYRange.Items.Add('Enabled Zero Based');
  FGenSeriesYRange.Items.Add('Common');
  FGenSeriesYRange.Items.Add('Common Zero Based');
  FGenSeriesYRange.Width := FGenSeriesXRange.Width;

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorZRV);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left;
  lbl2.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorZRV);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesZRV  := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesZRV.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesZRV.DecimalDigits := 1;
  FGenSeriesZRV.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesZRV.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesFillCol1.Height) / 2;
  FGenSeriesZRV.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesZRV.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesZRV.Top := lbl2.Top + (lbl2.Height - FGenSeriesFillCol1.Height) div 2;
  {$ENDIF}
  FGenSeriesZRV.Width := FGenSeriesYRange.Width;

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FGenSeriesZRV.Position.X + FGenSeriesZRV.Width + MIDLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinX);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FGenSeriesZRV.Left + FGenSeriesZRV.Width + MIDLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinX);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesMinX := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMinX.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMinX.DecimalDigits := 3;
  FGenSeriesMinX.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesMinX.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesMinX.Height)/2;
  FGenSeriesMinX.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMinX.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesMinX.Top := lbl2.Top + (lbl2.Height - FGenSeriesMinX.Height) div 2;
  {$ENDIF}
  FGenSeriesMinX.Width := FGenSeriesFillCol1.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMaxX);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMaxX);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesMaxX := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMaxX.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMaxX.DecimalDigits := 3;
  FGenSeriesMaxX.Position.X := FGenSeriesMinX.Position.X;
  FGenSeriesMaxX.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesMaxX.Height)/2;
  FGenSeriesMaxX.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMaxX.Left := FGenSeriesMinX.Left;
  FGenSeriesMaxX.Top := lbl3.Top + (lbl3.Height - FGenSeriesMaxX.Height) div 2;
  {$ENDIF}
  FGenSeriesMaxX.Width := FGenSeriesMinX.Width;

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinY);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left;
  lbl2.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinY);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesMinY := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMinY.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMinY.DecimalDigits := 3;
  FGenSeriesMinY.Position.X := FGenSeriesMinX.Position.X;
  FGenSeriesMinY.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesMinY.Height)/2;
  FGenSeriesMinY.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMinY.Left := FGenSeriesMinX.Left;
  FGenSeriesMinY.Top := lbl2.Top + (lbl2.Height - FGenSeriesMinY.Height) div 2;
  {$ENDIF}
  FGenSeriesMinY.Width := FGenSeriesMinX.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMaxY);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMaxY);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesMaxY := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMaxY.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMaxY.DecimalDigits := 3;
  FGenSeriesMaxY.Position.X := FGenSeriesMinX.Position.X;
  FGenSeriesMaxY.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesMaxY.Height)/2;
  FGenSeriesMaxY.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMaxY.Left := FGenSeriesMinX.Left;
  FGenSeriesMaxY.Top := lbl3.Top + (lbl3.Height - FGenSeriesMaxY.Height) div 2;
  {$ENDIF}
  FGenSeriesMaxY.Width := FGenSeriesMinX.Width;

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FGenSeriesMaxY.Position.X + FGenSeriesMaxY.Width + MIDLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinXOffset);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FGenSeriesMaxY.Left + FGenSeriesMaxY.Width + MIDLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinXOffset);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesMinXOff := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMinXOff.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMinXOff.DecimalDigits := 3;
  FGenSeriesMinXOff.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesMinXOff.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesMinXOff.Height)/2;
  FGenSeriesMinXOff.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMinXOff.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesMinXOff.Top := lbl2.Top + (lbl2.Height - FGenSeriesMinXOff.Height) div 2;
  {$ENDIF}
  FGenSeriesMinXOff.Width := FGenSeriesMinX.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMaxXOffset);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMaxXOffset);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesMaxXOff := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMaxXOff.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMaxXOff.DecimalDigits := 3;
  FGenSeriesMaxXOff.Position.X := FGenSeriesMinXOff.Position.X;
  FGenSeriesMaxXOff.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesMaxXOff.Height)/2;
  FGenSeriesMaxXOff.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMaxXOff.Left := FGenSeriesMinXOff.Left;
  FGenSeriesMaxXOff.Top := lbl3.Top + (lbl3.Height - FGenSeriesMaxXOff.Height) div 2;
  {$ENDIF}
  FGenSeriesMaxXOff.Width := FGenSeriesMinXOff.Width;

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinYOffset);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left;
  lbl2.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinYOffset);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesMinYOff := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMinYOff.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMinYOff.DecimalDigits := 3;
  FGenSeriesMinYOff.Position.X := FGenSeriesMinXOff.Position.X;
  FGenSeriesMinYOff.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesMinYOff.Height)/2;
  FGenSeriesMinYOff.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMinYOff.Left := FGenSeriesMinXOff.Left;
  FGenSeriesMinYOff.Top := lbl2.Top + (lbl2.Height - FGenSeriesMinYOff.Height) div 2;
  {$ENDIF}
  FGenSeriesMinYOff.Width := FGenSeriesMinXOff.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMaxYOffset);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMaxYOffset);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesMaxYOff := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesMaxYOff.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesMaxYOff.DecimalDigits := 3;
  FGenSeriesMaxYOff.Position.X := FGenSeriesMinXOff.Position.X;
  FGenSeriesMaxYOff.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesMaxYOff.Height)/2;
  FGenSeriesMaxYOff.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMaxYOff.Left := FGenSeriesMinXOff.Left;
  FGenSeriesMaxYOff.Top := lbl3.Top + (lbl3.Height - FGenSeriesMaxYOff.Height) div 2;
  {$ENDIF}
  FGenSeriesMaxYOff.Width := FGenSeriesMinXOff.Width;

  lbl1 := TLabel.Create(FSeriesGeneralPanel);
  lbl1.Parent := FSeriesGeneralPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FGenSeriesMaxYOff.Position.Y + FGenSeriesMaxYOff.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAnimation);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FGenSeriesMaxYOff.Top + FGenSeriesMaxYOff.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAnimation);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesGeneralPanel);
  lbl2.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + BIGHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFactor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + BIGHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFactor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesFactor := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesGeneralPanel);
  FGenSeriesFactor.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesFactor.DecimalDigits := 3;
  FGenSeriesFactor.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesFactor.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesFactor.Height)/2;
  FGenSeriesFactor.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}

  FGenSeriesFactor.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesFactor.Top := lbl2.Top + (lbl2.Height - FGenSeriesFactor.Height) div 2;
  {$ENDIF}
  FGenSeriesFactor.Width := FGenSeriesMaxYOff.Width;

  lbl3 := TLabel.Create(FSeriesGeneralPanel);
  lbl3.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFlow);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFlow);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesFlowCheck := TCheckBox.Create(FSeriesGeneralPanel);
  FGenSeriesFlowCheck.Parent := FSeriesGeneralPanel;
  {$IFDEF FMXLIB}
  FGenSeriesFlowCheck.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FGenSeriesFlowCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesFlowCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesFlowCheck.Height := CHECKBOXSIZE;
  FGenSeriesFlowCheck.Width := CHECKBOXSIZE;
  FGenSeriesFlowCheck.Left := lbl3.Left + SMALLHORSPACE;
  FGenSeriesFlowCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FSeriesGeneralPanel.Height := FGenSeriesFlowCheck.Position.Y + FGenSeriesFlowCheck.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesGeneralPanel.Height := FGenSeriesFlowCheck.Top + FGenSeriesFlowCheck.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //           Series Legend Panel
  //-----------------------------------------------

  FSeriesLegendPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesLegendPanel.Align := TAlignLayout.Top;
  FSeriesLegendPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesLegendPanel.PanelPosition := eppCenter;
  FSeriesLegendPanel.Align := alTop;
  FSeriesLegendPanel.Top := 0;
  {$ENDIF}
  FSeriesLegendPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesLegendPanel);
  lbl1.Parent := FSeriesLegendPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesLegendPanel);
  lbl2.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLegSeriesValue := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLegendPanel);
  FLegSeriesValue.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesValue.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLegSeriesValue.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesValue.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesValue.Left := lbl3.Left + SMALLHORSPACE;
  FLegSeriesValue.Top := lbl3.Top + (lbl3.Height - FLegSeriesValue.Height) div 2;
  {$ENDIF}
  FLegSeriesValue.Items.Add('Top Left');
  FLegSeriesValue.Items.Add('Top Center');
  FLegSeriesValue.Items.Add('Top Right');
  FLegSeriesValue.Items.Add('Center Left');
  FLegSeriesValue.Items.Add('Center Center');
  FLegSeriesValue.Items.Add('Center Right');
  FLegSeriesValue.Items.Add('Bottom Left');
  FLegSeriesValue.Items.Add('Bottom Center');
  FLegSeriesValue.Items.Add('Bottom Right');
  FLegSeriesValue.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesLegendPanel);
  lbl4.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLegSeriesAppLeft := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLegendPanel);
  FLegSeriesAppLeft.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesAppLeft.DecimalDigits := 1;
  FLegSeriesAppLeft.Position.X := FLegSeriesValue.Position.X;
  FLegSeriesAppLeft.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegSeriesAppLeft.Height)/2;
  FLegSeriesAppLeft.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesAppLeft.Left := FLegSeriesValue.Left;
  FLegSeriesAppLeft.Top := lbl4.Top + (lbl4.Height - FLegSeriesAppLeft.Height) div 2;
  {$ENDIF}
  FLegSeriesAppLeft.Width := FLegSeriesValue.Width;

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLegSeriesAppTop := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLegendPanel);
  FLegSeriesAppTop.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesAppTop.DecimalDigits := 1;
  FLegSeriesAppTop.Position.X := FLegSeriesAppLeft.Position.X;
  FLegSeriesAppTop.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesAppTop.Height)/2;
  FLegSeriesAppTop.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesAppTop.Left := FLegSeriesAppLeft.Left;
  FLegSeriesAppTop.Top := lbl3.Top + (lbl3.Height - FLegSeriesAppTop.Height) div 2;
  {$ENDIF}
  FLegSeriesAppTop.Width := FLegSeriesValue.Width;

  lbl4 := TLabel.Create(FSeriesLegendPanel);
  lbl4.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLegSeriesVisibleCheck := TCheckBox.Create(FSeriesLegendPanel);
  FLegSeriesVisibleCheck.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesVisibleCheck.Position.X := FLegSeriesAppTop.Position.X;
  FLegSeriesVisibleCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegSeriesVisibleCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesVisibleCheck.Height := CHECKBOXSIZE;
  FLegSeriesVisibleCheck.Width := CHECKBOXSIZE;
  FLegSeriesVisibleCheck.Left := FLegSeriesAppTop.Left;
  FLegSeriesVisibleCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := FLegSeriesAppTop.Position.X + FLegSeriesAppTop.Width + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  lbl3.StyledSettings := lbl3.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := FLegSeriesAppTop.Left + FLegSeriesAppTop.Width + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  {$ENDIF}
  lbl3.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl3);

  lbl2 := TLabel.Create(FSeriesLegendPanel);
  lbl2.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FLegSeriesFillCol1 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLegendPanel);
  FLegSeriesFillCol1.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesFillCol1.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FLegSeriesFillCol1.Position.Y := lbl2.Position.Y + (lbl2.Height - FLegSeriesFillCol1.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLegSeriesFillCol1);
  FLegSeriesFillCol1.Left := lbl2.Left + SMALLHORSPACE;
  FLegSeriesFillCol1.Top := lbl2.Top + (lbl2.Height - FLegSeriesFillCol1.Height) div 2;
  {$ENDIF}
  FLegSeriesFillCol1.Width := FLegSeriesValue.Width;

  lbl5 := TLabel.Create(FSeriesLegendPanel);
  lbl5.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl2.Left;
  lbl5.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FLegSeriesFillCol2 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLegendPanel);
  FLegSeriesFillCol2.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesFillCol2.Position.X := FLegSeriesFillCol1.Position.X;
  FLegSeriesFillCol2.Position.Y := lbl5.Position.Y + (lbl5.Height - FLegSeriesFillCol2.Height) / 2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLegSeriesFillCol2);
  FLegSeriesFillCol2.Left := FLegSeriesFillCol1.Left;
  FLegSeriesFillCol2.Top := lbl5.Top + (lbl5.Height - FLegSeriesFillCol2.Height) div 2;
  {$ENDIF}
  FLegSeriesFillCol2.Width := FLegSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesLegendPanel);
  lbl4.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl5.Position.X;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl5.Left;
  lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLegSeriesFillKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLegendPanel);
  FLegSeriesFillKind.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesFillKind.Position.X := FLegSeriesFillCol1.Position.X;
  FLegSeriesFillKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegSeriesFillKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesFillKind.Left := FLegSeriesFillCol1.Left;
  FLegSeriesFillKind.Top := lbl4.Top + (lbl4.Height - FLegSeriesFillKind.Height) div 2;
  {$ENDIF}
  FLegSeriesFillKind.Items.Add('None');
  FLegSeriesFillKind.Items.Add('Solid');
  FLegSeriesFillKind.Items.Add('Gradient');
  FLegSeriesFillKind.Width := FLegSeriesFillCol1.Width;

  lbl5 := TLabel.Create(FSeriesLegendPanel);
  lbl5.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl4.Position.X;
  lbl5.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl4.Left;
  lbl5.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FLegSeriesFillGradient := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLegendPanel);
  FLegSeriesFillGradient.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesFillGradient.Position.X := FLegSeriesFillCol1.Position.X;
  FLegSeriesFillGradient.Position.Y := lbl5.Position.Y + (lbl5.Height - FLegSeriesFillGradient.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesFillGradient.Left := FLegSeriesFillCol1.Left;
  FLegSeriesFillGradient.Top := lbl5.Top + (lbl5.Height - FLegSeriesFillGradient.Height) div 2;
  {$ENDIF}
  FLegSeriesFillGradient.Items.Add('Horizontal');
  FLegSeriesFillGradient.Items.Add('Vertical');
  FLegSeriesFillGradient.Width := LARGECONTROLWIDTH;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesLegendPanel);
  lbl2.Parent := FSeriesLegendPanel;
  lbl2.Position.X := lbl5.Position.X;
  lbl2.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FLegSeriesFillOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesLegendPanel);
  FLegSeriesFillOpacity.Parent := FSeriesLegendPanel;
  FLegSeriesFillOpacity.Position.X := FLegSeriesFillKind.Position.X;
  FLegSeriesFillOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FLegSeriesFillOpacity.Height)/2;
  FLegSeriesFillOpacity.Width := FLegSeriesFillCol1.Width;
  {$ENDIF}

  lbl2 := TLabel.Create(FSeriesLegendPanel);
  lbl2.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FLegSeriesFillKind.Position.X + FLegSeriesFillKind.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FLegSeriesFillKind.Left + FLegSeriesFillKind.Width + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLegSeriesStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLegendPanel);
  FLegSeriesStrokeCol.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLegSeriesStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLegSeriesStrokeCol);
  FLegSeriesStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
  FLegSeriesStrokeCol.Top := lbl3.Top + (lbl3.Height - FLegSeriesStrokeCol.Height) div 2;
  {$ENDIF}
  FLegSeriesStrokeCol.Width := FLegSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesLegendPanel);
  lbl4.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLegSeriesStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLegendPanel);
  FLegSeriesStrokeKind.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesStrokeKind.Position.X := FLegSeriesStrokeCol.Position.X;
  FLegSeriesStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegSeriesStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesStrokeKind.Left := FLegSeriesStrokeCol.Left;
  FLegSeriesStrokeKind.Top := lbl4.Top + (lbl4.Height - FLegSeriesStrokeKind.Height) div 2;
  {$ENDIF}
  FLegSeriesStrokeKind.Items.Add('None');
  FLegSeriesStrokeKind.Items.Add('Solid');
  FLegSeriesStrokeKind.Items.Add('Dash');
  FLegSeriesStrokeKind.Items.Add('Dot');
  FLegSeriesStrokeKind.Items.Add('DashDot');
  FLegSeriesStrokeKind.Items.Add('DashDotDot');
  FLegSeriesStrokeKind.Width := FLegSeriesStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesLegendPanel);
  lbl2.Parent := FSeriesLegendPanel;
  lbl2.Position.X := lbl4.Position.X;
  lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FLegSeriesStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesLegendPanel);
  FLegSeriesStrokeOpacity.Parent := FSeriesLegendPanel;
  FLegSeriesStrokeOpacity.Position.X := FLegSeriesStrokeKind.Position.X;
  FLegSeriesStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FLegSeriesStrokeOpacity.Height)/2;
  FLegSeriesStrokeOpacity.Width := FLegSeriesStrokeCol.Width;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLegSeriesStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLegendPanel);
  FLegSeriesStrokeWidth.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesStrokeWidth.Min := 0;
  FLegSeriesStrokeWidth.DecimalDigits := 1;
  FLegSeriesStrokeWidth.Position.X := FLegSeriesStrokeOpacity.Position.X;
  FLegSeriesStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesStrokeWidth.Height)/2;
  FLegSeriesStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesStrokeWidth.MinValue := 0;
  FLegSeriesStrokeWidth.Left := FLegSeriesStrokeKind.Left;
  FLegSeriesStrokeWidth.Top := lbl3.Top + (lbl3.Height - FLegSeriesStrokeWidth.Height) div 2;
  {$ENDIF}
  FLegSeriesStrokeWidth.Width := FLegSeriesStrokeCol.Width;

  lbl2 := TLabel.Create(FSeriesLegendPanel);
  lbl2.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := FLegSeriesFillOpacity.Position.Y + FLegSeriesFillOpacity.Height + BIGHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := FLegSeriesFillGradient.Top + FLegSeriesFillGradient.Height + BIGHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLegSeriesFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLegendPanel);
  FLegSeriesFontName.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLegSeriesFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesFontName.Height)/2;
  FLegSeriesFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesFontName.Left := lbl3.Left + SMALLHORSPACE;
  FLegSeriesFontName.Top := lbl3.Top + (lbl3.Height - FLegSeriesFontName.Height) div 2;
  {$ENDIF}
  FLegSeriesFontName.Width := FLegSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesLegendPanel);
  lbl4.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLegSeriesFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLegendPanel);
  FLegSeriesFontCol.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesFontCol.Position.X := FLegSeriesValue.Position.X;
  FLegSeriesFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegSeriesFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLegSeriesFontCol);
  FLegSeriesFontCol.Left := FLegSeriesValue.Left;
  FLegSeriesFontCol.Top := lbl4.Top + (lbl4.Height - FLegSeriesFontCol.Height) div 2;
  {$ENDIF}
  FLegSeriesFontCol.Width := FLegSeriesFontName.Width;

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLegSeriesSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLegendPanel);
  FLegSeriesSize.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesSize.Min := 0;
  FLegSeriesSize.Position.X := FLegSeriesAppLeft.Position.X;
  FLegSeriesSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesSize.MinValue := 0;
  FLegSeriesSize.Left := FLegSeriesFontCol.Left;
  FLegSeriesSize.Top := lbl3.Top + (lbl3.Height - FLegSeriesSize.Height) div 2;
  {$ENDIF}
  FLegSeriesSize.Width := FLegSeriesFontName.Width;

  lbl3 := TLabel.Create(FSeriesLegendPanel);
  lbl3.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := FLegSeriesSize.Position.X + FLegSeriesSize.Width + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  lbl3.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := FLegSeriesSize.Left + FLegSeriesSize.Width + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  {$ENDIF}
  lbl3.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl3);

  lbl2 := TLabel.Create(FSeriesLegendPanel);
  lbl2.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FLegSeriesText := TEdit.Create(FSeriesLegendPanel);
  FLegSeriesText.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesText.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FLegSeriesText.Position.Y := lbl2.Position.Y + (lbl2.Height - FLegSeriesText.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesText.Left := lbl2.Left + SMALLHORSPACE;
  FLegSeriesText.Top := lbl2.Top + (lbl2.Height - FLegSeriesText.Height) div 2;
  {$ENDIF}
  FLegSeriesText.Width := FLegSeriesStrokeCol.Width;

  lbl4 := TLabel.Create(FSeriesLegendPanel);
  lbl4.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl2.Position.X;
  lbl4.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorShow);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl2.Left;
  lbl4.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorShow);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLegSeriesShowCheck := TCheckBox.Create(FSeriesLegendPanel);
  FLegSeriesShowCheck.Parent := FSeriesLegendPanel;
  {$IFDEF FMXLIB}
  FLegSeriesShowCheck.Position.X := FLegSeriesText.Position.X;
  FLegSeriesShowCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FLegSeriesShowCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLegSeriesShowCheck.Height := CHECKBOXSIZE;
  FLegSeriesShowCheck.Width := CHECKBOXSIZE;
  FLegSeriesShowCheck.Left := FLegSeriesText.Left;
  FLegSeriesShowCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FSeriesLegendPanel.Height := FLegSeriesShowCheck.Position.Y + FLegSeriesShowCheck.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesLegendPanel.Height := FLegSeriesShowCheck.Top + FLegSeriesShowCheck.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //             Series Type Panel
  //-----------------------------------------------

  FSeriesTypePanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesTypePanel.Align := TAlignLayout.Top;
  FSeriesTypePanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesTypePanel.PanelPosition := eppCenter;
  FSeriesTypePanel.Align := alTop;
  FSeriesTypePanel.Top := 0;
  {$ENDIF}
  FSeriesTypePanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesTypePanel);
  lbl1.Parent := FSeriesTypePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := SMALLHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLineTypes);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorLineTypes);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  FChartSelectorLine := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorLine.Parent := FSeriesTypePanel;
  FChartSelectorLine.ChartType := ctLine;
  {$IFDEF FMXLIB}
  FChartSelectorLine.Position.X := lbl1.Position.X + MIDLBLSPACE;
  FChartSelectorLine.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorLine.Left := lbl1.Left + MIDLBLSPACE;
  FChartSelectorLine.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  FChartSelectorLine.OnClick := @DoChartSelectorClick;

  FChartSelectorDigitalLine := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorDigitalLine.Parent := FSeriesTypePanel;
  FChartSelectorDigitalLine.ChartType := ctXYLine;
  {$IFDEF FMXLIB}
  FChartSelectorDigitalLine.Position.X := FChartSelectorLine.Position.X + FChartSelectorLine.Width + SMALLLBLSPACE;
  FChartSelectorDigitalLine.Position.Y := FChartSelectorLine.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorDigitalLine.Left := FChartSelectorLine.Left + FChartSelectorLine.Width + SMALLLBLSPACE;
  FChartSelectorDigitalLine.Top := FChartSelectorLine.Top;
  {$ENDIF}
  FChartSelectorDigitalLine.Width := FChartSelectorLine.Width;
  FChartSelectorDigitalLine.Height := FChartSelectorLine.Height;
  FChartSelectorDigitalLine.OnClick := @DoChartSelectorClick;

  FChartSelectorXYLine := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorXYLine.Parent := FSeriesTypePanel;
  FChartSelectorXYLine.ChartType := ctDigitalLine;
  {$IFDEF FMXLIB}
  FChartSelectorXYLine.Position.X := FChartSelectorDigitalLine.Position.X + FChartSelectorDigitalLine.Width + SMALLLBLSPACE;
  FChartSelectorXYLine.Position.Y := FChartSelectorDigitalLine.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorXYLine.Left := FChartSelectorDigitalLine.Left + FChartSelectorDigitalLine.Width + SMALLLBLSPACE;
  FChartSelectorXYLine.Top := FChartSelectorDigitalLine.Top;
  {$ENDIF}
  FChartSelectorXYLine.Width := FChartSelectorLine.Width;
  FChartSelectorXYLine.Height := FChartSelectorLine.Height;
  FChartSelectorXYLine.Tag := 1;
  FChartSelectorXYLine.OnClick := @DoChartSelectorClick;

  lbl1 := TLabel.Create(FSeriesTypePanel);
  lbl1.Parent := FSeriesTypePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FChartSelectorXYLine.Position.Y + FChartSelectorXYLine.Height + SMALLHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAreaTypes);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FChartSelectorXYLine.Top + FChartSelectorXYLine.Height + SMALLHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAreaTypes);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  FChartSelectorArea := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorArea.Parent := FSeriesTypePanel;
  FChartSelectorArea.ChartType := ctArea;
  {$IFDEF FMXLIB}
  FChartSelectorArea.Position.X := lbl1.Position.X + MIDLBLSPACE;
  FChartSelectorArea.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorArea.Left := lbl1.Left + MIDLBLSPACE;
  FChartSelectorArea.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  FChartSelectorArea.Width := FChartSelectorLine.Width;
  FChartSelectorArea.Height := FChartSelectorLine.Height;
  FChartSelectorArea.OnClick := @DoChartSelectorClick;

  FChartSelectorStackedArea := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorStackedArea.Parent := FSeriesTypePanel;
  FChartSelectorStackedArea.ChartType := ctStackedArea;
  {$IFDEF FMXLIB}
  FChartSelectorStackedArea.Position.X := FChartSelectorArea.Position.X + FChartSelectorArea.Width + SMALLLBLSPACE;
  FChartSelectorStackedArea.Position.Y := FChartSelectorArea.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorStackedArea.Left := FChartSelectorArea.Left + FChartSelectorArea.Width + SMALLLBLSPACE;
  FChartSelectorStackedArea.Top := FChartSelectorArea.Top;
  {$ENDIF}
  FChartSelectorStackedArea.Width := FChartSelectorLine.Width;
  FChartSelectorStackedArea.Height := FChartSelectorLine.Height;
  FChartSelectorStackedArea.OnClick := @DoChartSelectorClick;

  FChartSelectorStackedPercArea := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorStackedPercArea.Parent := FSeriesTypePanel;
  FChartSelectorStackedPercArea.ChartType := ctStackedPercentageArea;
  {$IFDEF FMXLIB}
  FChartSelectorStackedPercArea.Position.X := FChartSelectorStackedArea.Position.X + FChartSelectorStackedArea.Width + SMALLLBLSPACE;
  FChartSelectorStackedPercArea.Position.Y := FChartSelectorArea.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorStackedPercArea.Left := FChartSelectorStackedArea.Left + FChartSelectorStackedArea.Width + SMALLLBLSPACE;
  FChartSelectorStackedPercArea.Top := FChartSelectorArea.Top;
  {$ENDIF}
  FChartSelectorStackedPercArea.Width := FChartSelectorLine.Width;
  FChartSelectorStackedPercArea.Height := FChartSelectorLine.Height;
  FChartSelectorStackedPercArea.OnClick := @DoChartSelectorClick;

  FChartSelectorBand := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorBand.Parent := FSeriesTypePanel;
  FChartSelectorBand.ChartType := ctBand;
  {$IFDEF FMXLIB}
  FChartSelectorBand.Position.X := FChartSelectorStackedPercArea.Position.X + FChartSelectorStackedPercArea.Width + SMALLLBLSPACE;
  FChartSelectorBand.Position.Y := FChartSelectorArea.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorBand.Left := FChartSelectorStackedPercArea.Left + FChartSelectorStackedPercArea.Width + SMALLLBLSPACE;
  FChartSelectorBand.Top := FChartSelectorArea.Top;
  {$ENDIF}
  FChartSelectorBand.Width := FChartSelectorLine.Width;
  FChartSelectorBand.Height := FChartSelectorLine.Height;
  FChartSelectorBand.OnClick := @DoChartSelectorClick;

  lbl1 := TLabel.Create(FSeriesTypePanel);
  lbl1.Parent := FSeriesTypePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FChartSelectorBand.Position.Y + FChartSelectorBand.Height + SMALLHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorBarTypes);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FChartSelectorBand.Top + FChartSelectorBand.Height + SMALLHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorBarTypes);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  FChartSelectorBar := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorBar.Parent := FSeriesTypePanel;
  FChartSelectorBar.ChartType := ctBar;
  {$IFDEF FMXLIB}
  FChartSelectorBar.Position.X := lbl1.Position.X + MIDLBLSPACE;
  FChartSelectorBar.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorBar.Left := lbl1.Left + MIDLBLSPACE;
  FChartSelectorBar.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  FChartSelectorBar.Width := FChartSelectorLine.Width;
  FChartSelectorBar.Height := FChartSelectorLine.Height;
  FChartSelectorBar.OnClick := @DoChartSelectorClick;

  FChartSelectorStackedBar := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorStackedBar.Parent := FSeriesTypePanel;
  FChartSelectorStackedBar.ChartType := ctStackedBar;
  {$IFDEF FMXLIB}
  FChartSelectorStackedBar.Position.X := FChartSelectorBar.Position.X + FChartSelectorBar.Width + SMALLLBLSPACE;
  FChartSelectorStackedBar.Position.Y := FChartSelectorBar.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorStackedBar.Left := FChartSelectorBar.Left + FChartSelectorBar.Width + SMALLLBLSPACE;
  FChartSelectorStackedBar.Top := FChartSelectorBar.Top;
  {$ENDIF}
  FChartSelectorStackedBar.Width := FChartSelectorLine.Width;
  FChartSelectorStackedBar.Height := FChartSelectorLine.Height;
  FChartSelectorStackedBar.OnClick := @DoChartSelectorClick;

  FChartSelectorPercBar := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorPercBar.Parent := FSeriesTypePanel;
  FChartSelectorPercBar.ChartType := ctStackedPercentageBar;
  {$IFDEF FMXLIB}
  FChartSelectorPercBar.Position.X := FChartSelectorStackedBar.Position.X + FChartSelectorStackedBar.Width + SMALLLBLSPACE;
  FChartSelectorPercBar.Position.Y := FChartSelectorStackedBar.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorPercBar.Left := FChartSelectorStackedBar.Left + FChartSelectorStackedBar.Width + SMALLLBLSPACE;
  FChartSelectorPercBar.Top := FChartSelectorStackedBar.Top;
  {$ENDIF}
  FChartSelectorPercBar.Width := FChartSelectorLine.Width;
  FChartSelectorPercBar.Height := FChartSelectorLine.Height;
  FChartSelectorPercBar.OnClick := @DoChartSelectorClick;

  lbl1 := TLabel.Create(FSeriesTypePanel);
  lbl1.Parent := FSeriesTypePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FChartSelectorPercBar.Position.Y + FChartSelectorPercBar.Height + SMALLHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMultiPointTypes);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FChartSelectorPercBar.Top + FChartSelectorPercBar.Height + SMALLHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMultiPointTypes);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Width := 300;
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  FChartSelectorOHLC := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorOHLC.Parent := FSeriesTypePanel;
  FChartSelectorOHLC.ChartType := ctOHLC;
  {$IFDEF FMXLIB}
  FChartSelectorOHLC.Position.X := lbl1.Position.X + MIDLBLSPACE;
  FChartSelectorOHLC.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorOHLC.Left := lbl1.Left + MIDLBLSPACE;
  FChartSelectorOHLC.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  FChartSelectorOHLC.Width := FChartSelectorLine.Width;
  FChartSelectorOHLC.Height := FChartSelectorLine.Height;
  FChartSelectorOHLC.OnClick := @DoChartSelectorClick;

  FChartSelectorCandleStick := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorCandleStick.Parent := FSeriesTypePanel;
  FChartSelectorCandleStick.ChartType := ctCandleStick;
  {$IFDEF FMXLIB}
  FChartSelectorCandleStick.Position.X := FChartSelectorOHLC.Position.X + FChartSelectorOHLC.Width + SMALLLBLSPACE;
  FChartSelectorCandleStick.Position.Y := FChartSelectorOHLC.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorCandleStick.Left := FChartSelectorOHLC.Left + FChartSelectorOHLC.Width + SMALLLBLSPACE;
  FChartSelectorCandleStick.Top := FChartSelectorOHLC.Top;
  {$ENDIF}
  FChartSelectorCandleStick.Width := FChartSelectorLine.Width;
  FChartSelectorCandleStick.Height := FChartSelectorLine.Height;
  FChartSelectorCandleStick.OnClick := @DoChartSelectorClick;

  FChartSelectorBoxPlot := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorBoxPlot.Parent := FSeriesTypePanel;
  FChartSelectorBoxPlot.ChartType := ctBoxPlot;
  {$IFDEF FMXLIB}
  FChartSelectorBoxPlot.Position.X := FChartSelectorCandleStick.Position.X + FChartSelectorCandleStick.Width + SMALLLBLSPACE;
  FChartSelectorBoxPlot.Position.Y := FChartSelectorCandleStick.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorBoxPlot.Left := FChartSelectorCandleStick.Left + FChartSelectorCandleStick.Width + SMALLLBLSPACE;
  FChartSelectorBoxPlot.Top := FChartSelectorCandleStick.Top;
  {$ENDIF}
  FChartSelectorBoxPlot.Width := FChartSelectorLine.Width;
  FChartSelectorBoxPlot.Height := FChartSelectorLine.Height;
  FChartSelectorBoxPlot.OnClick := @DoChartSelectorClick;

  lbl1 := TLabel.Create(FSeriesTypePanel);
  lbl1.Parent := FSeriesTypePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FChartSelectorBoxPlot.Position.Y + FChartSelectorBoxPlot.Height + SMALLHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOtherTypes);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FChartSelectorBoxPlot.Top + FChartSelectorBoxPlot.Height + SMALLHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorOtherTypes);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Width := 300;
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  FChartSelectorMarker := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorMarker.Parent := FSeriesTypePanel;
  FChartSelectorMarker.ChartType := ctMarker;
  {$IFDEF FMXLIB}
  FChartSelectorMarker.Position.X := lbl1.Position.X + MIDLBLSPACE;
  FChartSelectorMarker.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorMarker.Left := lbl1.Left + MIDLBLSPACE;
  FChartSelectorMarker.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  FChartSelectorMarker.Width := FChartSelectorLine.Width;
  FChartSelectorMarker.Height := FChartSelectorLine.Height;
  FChartSelectorMarker.OnClick := @DoChartSelectorClick;

  FChartSelectorXYMarker := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorXYMarker.Parent := FSeriesTypePanel;
  FChartSelectorXYMarker.ChartType := ctXYMarker;
  {$IFDEF FMXLIB}
  FChartSelectorXYMarker.Position.X := FChartSelectorMarker.Position.X + FChartSelectorMarker.Width + SMALLLBLSPACE;
  FChartSelectorXYMarker.Position.Y := FChartSelectorMarker.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorXYMarker.Left := FChartSelectorMarker.Left + FChartSelectorMarker.Width + SMALLLBLSPACE;
  FChartSelectorXYMarker.Top := FChartSelectorMarker.Top;
  {$ENDIF}
  FChartSelectorXYMarker.Width := FChartSelectorLine.Width;
  FChartSelectorXYMarker.Height := FChartSelectorLine.Height;
  FChartSelectorXYMarker.OnClick := @DoChartSelectorClick;

  FChartSelectorPie := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorPie.Parent := FSeriesTypePanel;
  FChartSelectorPie.ChartType := ctPie;
  {$IFDEF FMXLIB}
  FChartSelectorPie.Position.X := FChartSelectorXYMarker.Position.X + FChartSelectorXYMarker.Width + SMALLLBLSPACE;
  FChartSelectorPie.Position.Y := FChartSelectorXYMarker.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorPie.Left := FChartSelectorXYMarker.Left + FChartSelectorXYMarker.Width + SMALLLBLSPACE;
  FChartSelectorPie.Top := FChartSelectorXYMarker.Top;
  {$ENDIF}
  FChartSelectorPie.Width := FChartSelectorLine.Width;
  FChartSelectorPie.Height := FChartSelectorLine.Height;
  FChartSelectorPie.OnClick := @DoChartSelectorClick;

  FChartSelectorSizedPie := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorSizedPie.Parent := FSeriesTypePanel;
  FChartSelectorSizedPie.ChartType := ctSizedPie;
  {$IFDEF FMXLIB}
  FChartSelectorSizedPie.Position.X := FChartSelectorPie.Position.X + FChartSelectorPie.Width + SMALLLBLSPACE;
  FChartSelectorSizedPie.Position.Y := FChartSelectorPie.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorSizedPie.Left := FChartSelectorPie.Left + FChartSelectorPie.Width + SMALLLBLSPACE;
  FChartSelectorSizedPie.Top := FChartSelectorPie.Top;
  {$ENDIF}
  FChartSelectorSizedPie.Width := FChartSelectorLine.Width;
  FChartSelectorSizedPie.Height := FChartSelectorLine.Height;
  FChartSelectorSizedPie.OnClick := @DoChartSelectorClick;

  FChartSelectorVarRadiusPie := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorVarRadiusPie.Parent := FSeriesTypePanel;
  FChartSelectorVarRadiusPie.ChartType := ctVariableRadiusPie;
  {$IFDEF FMXLIB}
  FChartSelectorVarRadiusPie.Position.X := FChartSelectorSizedPie.Position.X + FChartSelectorSizedPie.Width + SMALLLBLSPACE;
  FChartSelectorVarRadiusPie.Position.Y := FChartSelectorSizedPie.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorVarRadiusPie.Left := FChartSelectorSizedPie.Left + FChartSelectorSizedPie.Width + SMALLLBLSPACE;
  FChartSelectorVarRadiusPie.Top := FChartSelectorSizedPie.Top;
  {$ENDIF}
  FChartSelectorVarRadiusPie.Width := FChartSelectorLine.Width;
  FChartSelectorVarRadiusPie.Height := FChartSelectorLine.Height;
  FChartSelectorVarRadiusPie.OnClick := @DoChartSelectorClick;

  FChartSelectorSpider := TTMSFNCChartEditorSelector.Create(FSeriesTypePanel);
  FChartSelectorSpider.Parent := FSeriesTypePanel;
  FChartSelectorSpider.ChartType := ctSpider;
  {$IFDEF FMXLIB}
  FChartSelectorSpider.Position.X := FChartSelectorVarRadiusPie.Position.X + FChartSelectorVarRadiusPie.Width + SMALLLBLSPACE;
  FChartSelectorSpider.Position.Y := FChartSelectorVarRadiusPie.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FChartSelectorSpider.Left := FChartSelectorVarRadiusPie.Left + FChartSelectorVarRadiusPie.Width + SMALLLBLSPACE;
  FChartSelectorSpider.Top := FChartSelectorVarRadiusPie.Top;
  {$ENDIF}
  FChartSelectorSpider.Width := FChartSelectorLine.Width;
  FChartSelectorSpider.Height := FChartSelectorLine.Height;
  FChartSelectorSpider.OnClick := @DoChartSelectorClick;

  {$IFDEF FMXLIB}
  FSeriesTypePanel.Height := FChartSelectorSpider.Position.Y + FChartSelectorSpider.Height + 5;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesTypePanel.Height := FChartSelectorSpider.Top + FChartSelectorSpider.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //             Series Labels Panel
  //-----------------------------------------------

  FSeriesLabelsPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesLabelsPanel.Align := TAlignLayout.Top;
  FSeriesLabelsPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesLabelsPanel.PanelPosition := eppCenter;
  FSeriesLabelsPanel.Align := alTop;
  FSeriesLabelsPanel.Top := 0;
  {$ENDIF}
  FSeriesLabelsPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesLabelsPanel);
  lbl1.Parent := FSeriesLabelsPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesLabelsPanel);
  lbl2.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetX);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetX);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesOffsetX := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLabelsPanel);
  FLabelSeriesOffsetX.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesOffsetX.DecimalDigits := 1;
  FLabelSeriesOffsetX.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLabelSeriesOffsetX.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesOffsetX.Height)/2;
  FLabelSeriesOffsetX.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesOffsetX.Left := lbl3.Left + SMALLHORSPACE;
  FLabelSeriesOffsetX.Top := lbl3.Top + (lbl3.Height - FLabelSeriesOffsetX.Height) div 2;
  {$ENDIF}
  FLabelSeriesOffsetX.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesLabelsPanel);
  lbl4.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetY);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorOffsetY);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLabelSeriesOffsetY := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLabelsPanel);
  FLabelSeriesOffsetY.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesOffsetY.DecimalDigits := 1;
  FLabelSeriesOffsetY.Position.X := FLabelSeriesOffsetX.Position.X;
  FLabelSeriesOffsetY.Position.Y := lbl4.Position.Y + (lbl4.Height - FLabelSeriesOffsetY.Height)/2;
  FLabelSeriesOffsetY.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesOffsetY.Left := FLabelSeriesOffsetX.Left;
  FLabelSeriesOffsetY.Top := lbl4.Top + (lbl4.Height - FLabelSeriesOffsetY.Height) div 2;
  {$ENDIF}
  FLabelSeriesOffsetY.Width := FLabelSeriesOffsetX.Width;

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesVisibleCheck := TCheckBox.Create(FSeriesLabelsPanel);
  FLabelSeriesVisibleCheck.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesVisibleCheck.Position.X := FLabelSeriesOffsetY.Position.X;
  FLabelSeriesVisibleCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesVisibleCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesVisibleCheck.Height := CHECKBOXSIZE;
  FLabelSeriesVisibleCheck.Width := CHECKBOXSIZE;
  FLabelSeriesVisibleCheck.Left := FLabelSeriesOffsetY.Left;
  FLabelSeriesVisibleCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := FLabelSeriesOffsetX.Position.X + FLabelSeriesOffsetX.Width + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  lbl3.StyledSettings := lbl3.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := FLabelSeriesOffsetX.Left + FLabelSeriesOffsetX.Width + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  {$ENDIF}
  lbl3.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl3);

  lbl2 := TLabel.Create(FSeriesLabelsPanel);
  lbl2.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FLabelSeriesFillCol1 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLabelsPanel);
  FLabelSeriesFillCol1.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesFillCol1.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FLabelSeriesFillCol1.Position.Y := lbl2.Position.Y + (lbl2.Height - FLabelSeriesFillCol1.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLabelSeriesFillCol1);
  FLabelSeriesFillCol1.Left := lbl2.Left + SMALLHORSPACE;
  FLabelSeriesFillCol1.Top := lbl2.Top + (lbl2.Height - FLabelSeriesFillCol1.Height) div 2;
  {$ENDIF}
  FLabelSeriesFillCol1.Width := FLabelSeriesOffsetX.Width;

  lbl5 := TLabel.Create(FSeriesLabelsPanel);
  lbl5.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl2.Left;
  lbl5.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FLabelSeriesFillCol2 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLabelsPanel);
  FLabelSeriesFillCol2.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesFillCol2.Position.X := FLabelSeriesFillCol1.Position.X;
  FLabelSeriesFillCol2.Position.Y := lbl5.Position.Y + (lbl5.Height - FLabelSeriesFillCol2.Height) / 2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLabelSeriesFillCol2);
  FLabelSeriesFillCol2.Left := FLabelSeriesFillCol1.Left;
  FLabelSeriesFillCol2.Top := lbl5.Top + (lbl5.Height - FLabelSeriesFillCol2.Height) div 2;
  {$ENDIF}
  FLabelSeriesFillCol2.Width := FLabelSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesLabelsPanel);
  lbl4.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl5.Position.X;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl5.Left;
  lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLabelSeriesFillKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLabelsPanel);
  FLabelSeriesFillKind.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesFillKind.Position.X := FLabelSeriesFillCol1.Position.X;
  FLabelSeriesFillKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FLabelSeriesFillKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesFillKind.Left := FLabelSeriesFillCol1.Left;
  FLabelSeriesFillKind.Top := lbl4.Top + (lbl4.Height - FLabelSeriesFillKind.Height) div 2;
  {$ENDIF}
  FLabelSeriesFillKind.Items.Add('None');
  FLabelSeriesFillKind.Items.Add('Solid');
  FLabelSeriesFillKind.Items.Add('Gradient');
  FLabelSeriesFillKind.Width := FLabelSeriesFillCol1.Width;

  lbl5 := TLabel.Create(FSeriesLabelsPanel);
  lbl5.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl4.Position.X;
  lbl5.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl4.Left;
  lbl5.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FLabelSeriesFillGradient := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLabelsPanel);
  FLabelSeriesFillGradient.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesFillGradient.Position.X := FLabelSeriesFillKind.Position.X;
  FLabelSeriesFillGradient.Position.Y := lbl5.Position.Y + (lbl5.Height - FLabelSeriesFillGradient.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesFillGradient.Left := FLabelSeriesFillKind.Left;
  FLabelSeriesFillGradient.Top := lbl5.Top + (lbl5.Height - FLabelSeriesFillGradient.Height) div 2;
  {$ENDIF}
  FLabelSeriesFillGradient.Items.Add('Horizontal');
  FLabelSeriesFillGradient.Items.Add('Vertical');
  FLabelSeriesFillGradient.Width := LARGECONTROLWIDTH;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesLabelsPanel);
  lbl2.Parent := FSeriesLabelsPanel;
  lbl2.Position.X := lbl5.Position.X;
  lbl2.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FLabelSeriesFillOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesLabelsPanel);
  FLabelSeriesFillOpacity.Parent := FSeriesLabelsPanel;
  FLabelSeriesFillOpacity.Position.X := FLabelSeriesFillKind.Position.X;
  FLabelSeriesFillOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FLabelSeriesFillOpacity.Height)/2;
  FLabelSeriesFillOpacity.Width := FLabelSeriesFillCol1.Width;
  {$ENDIF}

  lbl2 := TLabel.Create(FSeriesLabelsPanel);
  lbl2.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FLabelSeriesFillKind.Position.X + FLabelSeriesFillKind.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FLabelSeriesFillKind.Left + FLabelSeriesFillKind.Width + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLabelsPanel);
  FLabelSeriesStrokeCol.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLabelSeriesStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLabelSeriesStrokeCol);
  FLabelSeriesStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
  FLabelSeriesStrokeCol.Top := lbl3.Top + (lbl3.Height - FLabelSeriesStrokeCol.Height) div 2;
  {$ENDIF}
  FLabelSeriesStrokeCol.Width := FLabelSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesLabelsPanel);
  lbl4.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLabelSeriesStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLabelsPanel);
  FLabelSeriesStrokeKind.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesStrokeKind.Position.X := FLabelSeriesStrokeCol.Position.X;
  FLabelSeriesStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FLabelSeriesStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesStrokeKind.Left := FLabelSeriesStrokeCol.Left;
  FLabelSeriesStrokeKind.Top := lbl4.Top + (lbl4.Height - FLabelSeriesStrokeKind.Height) div 2;
  {$ENDIF}
  FLabelSeriesStrokeKind.Items.Add('None');
  FLabelSeriesStrokeKind.Items.Add('Solid');
  FLabelSeriesStrokeKind.Items.Add('Dash');
  FLabelSeriesStrokeKind.Items.Add('Dot');
  FLabelSeriesStrokeKind.Items.Add('DashDot');
  FLabelSeriesStrokeKind.Items.Add('DashDotDot');
  FLabelSeriesStrokeKind.Width := FLabelSeriesStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesLabelsPanel);
  lbl2.Parent := FSeriesLabelsPanel;
  lbl2.Position.X := lbl4.Position.X;
  lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FLabelSeriesStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesLabelsPanel);
  FLabelSeriesStrokeOpacity.Parent := FSeriesLabelsPanel;
  FLabelSeriesStrokeOpacity.Position.X := FLabelSeriesStrokeKind.Position.X;
  FLabelSeriesStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FLabelSeriesStrokeOpacity.Height)/2;
  FLabelSeriesStrokeOpacity.Width := FLabelSeriesStrokeCol.Width;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLabelsPanel);
  FLabelSeriesStrokeWidth.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesStrokeWidth.Min := 0;
  FLabelSeriesStrokeWidth.DecimalDigits := 1;
  FLabelSeriesStrokeWidth.Position.X := FLabelSeriesStrokeOpacity.Position.X;
  FLabelSeriesStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesStrokeWidth.Height)/2;
  FLabelSeriesStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesStrokeWidth.MinValue := 0;
  FLabelSeriesStrokeWidth.Left := FLabelSeriesStrokeKind.Left;
  FLabelSeriesStrokeWidth.Top := lbl3.Top + (lbl3.Height - FLabelSeriesStrokeWidth.Height) div 2;
  {$ENDIF}
  FLabelSeriesStrokeWidth.Width := FLabelSeriesStrokeCol.Width;

  lbl2 := TLabel.Create(FSeriesLabelsPanel);
  lbl2.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := FLabelSeriesFillOpacity.Position.Y + FLabelSeriesFillOpacity.Height + BIGHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFormat);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := FLabelSeriesFillGradient.Top + FLabelSeriesFillGradient.Height + BIGHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFormat);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesType := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLabelsPanel);
  FLabelSeriesType.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesType.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLabelSeriesType.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesType.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesType.Left := lbl3.Left + SMALLHORSPACE;
  FLabelSeriesType.Top := lbl3.Top + (lbl3.Height - FLabelSeriesType.Height) div 2;
  {$ENDIF}
  FLabelSeriesType.Items.Add('Normal');
  FLabelSeriesType.Items.Add('Float');
  FLabelSeriesType.Items.Add('DateTime');
  FLabelSeriesType.Width := FLabelSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesLabelsPanel);
  lbl4.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMode);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMode);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLabelSeriesMode := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLabelsPanel);
  FLabelSeriesMode.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesMode.Position.X := FLabelSeriesType.Position.X;
  FLabelSeriesMode.Position.Y := lbl4.Position.Y + (lbl4.Height - FLabelSeriesMode.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesMode.Left := FLabelSeriesType.Left;
  FLabelSeriesMode.Top := lbl4.Top + (lbl4.Height - FLabelSeriesMode.Height) div 2;
  {$ENDIF}
  FLabelSeriesMode.Items.Add('Normal');
  FLabelSeriesMode.Items.Add('Stacked');
  FLabelSeriesMode.Width := FLabelSeriesType.Width;

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesText := TEdit.Create(FSeriesLabelsPanel);
  FLabelSeriesText.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesText.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLabelSeriesText.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesText.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesText.Left := lbl3.Left + SMALLHORSPACE;
  FLabelSeriesText.Top := lbl3.Top + (lbl3.Height - FLabelSeriesText.Height) div 2;
  {$ENDIF}
  FLabelSeriesText.Width := FLegSeriesStrokeCol.Width;

  lbl4 := TLabel.Create(FSeriesLabelsPanel);
  lbl4.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := FLabelSeriesText.Position.X + FLabelSeriesText.Width + SMALLLBLSPACE;
  lbl4.Position.Y := lbl2.Position.Y;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  lbl4.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := FLabelSeriesText.Left + FLabelSeriesText.Width + SMALLLBLSPACE;
  lbl4.Top := lbl2.Top;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  {$ENDIF}
  lbl4.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl4);

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left + SMALLLBLSPACE;
  lbl3.Top := lbl4.Top + lbl4.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesLabelsPanel);
  FLabelSeriesFontName.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FLabelSeriesFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesFontName.Height)/2;
  FLabelSeriesFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesFontName.Left := lbl3.Left + SMALLHORSPACE;
  FLabelSeriesFontName.Top := lbl3.Top + (lbl3.Height - FLabelSeriesFontName.Height) div 2;
  {$ENDIF}
  FLabelSeriesFontName.Width := FLabelSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesLabelsPanel);
  lbl4.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FLabelSeriesFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesLabelsPanel);
  FLabelSeriesFontCol.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesFontCol.Position.X := FLabelSeriesFontName.Position.X;
  FLabelSeriesFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FLabelSeriesFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FLabelSeriesFontCol);
  FLabelSeriesFontCol.Left := FLabelSeriesFontName.Left;
  FLabelSeriesFontCol.Top := lbl4.Top + (lbl4.Height - FLabelSeriesFontCol.Height) div 2;
  {$ENDIF}
  FLabelSeriesFontCol.Width := FLabelSeriesFontName.Width;

  lbl3 := TLabel.Create(FSeriesLabelsPanel);
  lbl3.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FLabelSeriesSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesLabelsPanel);
  FLabelSeriesSize.Parent := FSeriesLabelsPanel;
  {$IFDEF FMXLIB}
  FLabelSeriesSize.Min := 0;
  FLabelSeriesSize.Position.X := FLabelSeriesFontName.Position.X;
  FLabelSeriesSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FLabelSeriesSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FLabelSeriesSize.MinValue := 0;
  FLabelSeriesSize.Left := FLabelSeriesFontName.Left;
  FLabelSeriesSize.Top := lbl3.Top + (lbl3.Height - FLabelSeriesSize.Height) div 2;
  {$ENDIF}
  FLabelSeriesSize.Width := FLabelSeriesFontName.Width;

  {$IFDEF FMXLIB}
  FSeriesLabelsPanel.Height := FLabelSeriesSize.Position.Y + FLabelSeriesSize.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesLabelsPanel.Height := FLabelSeriesSize.Top + FLabelSeriesSize.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //             Series Markers Panel
  //-----------------------------------------------

  FSeriesMarkersPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesMarkersPanel.Align := TAlignLayout.Top;
  FSeriesMarkersPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesMarkersPanel.PanelPosition := eppCenter;
  FSeriesMarkersPanel.Align := alTop;
  FSeriesMarkersPanel.Top := 0;
  {$ENDIF}
  FSeriesMarkersPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesMarkersPanel);
  lbl1.Parent := FSeriesMarkersPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesMarkersPanel);
  lbl2.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesMarkersPanel);
  lbl3.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FMarkersSeriesWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesMarkersPanel);
  FMarkersSeriesWidth.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesWidth.DecimalDigits := 1;
  FMarkersSeriesWidth.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FMarkersSeriesWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FMarkersSeriesWidth.Height)/2;
  FMarkersSeriesWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesWidth.Left := lbl3.Left + SMALLHORSPACE;
  FMarkersSeriesWidth.Top := lbl3.Top + (lbl3.Height - FMarkersSeriesWidth.Height) div 2;
  {$ENDIF}
  FMarkersSeriesWidth.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesMarkersPanel);
  lbl4.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorHeight);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorHeight);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FMarkersSeriesHeight := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesMarkersPanel);
  FMarkersSeriesHeight.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesHeight.Min := 0;
  FMarkersSeriesHeight.DecimalDigits := 1;
  FMarkersSeriesHeight.Position.X := FMarkersSeriesWidth.Position.X;
  FMarkersSeriesHeight.Position.Y := lbl4.Position.Y + (lbl4.Height - FMarkersSeriesWidth.Height)/2;
  FMarkersSeriesHeight.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesHeight.MinValue := 0;
  FMarkersSeriesHeight.Left := FMarkersSeriesWidth.Left;
  FMarkersSeriesHeight.Top := lbl4.Top + (lbl4.Height - FMarkersSeriesWidth.Height) div 2;
  {$ENDIF}
  FMarkersSeriesHeight.Width := FMarkersSeriesWidth.Width;

  lbl3 := TLabel.Create(FSeriesMarkersPanel);
  lbl3.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FMarkersSeriesVisibleCheck := TCheckBox.Create(FSeriesMarkersPanel);
  FMarkersSeriesVisibleCheck.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesVisibleCheck.Position.X := FMarkersSeriesHeight.Position.X;
  FMarkersSeriesVisibleCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FMarkersSeriesVisibleCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesVisibleCheck.Height := CHECKBOXSIZE;
  FMarkersSeriesVisibleCheck.Width := CHECKBOXSIZE;
  FMarkersSeriesVisibleCheck.Left := FMarkersSeriesHeight.Left;
  FMarkersSeriesVisibleCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesMarkersPanel);
  lbl3.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := FMarkersSeriesHeight.Position.X + FMarkersSeriesHeight.Width + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  lbl3.StyledSettings := lbl3.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := FMarkersSeriesHeight.Left + FMarkersSeriesHeight.Width + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFill);
  {$ENDIF}
  lbl3.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl3);

  lbl2 := TLabel.Create(FSeriesMarkersPanel);
  lbl2.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FMarkersSeriesFillCol1 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesMarkersPanel);
  FMarkersSeriesFillCol1.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesFillCol1.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FMarkersSeriesFillCol1.Position.Y := lbl2.Position.Y + (lbl2.Height - FMarkersSeriesFillCol1.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FMarkersSeriesFillCol1);
  FMarkersSeriesFillCol1.Left := lbl2.Left + SMALLHORSPACE;
  FMarkersSeriesFillCol1.Top := lbl2.Top + (lbl2.Height - FMarkersSeriesFillCol1.Height) div 2;
  {$ENDIF}
  FMarkersSeriesFillCol1.Width := FMarkersSeriesWidth.Width;

  lbl5 := TLabel.Create(FSeriesMarkersPanel);
  lbl5.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl2.Left;
  lbl5.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColorTo);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FMarkersSeriesFillCol2 := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesMarkersPanel);
  FMarkersSeriesFillCol2.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesFillCol2.Position.X := FMarkersSeriesFillCol1.Position.X;
  FMarkersSeriesFillCol2.Position.Y := lbl5.Position.Y + (lbl5.Height - FMarkersSeriesFillCol2.Height) / 2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FMarkersSeriesFillCol2);
  FMarkersSeriesFillCol2.Left := FMarkersSeriesFillCol1.Left;
  FMarkersSeriesFillCol2.Top := lbl5.Top + (lbl5.Height - FMarkersSeriesFillCol2.Height) div 2;
  {$ENDIF}
  FMarkersSeriesFillCol2.Width := FMarkersSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesMarkersPanel);
  lbl4.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl5.Position.X;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl5.Left;
  lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FMarkersSeriesFillKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesMarkersPanel);
  FMarkersSeriesFillKind.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesFillKind.Position.X := FMarkersSeriesFillCol1.Position.X;
  FMarkersSeriesFillKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FMarkersSeriesFillKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesFillKind.Left := FMarkersSeriesFillCol1.Left;
  FMarkersSeriesFillKind.Top := lbl4.Top + (lbl4.Height - FMarkersSeriesFillKind.Height) div 2;
  {$ENDIF}
  FMarkersSeriesFillKind.Items.Add('None');
  FMarkersSeriesFillKind.Items.Add('Solid');
  FMarkersSeriesFillKind.Items.Add('Gradient');
  FMarkersSeriesFillKind.Width := FMarkersSeriesFillCol1.Width;

  lbl5 := TLabel.Create(FSeriesMarkersPanel);
  lbl5.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl4.Position.X;
  lbl5.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl4.Left;
  lbl5.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorGradient);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FMarkersSeriesFillGradient := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesMarkersPanel);
  FMarkersSeriesFillGradient.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesFillGradient.Position.X := FMarkersSeriesFillKind.Position.X;
  FMarkersSeriesFillGradient.Position.Y := lbl5.Position.Y + (lbl5.Height - FMarkersSeriesFillGradient.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesFillGradient.Left := FMarkersSeriesFillKind.Left;
  FMarkersSeriesFillGradient.Top := lbl5.Top + (lbl5.Height - FMarkersSeriesFillGradient.Height) div 2;
  {$ENDIF}
  FMarkersSeriesFillGradient.Items.Add('Horizontal');
  FMarkersSeriesFillGradient.Items.Add('Vertical');
  FMarkersSeriesFillGradient.Width := LARGECONTROLWIDTH;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesMarkersPanel);
  lbl2.Parent := FSeriesMarkersPanel;
  lbl2.Position.X := lbl5.Position.X;
  lbl2.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FMarkersSeriesFillOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesMarkersPanel);
  FMarkersSeriesFillOpacity.Parent := FSeriesMarkersPanel;
  FMarkersSeriesFillOpacity.Position.X := FMarkersSeriesFillKind.Position.X;
  FMarkersSeriesFillOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FMarkersSeriesFillOpacity.Height)/2;
  FMarkersSeriesFillOpacity.Width := FMarkersSeriesFillCol1.Width;
  {$ENDIF}

  lbl2 := TLabel.Create(FSeriesMarkersPanel);
  lbl2.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FMarkersSeriesFillKind.Position.X + FMarkersSeriesFillKind.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FMarkersSeriesFillKind.Left + FMarkersSeriesFillKind.Width + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorStroke);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesMarkersPanel);
  lbl3.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FMarkersSeriesStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesMarkersPanel);
  FMarkersSeriesStrokeCol.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FMarkersSeriesStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FMarkersSeriesStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FMarkersSeriesStrokeCol);
  FMarkersSeriesStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
  FMarkersSeriesStrokeCol.Top := lbl3.Top + (lbl3.Height - FMarkersSeriesStrokeCol.Height) div 2;
  {$ENDIF}
  FMarkersSeriesStrokeCol.Width := FMarkersSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesMarkersPanel);
  lbl4.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);
  FMarkersSeriesStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesMarkersPanel);
  FMarkersSeriesStrokeKind.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesStrokeKind.Position.X := FMarkersSeriesStrokeCol.Position.X;
  FMarkersSeriesStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FMarkersSeriesStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesStrokeKind.Left := FMarkersSeriesStrokeCol.Left;
  FMarkersSeriesStrokeKind.Top := lbl4.Top + (lbl4.Height - FMarkersSeriesStrokeKind.Height) div 2;
  {$ENDIF}
  FMarkersSeriesStrokeKind.Items.Add('None');
  FMarkersSeriesStrokeKind.Items.Add('Solid');
  FMarkersSeriesStrokeKind.Items.Add('Dash');
  FMarkersSeriesStrokeKind.Items.Add('Dot');
  FMarkersSeriesStrokeKind.Items.Add('DashDot');
  FMarkersSeriesStrokeKind.Items.Add('DashDotDot');
  FMarkersSeriesStrokeKind.Width := FMarkersSeriesStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesMarkersPanel);
  lbl2.Parent := FSeriesMarkersPanel;
  lbl2.Position.X := lbl4.Position.X;
  lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FMarkersSeriesStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesMarkersPanel);
  FMarkersSeriesStrokeOpacity.Parent := FSeriesMarkersPanel;
  FMarkersSeriesStrokeOpacity.Position.X := FMarkersSeriesStrokeKind.Position.X;
  FMarkersSeriesStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FMarkersSeriesStrokeOpacity.Height)/2;
  FMarkersSeriesStrokeOpacity.Width := FMarkersSeriesStrokeCol.Width;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesMarkersPanel);
  lbl3.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FMarkersSeriesStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesMarkersPanel);
  FMarkersSeriesStrokeWidth.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesStrokeWidth.Min := 0;
  FMarkersSeriesStrokeWidth.DecimalDigits := 1;
  FMarkersSeriesStrokeWidth.Position.X := FMarkersSeriesStrokeOpacity.Position.X;
  FMarkersSeriesStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FMarkersSeriesStrokeWidth.Height)/2;
  FMarkersSeriesStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesStrokeWidth.MinValue := 0;
  FMarkersSeriesStrokeWidth.Left := FMarkersSeriesStrokeKind.Left;
  FMarkersSeriesStrokeWidth.Top := lbl3.Top + (lbl3.Height - FMarkersSeriesStrokeWidth.Height) div 2;
  {$ENDIF}
  FMarkersSeriesStrokeWidth.Width := FMarkersSeriesStrokeCol.Width;

  lbl2 := TLabel.Create(FSeriesMarkersPanel);
  lbl2.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := FMarkersSeriesFillOpacity.Position.Y + FMarkersSeriesFillOpacity.Height + BIGHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorShape);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := FMarkersSeriesFillGradient.Top + FMarkersSeriesFillGradient.Height + BIGHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorShape);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesMarkersPanel);
  lbl3.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FMarkersSeriesShape := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesMarkersPanel);
  FMarkersSeriesShape.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  FMarkersSeriesShape.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FMarkersSeriesShape.Position.Y := lbl3.Position.Y + (lbl3.Height - FMarkersSeriesShape.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FMarkersSeriesShape.Left := lbl3.Left + SMALLHORSPACE;
  FMarkersSeriesShape.Top := lbl3.Top + (lbl3.Height - FMarkersSeriesShape.Height) div 2;
  {$ENDIF}
  FMarkersSeriesShape.Items.Add('Ellipse');
  FMarkersSeriesShape.Items.Add('Square');
  FMarkersSeriesShape.Items.Add('Diamond');
  FMarkersSeriesShape.Items.Add('Triangle');
  FMarkersSeriesShape.Items.Add('Bitmap');
  FMarkersSeriesShape.Items.Add('Custom');
  FMarkersSeriesShape.Width := FMarkersSeriesFillCol1.Width;

  lbl4 := TLabel.Create(FSeriesMarkersPanel);
  lbl4.Parent := FSeriesMarkersPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorBitmap);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorBitmap);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FImage := TTMSFNCCustomControl.Create(FSeriesMarkersPanel);
  FImage.Parent := FSeriesMarkersPanel;
  {$IFDEF WEBLIB}
  FImage.DisableBackground;
  {$ENDIF}
  {$IFDEF FMXLIB}
  FImage.Position.X := FMarkersSeriesShape.Position.X;
  FImage.Position.Y := lbl4.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FImage.Left := FMarkersSeriesShape.Left;
  FImage.Top := lbl4.Top;
  {$ENDIF}
  FImage.Width := FMarkersSeriesShape.Width;
  FImage.Height := FMarkersSeriesShape.Width;
  FImage.OnClick := @DoOpenFile;
  if IsLightTheme then
  begin
    FImage.Color := EDITORSUBBACKCOLORLIGHT;
  end
  else
  begin
    FImage.Color := EDITORSUBBACKCOLORDARK;
  end;

  FImage.OnAfterDraw := @DoAfterDraw;

  {$IFDEF FMXLIB}
  FSeriesMarkersPanel.Height := FImage.Position.Y + FImage.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesMarkersPanel.Height := FImage.Top + FImage.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //             Series X Grid Panel
  //-----------------------------------------------

  FSeriesXGridPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesXGridPanel.Align := TAlignLayout.Top;
  FSeriesXGridPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesXGridPanel.PanelPosition := eppCenter;
  FSeriesXGridPanel.Align := alTop;
  FSeriesXGridPanel.Top := 0;
  {$ENDIF}
  FSeriesXGridPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesXGridPanel);
  lbl1.Parent := FSeriesXGridPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesXGridPanel);
  lbl2.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisibility);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisibility);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXGridPanel);
  lbl3.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXGridSeriesVisibleCheck := TCheckBox.Create(FSeriesXGridPanel);
  FXGridSeriesVisibleCheck.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesVisibleCheck.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXGridSeriesVisibleCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FXGridSeriesVisibleCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXGridSeriesVisibleCheck.Height := CHECKBOXSIZE;
  FXGridSeriesVisibleCheck.Width := CHECKBOXSIZE;
  FXGridSeriesVisibleCheck.Left := lbl3.Left + SMALLHORSPACE;
  FXGridSeriesVisibleCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesXGridPanel);
  lbl4.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorExtended);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorExtended);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXGridSeriesExtendedCheck := TCheckBox.Create(FSeriesXGridPanel);
  FXGridSeriesExtendedCheck.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesExtendedCheck.Position.X := FMarkersSeriesVisibleCheck.Position.X;
  FXGridSeriesExtendedCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FXGridSeriesExtendedCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXGridSeriesExtendedCheck.Height := CHECKBOXSIZE;
  FXGridSeriesExtendedCheck.Width := CHECKBOXSIZE;
  FXGridSeriesExtendedCheck.Left := FMarkersSeriesVisibleCheck.Left;
  FXGridSeriesExtendedCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesXGridPanel);
  lbl3.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := FXGridSeriesExtendedCheck.Position.X + FMarkersSeriesFillKind.Width + 10;
  lbl3.Position.Y := lbl2.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorStroke);
  lbl3.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := FXGridSeriesExtendedCheck.Left + FMarkersSeriesFillKind.Width + 10;
  lbl3.Top := lbl2.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorStroke);
  {$ENDIF}
  lbl3.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl3);

  lbl2 := TLabel.Create(FSeriesXGridPanel);
  lbl2.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FXGridSeriesMajorStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesXGridPanel);
  FXGridSeriesMajorStrokeCol.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesMajorStrokeCol.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FXGridSeriesMajorStrokeCol.Position.Y := lbl2.Position.Y + (lbl2.Height - FXGridSeriesMajorStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FXGridSeriesMajorStrokeCol);
  FXGridSeriesMajorStrokeCol.Left := lbl2.Left + SMALLHORSPACE;
  FXGridSeriesMajorStrokeCol.Top := lbl2.Top + (lbl2.Height - FXGridSeriesMajorStrokeCol.Height) div 2;
  {$ENDIF}
  FXGridSeriesMajorStrokeCol.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesXGridPanel);
  lbl4.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl2.Position.X;
  lbl4.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl2.Left;
  lbl4.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXGridSeriesMajorStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXGridPanel);
  FXGridSeriesMajorStrokeKind.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesMajorStrokeKind.Position.X := FXGridSeriesMajorStrokeCol.Position.X;
  FXGridSeriesMajorStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FXGridSeriesMajorStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXGridSeriesMajorStrokeKind.Left := FXGridSeriesMajorStrokeCol.Left;
  FXGridSeriesMajorStrokeKind.Top := lbl4.Top + (lbl4.Height - FXGridSeriesMajorStrokeKind.Height) div 2;
  {$ENDIF}
  FXGridSeriesMajorStrokeKind.Items.Add('None');
  FXGridSeriesMajorStrokeKind.Items.Add('Solid');
  FXGridSeriesMajorStrokeKind.Items.Add('Dash');
  FXGridSeriesMajorStrokeKind.Items.Add('Dot');
  FXGridSeriesMajorStrokeKind.Items.Add('DashDot');
  FXGridSeriesMajorStrokeKind.Items.Add('DashDotDot');
  FXGridSeriesMajorStrokeKind.Width := FXGridSeriesMajorStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesXGridPanel);
  lbl2.Parent := FSeriesXGridPanel;
  lbl2.Position.X := lbl4.Position.X;
  lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FXGridSeriesMajorStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesXGridPanel);
  FXGridSeriesMajorStrokeOpacity.Parent := FSeriesXGridPanel;
  FXGridSeriesMajorStrokeOpacity.Position.X := FXGridSeriesMajorStrokeCol.Position.X;
  FXGridSeriesMajorStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FXGridSeriesMajorStrokeOpacity.Height)/2;
  FXGridSeriesMajorStrokeOpacity.Width := FXGridSeriesMajorStrokeKind.Width;
  {$ENDIF}

  lbl5 := TLabel.Create(FSeriesXGridPanel);
  lbl5.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl4.Left;
  lbl5.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FXGridSeriesMajorStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXGridPanel);
  FXGridSeriesMajorStrokeWidth.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesMajorStrokeWidth.Min := 0;
  FXGridSeriesMajorStrokeWidth.DecimalDigits := 1;
  FXGridSeriesMajorStrokeWidth.Position.X := FXGridSeriesMajorStrokeCol.Position.X;
  FXGridSeriesMajorStrokeWidth.Position.Y := lbl5.Position.Y + (lbl5.Height - FXGridSeriesMajorStrokeWidth.Height)/2;
  FXGridSeriesMajorStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXGridSeriesMajorStrokeWidth.MinValue := 0;
  FXGridSeriesMajorStrokeWidth.Left := FXGridSeriesMajorStrokeCol.Left;
  FXGridSeriesMajorStrokeWidth.Top := lbl5.Top + (lbl5.Height - FXGridSeriesMajorStrokeWidth.Height) div 2;
  {$ENDIF}
  FXGridSeriesMajorStrokeWidth.Width := FXGridSeriesMajorStrokeCol.Width;

  lbl2 := TLabel.Create(FSeriesXGridPanel);
  lbl2.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FXGridSeriesMajorStrokeWidth.Position.X + FXGridSeriesMajorStrokeWidth.Width + 10;
  lbl2.Position.Y := lbl3.Position.Y;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorStroke);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FXGridSeriesMajorStrokeWidth.Left + FXGridSeriesMajorStrokeWidth.Width + 10;
  lbl2.Top := lbl3.Top;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorStroke);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXGridPanel);
  lbl3.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXGridSeriesMinorStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesXGridPanel);
  FXGridSeriesMinorStrokeCol.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesMinorStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXGridSeriesMinorStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FXGridSeriesMinorStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FXGridSeriesMinorStrokeCol);
  FXGridSeriesMinorStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
  FXGridSeriesMinorStrokeCol.Top := lbl3.Top + (lbl3.Height - FXGridSeriesMinorStrokeCol.Height) div 2;
  {$ENDIF}
  FXGridSeriesMinorStrokeCol.Width := FXGridSeriesMajorStrokeCol.Width;

  lbl4 := TLabel.Create(FSeriesXGridPanel);
  lbl4.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXGridSeriesMinorStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXGridPanel);
  FXGridSeriesMinorStrokeKind.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesMinorStrokeKind.Position.X := FMarkersSeriesStrokeCol.Position.X;
  FXGridSeriesMinorStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FXGridSeriesMinorStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXGridSeriesMinorStrokeKind.Left := FMarkersSeriesStrokeCol.Left;
  FXGridSeriesMinorStrokeKind.Top := lbl4.Top + (lbl4.Height - FXGridSeriesMinorStrokeKind.Height) div 2;
  {$ENDIF}
  FXGridSeriesMinorStrokeKind.Items.Add('None');
  FXGridSeriesMinorStrokeKind.Items.Add('Solid');
  FXGridSeriesMinorStrokeKind.Items.Add('Dash');
  FXGridSeriesMinorStrokeKind.Items.Add('Dot');
  FXGridSeriesMinorStrokeKind.Items.Add('DashDot');
  FXGridSeriesMinorStrokeKind.Items.Add('DashDotDot');
  FXGridSeriesMinorStrokeKind.Width := FXGridSeriesMinorStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesXGridPanel);
  lbl2.Parent := FSeriesXGridPanel;
  lbl2.Position.X := lbl4.Position.X;
  lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FXGridSeriesMinorStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesXGridPanel);
  FXGridSeriesMinorStrokeOpacity.Parent := FSeriesXGridPanel;
  FXGridSeriesMinorStrokeOpacity.Position.X := FMarkersSeriesStrokeKind.Position.X;
  FXGridSeriesMinorStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FXGridSeriesMinorStrokeOpacity.Height)/2;
  FXGridSeriesMinorStrokeOpacity.Width := FMarkersSeriesStrokeCol.Width;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesXGridPanel);
  lbl3.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXGridSeriesMinorStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXGridPanel);
  FXGridSeriesMinorStrokeWidth.Parent := FSeriesXGridPanel;
  {$IFDEF FMXLIB}
  FXGridSeriesMinorStrokeWidth.Min := 0;
  FXGridSeriesMinorStrokeWidth.DecimalDigits := 1;
  FXGridSeriesMinorStrokeWidth.Position.X := FMarkersSeriesStrokeOpacity.Position.X;
  FXGridSeriesMinorStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FXGridSeriesMinorStrokeWidth.Height)/2;
  FXGridSeriesMinorStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXGridSeriesMinorStrokeWidth.MinValue := 0;
  FXGridSeriesMinorStrokeWidth.Left := FMarkersSeriesStrokeKind.Left;
  FXGridSeriesMinorStrokeWidth.Top := lbl3.Top + (lbl3.Height - FXGridSeriesMinorStrokeWidth.Height) div 2;
  {$ENDIF}
  FXGridSeriesMinorStrokeWidth.Width := FXGridSeriesMinorStrokeKind.Width;

  {$IFDEF FMXLIB}
  FSeriesXGridPanel.Height := FXGridSeriesMinorStrokeWidth.Position.Y + FXGridSeriesMinorStrokeWidth.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesXGridPanel.Height := FXGridSeriesMinorStrokeWidth.Top + FXGridSeriesMinorStrokeWidth.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //             Series X Values Panel
  //-----------------------------------------------

  FSeriesXValuesPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesXValuesPanel.Align := TAlignLayout.Top;
  FSeriesXValuesPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesXValuesPanel.PanelPosition := eppCenter;
  FSeriesXValuesPanel.Align := alTop;
  FSeriesXValuesPanel.Top := 0;
  {$ENDIF}
  FSeriesXValuesPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesXValuesPanel);
  lbl1.Parent := FSeriesXValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesTopCheck := TCheckBox.Create(FSeriesXValuesPanel);
  FXValSeriesTopCheck.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTopCheck.Position.X := lbl3.Position.X + BIGHORSPACE;
  FXValSeriesTopCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTopCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTopCheck.Height := CHECKBOXSIZE;
  FXValSeriesTopCheck.Width := CHECKBOXSIZE;
  FXValSeriesTopCheck.Left := lbl3.Left + BIGHORSPACE;
  FXValSeriesTopCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorCenter);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorCenter);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesCenterCheck := TCheckBox.Create(FSeriesXValuesPanel);
  FXValSeriesCenterCheck.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesCenterCheck.Position.X := FXValSeriesTopCheck.Position.X;
  FXValSeriesCenterCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesCenterCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesCenterCheck.Height := CHECKBOXSIZE;
  FXValSeriesCenterCheck.Width := CHECKBOXSIZE;
  FXValSeriesCenterCheck.Left := FXValSeriesTopCheck.Left;
  FXValSeriesCenterCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesBottomCheck := TCheckBox.Create(FSeriesXValuesPanel);
  FXValSeriesBottomCheck.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesBottomCheck.Position.X := FXValSeriesTopCheck.Position.X;
  FXValSeriesBottomCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesBottomCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesBottomCheck.Height := CHECKBOXSIZE;
  FXValSeriesBottomCheck.Width := CHECKBOXSIZE;
  FXValSeriesBottomCheck.Left := FXValSeriesTopCheck.Left;
  FXValSeriesBottomCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAngle);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAngle);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesAngle := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesAngle.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesAngle.Max := 180;
  FXValSeriesAngle.Min := -180;
  FXValSeriesAngle.Position.X := FXValSeriesBottomCheck.Position.X;
  FXValSeriesAngle.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesAngle.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesAngle.MaxValue := 180;
  FXValSeriesAngle.MinValue := -180;
  FXValSeriesAngle.Left := FXValSeriesBottomCheck.Left;
  FXValSeriesAngle.Top := lbl4.Top + (lbl4.Height - FXValSeriesAngle.Height) div 2;
  {$ENDIF}
  FXValSeriesAngle.Width := SERIESLARGECONTROLWIDTH;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorSpacing);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorSpacing);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMajSpacing := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMajSpacing.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajSpacing.DecimalDigits := 1;
  FXValSeriesMajSpacing.Position.X := FXValSeriesAngle.Position.X;
  FXValSeriesMajSpacing.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesMajSpacing.Height)/2;
  FXValSeriesMajSpacing.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMajSpacing.Left := FXValSeriesAngle.Left;
  FXValSeriesMajSpacing.Top := lbl3.Top + (lbl3.Height - FXValSeriesMajSpacing.Height) div 2;
  {$ENDIF}
  FXValSeriesMajSpacing.Width := FXValSeriesAngle.Width;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorSpacing);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorSpacing);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesMinSpacing := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMinSpacing.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinSpacing.DecimalDigits := 1;
  FXValSeriesMinSpacing.Position.X := FXValSeriesMajSpacing.Position.X;
  FXValSeriesMinSpacing.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesMajSpacing.Height)/2;
  FXValSeriesMinSpacing.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMinSpacing.Left := FXValSeriesMajSpacing.Left;
  FXValSeriesMinSpacing.Top := lbl4.Top + (lbl4.Height - FXValSeriesMajSpacing.Height) div 2;
  {$ENDIF}
  FXValSeriesMinSpacing.Width := FXValSeriesMajSpacing.Width;

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FXValSeriesMinSpacing.Position.X + FXValSeriesMinSpacing.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFont);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FXValSeriesMinSpacing.Left + FXValSeriesMinSpacing.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFont);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMajFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXValuesPanel);
  FXValSeriesMajFontName.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXValSeriesMajFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesMajFontName.Height)/2;
  FXValSeriesMajFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMajFontName.Left := lbl3.Left + SMALLHORSPACE;
  FXValSeriesMajFontName.Top := lbl3.Top + (lbl3.Height - FXValSeriesMajFontName.Height) div 2;
  {$ENDIF}
  FXValSeriesMajFontName.Width := FXValSeriesAngle.Width;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesMajFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesXValuesPanel);
  FXValSeriesMajFontCol.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajFontCol.Position.X := FXValSeriesMajFontName.Position.X;
  FXValSeriesMajFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesMajFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FXValSeriesMajFontCol);
  FXValSeriesMajFontCol.Left := FXValSeriesMajFontName.Left;
  FXValSeriesMajFontCol.Top := lbl4.Top + (lbl4.Height - FXValSeriesMajFontCol.Height) div 2;
  {$ENDIF}
  FXValSeriesMajFontCol.Width := FXValSeriesAngle.Width;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMajFontSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMajFontSize.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajFontSize.Min := 0;
  FXValSeriesMajFontSize.Position.X := FXValSeriesMajFontName.Position.X;
  FXValSeriesMajFontSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMajFontSize.MinValue := 0;
  FXValSeriesMajFontSize.Left := FXValSeriesMajFontName.Left;
  FXValSeriesMajFontSize.Top := lbl3.Top + (lbl3.Height - FLegSeriesSize.Height) div 2;
  {$ENDIF}
  FXValSeriesMajFontSize.Width := FXValSeriesMajFontName.Width;

  lbl5 := TLabel.Create(FSeriesXValuesPanel);
  lbl5.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := FXValSeriesMajFontSize.Position.Y + FXValSeriesMajFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorTickmark);
  lbl5.StyledSettings := lbl5.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl2.Left;
  lbl5.Top := FXValSeriesMajFontSize.Top + FXValSeriesMajFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorTickmark);
  {$ENDIF}
  lbl5.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl5);

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl5.Position.X + SMALLLBLSPACE;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl5.Left + SMALLLBLSPACE;
  lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesMajTickCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesXValuesPanel);
  FXValSeriesMajTickCol.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajTickCol.Position.X := FXValSeriesMajFontName.Position.X;
  FXValSeriesMajTickCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesMajTickCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FXValSeriesMajTickCol);
  FXValSeriesMajTickCol.Left := FXValSeriesMajFontName.Left;
  FXValSeriesMajTickCol.Top := lbl4.Top + (lbl4.Height - FXValSeriesMajTickCol.Height) div 2;
  {$ENDIF}
  FXValSeriesMajTickCol.Width := FXValSeriesAngle.Width;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMajTickSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMajTickSize.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajTickSize.Min := 0;
  FXValSeriesMajTickSize.Position.X := FXValSeriesMajFontName.Position.X;
  FXValSeriesMajTickSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesMajTickSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMajTickSize.MinValue := 0;
  FXValSeriesMajTickSize.Left := FXValSeriesMajFontName.Left;
  FXValSeriesMajTickSize.Top := lbl3.Top + (lbl3.Height - FXValSeriesMajTickSize.Height) div 2;
  {$ENDIF}
  FXValSeriesMajTickSize.Width := FXValSeriesMajTickCol.Width;

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FXValSeriesMajFontSize.Position.X + FXValSeriesMajFontSize.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFont);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FXValSeriesMajFontSize.Left + FXValSeriesMajFontSize.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFont);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMinFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXValuesPanel);
  FXValSeriesMinFontName.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXValSeriesMinFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesMinFontName.Height)/2;
  FXValSeriesMinFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMinFontName.Left := lbl3.Left + SMALLHORSPACE;
  FXValSeriesMinFontName.Top := lbl3.Top + (lbl3.Height - FXValSeriesMinFontName.Height) div 2;
  {$ENDIF}
  FXValSeriesMinFontName.Width := FXValSeriesAngle.Width;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesMinFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesXValuesPanel);
  FXValSeriesMinFontCol.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinFontCol.Position.X := FXValSeriesMinFontName.Position.X;
  FXValSeriesMinFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesMinFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FXValSeriesMinFontCol);
  FXValSeriesMinFontCol.Left := FXValSeriesMinFontName.Left;
  FXValSeriesMinFontCol.Top := lbl4.Top + (lbl4.Height - FXValSeriesMinFontCol.Height) div 2;
  {$ENDIF}
  FXValSeriesMinFontCol.Width := FXValSeriesAngle.Width;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMinFontSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMinFontSize.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinFontSize.Min := 0;
  FXValSeriesMinFontSize.Position.X := FXValSeriesMinFontName.Position.X;
  FXValSeriesMinFontSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMinFontSize.MinValue := 0;
  FXValSeriesMinFontSize.Left := FXValSeriesMinFontName.Left;
  FXValSeriesMinFontSize.Top := lbl3.Top + (lbl3.Height - FLegSeriesSize.Height) div 2;
  {$ENDIF}
  FXValSeriesMinFontSize.Width := FXValSeriesMinFontName.Width;

  lbl5 := TLabel.Create(FSeriesXValuesPanel);
  lbl5.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := FXValSeriesMinFontSize.Position.Y + FXValSeriesMinFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorTickmark);
  lbl5.StyledSettings := lbl5.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl2.Left;
  lbl5.Top := FXValSeriesMinFontSize.Top + FXValSeriesMinFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorTickmark);
  {$ENDIF}
  lbl5.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl5);

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl5.Position.X + SMALLLBLSPACE;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl5.Left + SMALLLBLSPACE;
  lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesMinTickCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesXValuesPanel);
  FXValSeriesMinTickCol.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinTickCol.Position.X := FXValSeriesMinFontName.Position.X;
  FXValSeriesMinTickCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesMinTickCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FXValSeriesMinTickCol);
  FXValSeriesMinTickCol.Left := FXValSeriesMinFontName.Left;
  FXValSeriesMinTickCol.Top := lbl4.Top + (lbl4.Height - FXValSeriesMinTickCol.Height) div 2;
  {$ENDIF}
  FXValSeriesMinTickCol.Width := FXValSeriesAngle.Width;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMinTickSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMinTickSize.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinTickSize.Min := 0;
  FXValSeriesMinTickSize.Position.X := FXValSeriesMinFontName.Position.X;
  FXValSeriesMinTickSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesMinTickSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMinTickSize.MinValue := 0;
  FXValSeriesMinTickSize.Left := FXValSeriesMinFontName.Left;
  FXValSeriesMinTickSize.Top := lbl3.Top + (lbl3.Height - FXValSeriesMinTickSize.Height) div 2;
  {$ENDIF}
  FXValSeriesMinTickSize.Width := FXValSeriesMinTickCol.Width;

  lbl1 := TLabel.Create(FSeriesXValuesPanel);
  lbl1.Parent := FSeriesXValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FXValSeriesMinSpacing.Position.Y + FXValSeriesMinSpacing.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValues);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FXValSeriesMinSpacing.Top + FXValSeriesMinSpacing.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValues);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + BIGHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorUnits);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + BIGHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorUnits);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAuto);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAuto);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesAutoCheck := TCheckBox.Create(FSeriesXValuesPanel);
  FXValSeriesAutoCheck.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesAutoCheck.Position.X := lbl3.Position.X + BIGHORSPACE;
  FXValSeriesAutoCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTopCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesAutoCheck.Height := CHECKBOXSIZE;
  FXValSeriesAutoCheck.Width := CHECKBOXSIZE;
  FXValSeriesAutoCheck.Left := lbl3.Left + BIGHORSPACE;
  FXValSeriesAutoCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesUnitMajor := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesUnitMajor.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesUnitMajor.DecimalDigits := 3;
  FXValSeriesUnitMajor.Position.X := FXValSeriesMajSpacing.Position.X;
  FXValSeriesUnitMajor.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesUnitMajor.Height)/2;
  FXValSeriesUnitMajor.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesUnitMajor.Left := FXValSeriesMajSpacing.Left;
  FXValSeriesUnitMajor.Top := lbl4.Top + (lbl4.Height - FXValSeriesUnitMajor.Height) div 2;
  {$ENDIF}
  FXValSeriesUnitMajor.Width := FXValSeriesMajSpacing.Width;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesUnitMinor := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesUnitMinor.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesUnitMinor.DecimalDigits := 3;
  FXValSeriesUnitMinor.Position.X := FXValSeriesAngle.Position.X;
  FXValSeriesUnitMinor.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesUnitMinor.Height)/2;
  FXValSeriesUnitMinor.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesUnitMinor.Left := FXValSeriesAngle.Left;
  FXValSeriesUnitMinor.Top := lbl3.Top + (lbl3.Height - FXValSeriesUnitMinor.Height) div 2;
  {$ENDIF}
  FXValSeriesUnitMinor.Width := FXValSeriesUnitMajor.Width;

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FXValSeriesUnitMinor.Position.X + FXValSeriesUnitMinor.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFormat);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FXValSeriesUnitMinor.Left + FXValSeriesUnitMinor.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFormat);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMajFormatType := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXValuesPanel);
  FXValSeriesMajFormatType.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajFormatType.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXValSeriesMajFormatType.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesMajFormatType.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMajFormatType.Left := lbl3.Left + SMALLHORSPACE;
  FXValSeriesMajFormatType.Top := lbl3.Top + (lbl3.Height - FXValSeriesMajFormatType.Height) div 2;
  {$ENDIF}
  FXValSeriesMajFormatType.Items.Add('Normal');
  FXValSeriesMajFormatType.Items.Add('Float');
  FXValSeriesMajFormatType.Items.Add('DateTime');
  FXValSeriesMajFormatType.Width := FXValSeriesUnitMinor.Width;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesMajFormatValue := TEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMajFormatValue.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMajFormatValue.Position.X := FXValSeriesMajFormatType.Position.X;
  FXValSeriesMajFormatValue.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesMajFormatValue.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMajFormatValue.Left := FXValSeriesMajFormatType.Left;
  FXValSeriesMajFormatValue.Top := lbl4.Top + (lbl4.Height - FXValSeriesMajFormatValue.Height) div 2;
  {$ENDIF}
  FXValSeriesMajFormatValue.Width := FXValSeriesMajFormatType.Width;

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FXValSeriesMajFormatValue.Position.X + FXValSeriesMajFormatValue.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFormat);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FXValSeriesMajFormatValue.Left + FXValSeriesMajFormatValue.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFormat);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesMinFormatType := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXValuesPanel);
  FXValSeriesMinFormatType.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinFormatType.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXValSeriesMinFormatType.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesMinFormatType.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMinFormatType.Left := lbl3.Left + SMALLHORSPACE;
  FXValSeriesMinFormatType.Top := lbl3.Top + (lbl3.Height - FXValSeriesMinFormatType.Height) div 2;
  {$ENDIF}
  FXValSeriesMinFormatType.Items.Add('Normal');
  FXValSeriesMinFormatType.Items.Add('Float');
  FXValSeriesMinFormatType.Items.Add('DateTime');
  FXValSeriesMinFormatType.Width := FXValSeriesUnitMinor.Width;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesMinFormatValue := TEdit.Create(FSeriesXValuesPanel);
  FXValSeriesMinFormatValue.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesMinFormatValue.Position.X := FXValSeriesMinFormatType.Position.X;
  FXValSeriesMinFormatValue.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesMinFormatValue.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesMinFormatValue.Left := FXValSeriesMinFormatType.Left;
  FXValSeriesMinFormatValue.Top := lbl4.Top + (lbl4.Height - FXValSeriesMinFormatValue.Height) div 2;
  {$ENDIF}
  FXValSeriesMinFormatValue.Width := FXValSeriesMinFormatType.Width;

  lbl1 := TLabel.Create(FSeriesXValuesPanel);
  lbl1.Parent := FSeriesXValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FXValSeriesUnitMinor.Position.Y + FXValSeriesUnitMinor.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTitleText);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FXValSeriesUnitMinor.Top + FXValSeriesUnitMinor.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTitleText);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesTitleValue := TEdit.Create(FSeriesXValuesPanel);
  FXValSeriesTitleValue.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTitleValue.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXValSeriesTitleValue.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTitleValue.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTitleValue.Left := lbl3.Left + SMALLHORSPACE;
  FXValSeriesTitleValue.Top := lbl3.Top + (lbl3.Height - FXValSeriesTitleValue.Height) div 2;
  {$ENDIF}
  FXValSeriesTitleValue.Width := FXValSeriesMinFormatType.Width;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorHAlign);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorHAlign);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesTitleHAlign := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXValuesPanel);
  FXValSeriesTitleHAlign.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTitleHAlign.Position.X := FXValSeriesTitleValue.Position.X;
  FXValSeriesTitleHAlign.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesTitleHAlign.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTitleHAlign.Left := FXValSeriesTitleValue.Left;
  FXValSeriesTitleHAlign.Top := lbl4.Top + (lbl4.Height - FXValSeriesTitleHAlign.Height) div 2;
  {$ENDIF}
  FXValSeriesTitleHAlign.Items.Add('Center');
  FXValSeriesTitleHAlign.Items.Add('Left');
  FXValSeriesTitleHAlign.Items.Add('Right');
  FXValSeriesTitleHAlign.Width := FXValSeriesTitleValue.Width;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVAlign);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVAlign);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesTitleVAlign := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXValuesPanel);
  FXValSeriesTitleVAlign.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTitleVAlign.Position.X := FXValSeriesTitleHAlign.Position.X;
  FXValSeriesTitleVAlign.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTitleVAlign.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTitleVAlign.Left := FXValSeriesTitleHAlign.Left;
  FXValSeriesTitleVAlign.Top := lbl3.Top + (lbl3.Height - FXValSeriesTitleVAlign.Height) div 2;
  {$ENDIF}
  FXValSeriesTitleVAlign.Items.Add('Center');
  FXValSeriesTitleVAlign.Items.Add('Top');
  FXValSeriesTitleVAlign.Items.Add('Bottom');
  FXValSeriesTitleVAlign.Width := FXValSeriesTitleHAlign.Width;

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FXValSeriesTitleVAlign.Position.X + FXValSeriesTitleVAlign.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTextMargins);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FXValSeriesTitleVAlign.Left + FXValSeriesTitleVAlign.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTextMargins);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + MIDLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesTextLeft := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesTextLeft.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTextLeft.DecimalDigits := 1;
  FXValSeriesTextLeft.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXValSeriesTextLeft.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTextLeft.Height)/2;
  FXValSeriesTextLeft.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTextLeft.Left := lbl3.Left + SMALLHORSPACE;
  FXValSeriesTextLeft.Top := lbl3.Top + (lbl3.Height - FXValSeriesTextLeft.Height) div 2;
  {$ENDIF}
  FXValSeriesTextLeft.Width := LARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesTextTop := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesTextTop.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTextTop.DecimalDigits := 1;
  FXValSeriesTextTop.Position.X := FXValSeriesTextLeft.Position.X;
  FXValSeriesTextTop.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesTextTop.Height)/2;
  FXValSeriesTextTop.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTextTop.Left := FXValSeriesTextLeft.Left;
  FXValSeriesTextTop.Top := lbl4.Top + (lbl4.Height - FXValSeriesTextTop.Height) div 2;
  {$ENDIF}
  FXValSeriesTextTop.Width := LARGECONTROLWIDTH;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesTextRight := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesTextRight.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTextRight.DecimalDigits := 1;
  FXValSeriesTextRight.Position.X := FXValSeriesTextLeft.Position.X;
  FXValSeriesTextRight.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTextRight.Height)/2;
  FXValSeriesTextRight.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTextRight.Left := FXValSeriesTextLeft.Left;
  FXValSeriesTextRight.Top := lbl3.Top + (lbl3.Height - FXValSeriesTextRight.Height) div 2;
  {$ENDIF}
  FXValSeriesTextRight.Width := LARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesTextBottom := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesTextBottom.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTextBottom.DecimalDigits := 1;
  FXValSeriesTextBottom.Position.X := FXValSeriesTextLeft.Position.X;
  FXValSeriesTextBottom.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesTextBottom.Height)/2;
  FXValSeriesTextBottom.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTextBottom.Left := FXValSeriesTextLeft.Left;
  FXValSeriesTextBottom.Top := lbl4.Top + (lbl4.Height - FXValSeriesTextBottom.Height) div 2;
  {$ENDIF}
  FXValSeriesTextBottom.Width := LARGECONTROLWIDTH;

  lbl2 := TLabel.Create(FSeriesXValuesPanel);
  lbl2.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FXValSeriesTextBottom.Position.X + FXValSeriesTextBottom.Width + 10;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FXValSeriesTextBottom.Left + FXValSeriesTextBottom.Width + 10;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesTitleFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesXValuesPanel);
  FXValSeriesTitleFontName.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTitleFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FXValSeriesTitleFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTitleFontName.Height)/2;
  FXValSeriesTitleFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTitleFontName.Left := lbl3.Left + SMALLHORSPACE;
  FXValSeriesTitleFontName.Top := lbl3.Top + (lbl3.Height - FXValSeriesTitleFontName.Height) div 2;
  {$ENDIF}
  FXValSeriesTitleFontName.Width := FXValSeriesTextBottom.Width;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesTitleFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesXValuesPanel);
  FXValSeriesTitleFontCol.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTitleFontCol.Position.X := FXValSeriesTitleFontName.Position.X;
  FXValSeriesTitleFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesTitleFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FXValSeriesTitleFontCol);
  FXValSeriesTitleFontCol.Left := FXValSeriesTitleFontName.Left;
  FXValSeriesTitleFontCol.Top := lbl4.Top + (lbl4.Height - FXValSeriesTitleFontCol.Height) div 2;
  {$ENDIF}
  FXValSeriesTitleFontCol.Width := FXValSeriesTitleFontName.Width;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesTitleFontSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesTitleFontSize.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesTitleFontSize.Min := 0;
  FXValSeriesTitleFontSize.Position.X := FXValSeriesTitleFontName.Position.X;
  FXValSeriesTitleFontSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesTitleFontSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesTitleFontSize.MinValue := 0;
  FXValSeriesTitleFontSize.Left := FXValSeriesTitleFontName.Left;
  FXValSeriesTitleFontSize.Top := lbl3.Top + (lbl3.Height - FXValSeriesTitleFontSize.Height) div 2;
  {$ENDIF}
  FXValSeriesTitleFontSize.Width := FXValSeriesTitleFontName.Width;

  // SmartLabels section
  lbl1 := TLabel.Create(FSeriesXValuesPanel);
  lbl1.Parent := FSeriesXValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FXValSeriesTextBottom.Position.Y + FXValSeriesTextBottom.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartLabels);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FXValSeriesTextBottom.Top + FXValSeriesTextBottom.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartLabels);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartEnabled);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl1.Left + SMALLLBLSPACE;
  lbl3.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartEnabled);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesSmartEnabledCheck := TCheckBox.Create(FSeriesXValuesPanel);
  FXValSeriesSmartEnabledCheck.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesSmartEnabledCheck.Position.X := lbl3.Position.X + BIGHORSPACE;
  FXValSeriesSmartEnabledCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesSmartEnabledCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesSmartEnabledCheck.Height := CHECKBOXSIZE;
  FXValSeriesSmartEnabledCheck.Width := CHECKBOXSIZE;
  FXValSeriesSmartEnabledCheck.Left := lbl3.Left + BIGHORSPACE;
  FXValSeriesSmartEnabledCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartAutoRotate);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartAutoRotate);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesSmartAutoRotateCheck := TCheckBox.Create(FSeriesXValuesPanel);
  FXValSeriesSmartAutoRotateCheck.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesSmartAutoRotateCheck.Position.X := FXValSeriesSmartEnabledCheck.Position.X;
  FXValSeriesSmartAutoRotateCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesSmartAutoRotateCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesSmartAutoRotateCheck.Height := CHECKBOXSIZE;
  FXValSeriesSmartAutoRotateCheck.Width := CHECKBOXSIZE;
  FXValSeriesSmartAutoRotateCheck.Left := FXValSeriesSmartEnabledCheck.Left;
  FXValSeriesSmartAutoRotateCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinSpacing);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinSpacing);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesSmartMinSpacing := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesSmartMinSpacing.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesSmartMinSpacing.DecimalDigits := 1;
  FXValSeriesSmartMinSpacing.Min := 0;
  FXValSeriesSmartMinSpacing.Position.X := FXValSeriesSmartEnabledCheck.Position.X;
  FXValSeriesSmartMinSpacing.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesSmartMinSpacing.Height)/2;
  FXValSeriesSmartMinSpacing.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesSmartMinSpacing.MinValue := 0;
  FXValSeriesSmartMinSpacing.Left := FXValSeriesSmartEnabledCheck.Left;
  FXValSeriesSmartMinSpacing.Top := lbl3.Top + (lbl3.Height - FXValSeriesSmartMinSpacing.Height) div 2;
  {$ENDIF}
  FXValSeriesSmartMinSpacing.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesXValuesPanel);
  lbl4.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinLabels);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinLabels);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FXValSeriesSmartMinLabels := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesSmartMinLabels.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesSmartMinLabels.Min := 0;
  FXValSeriesSmartMinLabels.Position.X := FXValSeriesSmartMinSpacing.Position.X;
  FXValSeriesSmartMinLabels.Position.Y := lbl4.Position.Y + (lbl4.Height - FXValSeriesSmartMinLabels.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesSmartMinLabels.MinValue := 0;
  FXValSeriesSmartMinLabels.Left := FXValSeriesSmartMinSpacing.Left;
  FXValSeriesSmartMinLabels.Top := lbl4.Top + (lbl4.Height - FXValSeriesSmartMinLabels.Height) div 2;
  {$ENDIF}
  FXValSeriesSmartMinLabels.Width := SERIESLARGECONTROLWIDTH;

  lbl3 := TLabel.Create(FSeriesXValuesPanel);
  lbl3.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMaxLabels);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMaxLabels);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FXValSeriesSmartMaxLabels := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesXValuesPanel);
  FXValSeriesSmartMaxLabels.Parent := FSeriesXValuesPanel;
  {$IFDEF FMXLIB}
  FXValSeriesSmartMaxLabels.Min := 0;
  FXValSeriesSmartMaxLabels.Position.X := FXValSeriesSmartMinLabels.Position.X;
  FXValSeriesSmartMaxLabels.Position.Y := lbl3.Position.Y + (lbl3.Height - FXValSeriesSmartMaxLabels.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FXValSeriesSmartMaxLabels.MinValue := 0;
  FXValSeriesSmartMaxLabels.Left := FXValSeriesSmartMinLabels.Left;
  FXValSeriesSmartMaxLabels.Top := lbl3.Top + (lbl3.Height - FXValSeriesSmartMaxLabels.Height) div 2;
  {$ENDIF}
  FXValSeriesSmartMaxLabels.Width := SERIESLARGECONTROLWIDTH;

  {$IFDEF FMXLIB}
  FSeriesXValuesPanel.Height := FXValSeriesSmartMaxLabels.Position.Y + FXValSeriesSmartMaxLabels.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesXValuesPanel.Height := FXValSeriesSmartMaxLabels.Top + FXValSeriesSmartMaxLabels.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //             Series Y Grid Panel
  //-----------------------------------------------

  FSeriesYGridPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesYGridPanel.Align := TAlignLayout.Top;
  FSeriesYGridPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesYGridPanel.PanelPosition := eppCenter;
  FSeriesYGridPanel.Align := alTop;
  FSeriesYGridPanel.Top := 0;
  {$ENDIF}
  FSeriesYGridPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesYGridPanel);
  lbl1.Parent := FSeriesYGridPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesYGridPanel);
  lbl2.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisibility);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisibility);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYGridPanel);
  lbl3.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYGridSeriesVisibleCheck := TCheckBox.Create(FSeriesYGridPanel);
  FYGridSeriesVisibleCheck.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesVisibleCheck.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYGridSeriesVisibleCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FYGridSeriesVisibleCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesVisibleCheck.Height := CHECKBOXSIZE;
  FYGridSeriesVisibleCheck.Width := CHECKBOXSIZE;
  FYGridSeriesVisibleCheck.Left := lbl3.Left + SMALLHORSPACE;
  FYGridSeriesVisibleCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesYGridPanel);
  lbl4.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorExtended);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorExtended);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYGridSeriesExtendedCheck := TCheckBox.Create(FSeriesYGridPanel);
  FYGridSeriesExtendedCheck.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesExtendedCheck.Position.X := FMarkersSeriesVisibleCheck.Position.X;
  FYGridSeriesExtendedCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FYGridSeriesExtendedCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesExtendedCheck.Height := CHECKBOXSIZE;
  FYGridSeriesExtendedCheck.Width := CHECKBOXSIZE;
  FYGridSeriesExtendedCheck.Left := FMarkersSeriesVisibleCheck.Left;
  FYGridSeriesExtendedCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesYGridPanel);
  lbl3.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := FYGridSeriesExtendedCheck.Position.X + FMarkersSeriesFillKind.Width + 10;
  lbl3.Position.Y := lbl2.Position.Y;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorStroke);
  lbl3.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := FYGridSeriesExtendedCheck.Left + FMarkersSeriesFillKind.Width + 10;
  lbl3.Top := lbl2.Top;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorStroke);
  {$ENDIF}
  lbl3.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl3);

  lbl2 := TLabel.Create(FSeriesYGridPanel);
  lbl2.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl3.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl3.Position.Y + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl3.Left + SMALLLBLSPACE;
  lbl2.Top := lbl3.Top + lbl3.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FYGridSeriesMajorStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesYGridPanel);
  FYGridSeriesMajorStrokeCol.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesMajorStrokeCol.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FYGridSeriesMajorStrokeCol.Position.Y := lbl2.Position.Y + (lbl2.Height - FYGridSeriesMajorStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FYGridSeriesMajorStrokeCol);
  FYGridSeriesMajorStrokeCol.Left := lbl2.Left + SMALLHORSPACE;
  FYGridSeriesMajorStrokeCol.Top := lbl2.Top + (lbl2.Height - FYGridSeriesMajorStrokeCol.Height) div 2;
  {$ENDIF}
  FYGridSeriesMajorStrokeCol.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesYGridPanel);
  lbl4.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl2.Position.X;
  lbl4.Position.Y := lbl2.Position.Y + lbl2.Height + 15;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl2.Left;
  lbl4.Top := lbl2.Top + lbl2.Height + 10;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYGridSeriesMajorStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYGridPanel);
  FYGridSeriesMajorStrokeKind.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesMajorStrokeKind.Position.X := FYGridSeriesMajorStrokeCol.Position.X;
  FYGridSeriesMajorStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FYGridSeriesMajorStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesMajorStrokeKind.Left := FYGridSeriesMajorStrokeCol.Left;
  FYGridSeriesMajorStrokeKind.Top := lbl4.Top + (lbl4.Height - FYGridSeriesMajorStrokeKind.Height) div 2;
  {$ENDIF}
  FYGridSeriesMajorStrokeKind.Items.Add('None');
  FYGridSeriesMajorStrokeKind.Items.Add('Solid');
  FYGridSeriesMajorStrokeKind.Items.Add('Dash');
  FYGridSeriesMajorStrokeKind.Items.Add('Dot');
  FYGridSeriesMajorStrokeKind.Items.Add('DashDot');
  FYGridSeriesMajorStrokeKind.Items.Add('DashDotDot');
  FYGridSeriesMajorStrokeKind.Width := FYGridSeriesMajorStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesYGridPanel);
  lbl2.Parent := FSeriesYGridPanel;
  lbl2.Position.X := lbl4.Position.X;
  lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + 15;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FYGridSeriesMajorStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesYGridPanel);
  FYGridSeriesMajorStrokeOpacity.Parent := FSeriesYGridPanel;
  FYGridSeriesMajorStrokeOpacity.Position.X := FYGridSeriesMajorStrokeCol.Position.X;
  FYGridSeriesMajorStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FYGridSeriesMajorStrokeOpacity.Height)/2;
  FYGridSeriesMajorStrokeOpacity.Width := FYGridSeriesMajorStrokeKind.Width;
  {$ENDIF}

  lbl5 := TLabel.Create(FSeriesYGridPanel);
  lbl5.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := lbl2.Position.Y + lbl2.Height + 15;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl4.Left;
  lbl5.Top := lbl4.Top + lbl4.Height + 10;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl5);

  FYGridSeriesMajorStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYGridPanel);
  FYGridSeriesMajorStrokeWidth.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesMajorStrokeWidth.Min := 0;
  FYGridSeriesMajorStrokeWidth.DecimalDigits := 1;
  FYGridSeriesMajorStrokeWidth.Position.X := FYGridSeriesMajorStrokeCol.Position.X;
  FYGridSeriesMajorStrokeWidth.Position.Y := lbl5.Position.Y + (lbl5.Height - FYGridSeriesMajorStrokeWidth.Height)/2;
  FYGridSeriesMajorStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesMajorStrokeWidth.MinValue := 0;
  FYGridSeriesMajorStrokeWidth.Left := FYGridSeriesMajorStrokeCol.Left;
  FYGridSeriesMajorStrokeWidth.Top := lbl5.Top + (lbl5.Height - FYGridSeriesMajorStrokeWidth.Height) div 2;
  {$ENDIF}
  FYGridSeriesMajorStrokeWidth.Width := FYGridSeriesMajorStrokeCol.Width;

  lbl2 := TLabel.Create(FSeriesYGridPanel);
  lbl2.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FYGridSeriesMajorStrokeWidth.Position.X + FYGridSeriesMajorStrokeWidth.Width + 10;
  lbl2.Position.Y := lbl3.Position.Y;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorStroke);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FYGridSeriesMajorStrokeWidth.Left + FYGridSeriesMajorStrokeWidth.Width + 10;
  lbl2.Top := lbl3.Top;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorStroke);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYGridPanel);
  lbl3.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYGridSeriesMinorStrokeCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesYGridPanel);
  FYGridSeriesMinorStrokeCol.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesMinorStrokeCol.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYGridSeriesMinorStrokeCol.Position.Y := lbl3.Position.Y + (lbl3.Height - FYGridSeriesMinorStrokeCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FYGridSeriesMinorStrokeCol);
  FYGridSeriesMinorStrokeCol.Left := lbl3.Left + SMALLHORSPACE;
  FYGridSeriesMinorStrokeCol.Top := lbl3.Top + (lbl3.Height - FYGridSeriesMinorStrokeCol.Height) div 2;
  {$ENDIF}
  FYGridSeriesMinorStrokeCol.Width := FYGridSeriesMajorStrokeCol.Width;

  lbl4 := TLabel.Create(FSeriesYGridPanel);
  lbl4.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYGridSeriesMinorStrokeKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYGridPanel);
  FYGridSeriesMinorStrokeKind.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesMinorStrokeKind.Position.X := FMarkersSeriesStrokeCol.Position.X;
  FYGridSeriesMinorStrokeKind.Position.Y := lbl4.Position.Y + (lbl4.Height - FYGridSeriesMinorStrokeKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesMinorStrokeKind.Left := FMarkersSeriesStrokeCol.Left;
  FYGridSeriesMinorStrokeKind.Top := lbl4.Top + (lbl4.Height - FYGridSeriesMinorStrokeKind.Height) div 2;
  {$ENDIF}
  FYGridSeriesMinorStrokeKind.Items.Add('None');
  FYGridSeriesMinorStrokeKind.Items.Add('Solid');
  FYGridSeriesMinorStrokeKind.Items.Add('Dash');
  FYGridSeriesMinorStrokeKind.Items.Add('Dot');
  FYGridSeriesMinorStrokeKind.Items.Add('DashDot');
  FYGridSeriesMinorStrokeKind.Items.Add('DashDotDot');
  FYGridSeriesMinorStrokeKind.Width := FYGridSeriesMinorStrokeCol.Width;

  {$IFDEF FMXLIB}
  lbl2 := TLabel.Create(FSeriesYGridPanel);
  lbl2.Parent := FSeriesYGridPanel;
  lbl2.Position.X := lbl4.Position.X;
  lbl2.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOpacity);
  SetEditorLabelAppearance(lbl2);

  FYGridSeriesMinorStrokeOpacity := TTMSFNCChartSeriesEditorAlphaTrackBar.Create(FSeriesYGridPanel);
  FYGridSeriesMinorStrokeOpacity.Parent := FSeriesYGridPanel;
  FYGridSeriesMinorStrokeOpacity.Position.X := FMarkersSeriesStrokeKind.Position.X;
  FYGridSeriesMinorStrokeOpacity.Position.Y := lbl2.Position.Y + (lbl2.Height - FYGridSeriesMinorStrokeOpacity.Height)/2;
  FYGridSeriesMinorStrokeOpacity.Width := FMarkersSeriesStrokeCol.Width;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesYGridPanel);
  lbl3.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYGridSeriesMinorStrokeWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYGridPanel);
  FYGridSeriesMinorStrokeWidth.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesMinorStrokeWidth.Min := 0;
  FYGridSeriesMinorStrokeWidth.DecimalDigits := 1;
  FYGridSeriesMinorStrokeWidth.Position.X := FMarkersSeriesStrokeOpacity.Position.X;
  FYGridSeriesMinorStrokeWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FYGridSeriesMinorStrokeWidth.Height)/2;
  FYGridSeriesMinorStrokeWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesMinorStrokeWidth.MinValue := 0;
  FYGridSeriesMinorStrokeWidth.Left := FMarkersSeriesStrokeKind.Left;
  FYGridSeriesMinorStrokeWidth.Top := lbl3.Top + (lbl3.Height - FYGridSeriesMinorStrokeWidth.Height) div 2;
  {$ENDIF}
  FYGridSeriesMinorStrokeWidth.Width := FYGridSeriesMinorStrokeKind.Width;

  lbl1 := TLabel.Create(FSeriesYGridPanel);
  lbl1.Parent := FSeriesYGridPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FYGridSeriesMinorStrokeWidth.Position.Y + FYGridSeriesMinorStrokeWidth.Height + BIGHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSpider);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FYGridSeriesMinorStrokeWidth.Top + FYGridSeriesMinorStrokeWidth.Height + BIGHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSpider);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl3 := TLabel.Create(FSeriesYGridPanel);
  lbl3.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl1.Position.X + MIDLBLSPACE;
  lbl3.Position.Y := lbl1.Position.Y + lbl1.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl1.Left + MIDLBLSPACE;
  lbl3.Top := lbl1.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVisible);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYGridSeriesSpiderVisibleCheck := TCheckBox.Create(FSeriesYGridPanel);
  FYGridSeriesSpiderVisibleCheck.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesSpiderVisibleCheck.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYGridSeriesSpiderVisibleCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FYGridSeriesSpiderVisibleCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesSpiderVisibleCheck.Height := CHECKBOXSIZE;
  FYGridSeriesSpiderVisibleCheck.Width := CHECKBOXSIZE;
  FYGridSeriesSpiderVisibleCheck.Left := lbl3.Left + SMALLHORSPACE;
  FYGridSeriesSpiderVisibleCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesYGridPanel);
  lbl4.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYGridSeriesLegendTextCheck := TCheckBox.Create(FSeriesYGridPanel);
  FYGridSeriesLegendTextCheck.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesLegendTextCheck.Position.X := FYGridSeriesSpiderVisibleCheck.Position.X;
  FYGridSeriesLegendTextCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FYGridSeriesLegendTextCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesLegendTextCheck.Height := CHECKBOXSIZE;
  FYGridSeriesLegendTextCheck.Width := CHECKBOXSIZE;
  FYGridSeriesLegendTextCheck.Left := FYGridSeriesSpiderVisibleCheck.Left;
  FYGridSeriesLegendTextCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesYGridPanel);
  lbl3.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorKind);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYGridSeriesSpiderKind := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYGridPanel);
  FYGridSeriesSpiderKind.Parent := FSeriesYGridPanel;
  {$IFDEF FMXLIB}
  FYGridSeriesSpiderKind.Position.X := FYGridSeriesLegendTextCheck.Position.X;
  FYGridSeriesSpiderKind.Position.Y := lbl3.Position.Y + (lbl3.Height - FYGridSeriesSpiderKind.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYGridSeriesSpiderKind.Left := FYGridSeriesLegendTextCheck.Left;
  FYGridSeriesSpiderKind.Top := lbl3.Top + (lbl3.Height - FYGridSeriesSpiderKind.Height) div 2;
  {$ENDIF}
  FYGridSeriesSpiderKind.Items.Add('Circles');
  FYGridSeriesSpiderKind.Items.Add('Polygon');
  FYGridSeriesSpiderKind.Width := FYGridSeriesMinorStrokeCol.Width;

  {$IFDEF FMXLIB}
  FSeriesYGridPanel.Height := FYGridSeriesSpiderKind.Position.Y + FYGridSeriesSpiderKind.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesYGridPanel.Height := FYGridSeriesSpiderKind.Top + FYGridSeriesSpiderKind.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //             Series Y Values Panel
  //-----------------------------------------------

  FSeriesYValuesPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesYValuesPanel.Align := TAlignLayout.Top;
  FSeriesYValuesPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesYValuesPanel.PanelPosition := eppCenter;
  FSeriesYValuesPanel.Align := alTop;
  FSeriesYValuesPanel.Top := 0;
  {$ENDIF}
  FSeriesYValuesPanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesYValuesPanel);
  lbl1.Parent := FSeriesYValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAppearance);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesLeftCheck := TCheckBox.Create(FSeriesYValuesPanel);
  FYValSeriesLeftCheck.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesLeftCheck.Position.X := lbl3.Position.X + BIGHORSPACE;
  FYValSeriesLeftCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesLeftCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesLeftCheck.Height := CHECKBOXSIZE;
  FYValSeriesLeftCheck.Width := CHECKBOXSIZE;
  FYValSeriesLeftCheck.Left := lbl3.Left + BIGHORSPACE;
  FYValSeriesLeftCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorCenter);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorCenter);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesCenterCheck := TCheckBox.Create(FSeriesYValuesPanel);
  FYValSeriesCenterCheck.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesCenterCheck.Position.X := FYValSeriesLeftCheck.Position.X;
  FYValSeriesCenterCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesCenterCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesCenterCheck.Height := CHECKBOXSIZE;
  FYValSeriesCenterCheck.Width := CHECKBOXSIZE;
  FYValSeriesCenterCheck.Left := FYValSeriesLeftCheck.Left;
  FYValSeriesCenterCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesRightCheck := TCheckBox.Create(FSeriesYValuesPanel);
  FYValSeriesRightCheck.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesRightCheck.Position.X := FYValSeriesLeftCheck.Position.X;
  FYValSeriesRightCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesRightCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesRightCheck.Height := CHECKBOXSIZE;
  FYValSeriesRightCheck.Width := CHECKBOXSIZE;
  FYValSeriesRightCheck.Left := FYValSeriesLeftCheck.Left;
  FYValSeriesRightCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSpider);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSpider);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesValuesCheck := TCheckBox.Create(FSeriesYValuesPanel);
  FYValSeriesValuesCheck.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesValuesCheck.Position.X := FYValSeriesRightCheck.Position.X;
  FYValSeriesValuesCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesValuesCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesValuesCheck.Height := CHECKBOXSIZE;
  FYValSeriesValuesCheck.Width := CHECKBOXSIZE;
  FYValSeriesValuesCheck.Left := FYValSeriesRightCheck.Left;
  FYValSeriesValuesCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorSpacing);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorSpacing);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMajSpacing := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMajSpacing.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajSpacing.DecimalDigits := 1;
  FYValSeriesMajSpacing.Position.X := FYValSeriesValuesCheck.Position.X;
  FYValSeriesMajSpacing.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesMajSpacing.Height)/2;
  FYValSeriesMajSpacing.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMajSpacing.Left := FYValSeriesValuesCheck.Left;
  FYValSeriesMajSpacing.Top := lbl3.Top + (lbl3.Height - FYValSeriesMajSpacing.Height) div 2;
  {$ENDIF}
  FYValSeriesMajSpacing.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorSpacing);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorSpacing);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesMinSpacing := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMinSpacing.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinSpacing.DecimalDigits := 1;
  FYValSeriesMinSpacing.Position.X := FYValSeriesMajSpacing.Position.X;
  FYValSeriesMinSpacing.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesMajSpacing.Height)/2;
  FYValSeriesMinSpacing.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMinSpacing.Left := FYValSeriesMajSpacing.Left;
  FYValSeriesMinSpacing.Top := lbl4.Top + (lbl4.Height - FYValSeriesMajSpacing.Height) div 2;
  {$ENDIF}
  FYValSeriesMinSpacing.Width := FYValSeriesMajSpacing.Width;

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FYValSeriesMinSpacing.Position.X + FYValSeriesMinSpacing.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFont);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FYValSeriesMinSpacing.Left + FYValSeriesMinSpacing.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFont);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMajFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYValuesPanel);
  FYValSeriesMajFontName.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYValSeriesMajFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesMajFontName.Height)/2;
  FYValSeriesMajFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMajFontName.Left := lbl3.Left + SMALLHORSPACE;
  FYValSeriesMajFontName.Top := lbl3.Top + (lbl3.Height - FYValSeriesMajFontName.Height) div 2;
  {$ENDIF}
  FYValSeriesMajFontName.Width := FYValSeriesMinSpacing.Width;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesMajFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesYValuesPanel);
  FYValSeriesMajFontCol.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajFontCol.Position.X := FYValSeriesMajFontName.Position.X;
  FYValSeriesMajFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesMajFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FYValSeriesMajFontCol);
  FYValSeriesMajFontCol.Left := FYValSeriesMajFontName.Left;
  FYValSeriesMajFontCol.Top := lbl4.Top + (lbl4.Height - FYValSeriesMajFontCol.Height) div 2;
  {$ENDIF}
  FYValSeriesMajFontCol.Width := FYValSeriesMajFontName.Width;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMajFontSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMajFontSize.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajFontSize.Min := 0;
  FYValSeriesMajFontSize.Position.X := FYValSeriesMajFontName.Position.X;
  FYValSeriesMajFontSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMajFontSize.MinValue := 0;
  FYValSeriesMajFontSize.Left := FYValSeriesMajFontName.Left;
  FYValSeriesMajFontSize.Top := lbl3.Top + (lbl3.Height - FLegSeriesSize.Height) div 2;
  {$ENDIF}
  FYValSeriesMajFontSize.Width := FYValSeriesMajFontName.Width;

  lbl5 := TLabel.Create(FSeriesYValuesPanel);
  lbl5.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := FYValSeriesMajFontSize.Position.Y + FYValSeriesMajFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorTickmark);
  lbl5.StyledSettings := lbl5.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl2.Left;
  lbl5.Top := FYValSeriesMajFontSize.Top + FYValSeriesMajFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorTickmark);
  {$ENDIF}
  lbl5.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl5);

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl5.Position.X + SMALLLBLSPACE;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl5.Left + SMALLLBLSPACE;
  lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesMajTickCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesYValuesPanel);
  FYValSeriesMajTickCol.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajTickCol.Position.X := FYValSeriesMajFontName.Position.X;
  FYValSeriesMajTickCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesMajTickCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FYValSeriesMajTickCol);
  FYValSeriesMajTickCol.Left := FYValSeriesMajFontName.Left;
  FYValSeriesMajTickCol.Top := lbl4.Top + (lbl4.Height - FYValSeriesMajTickCol.Height) div 2;
  {$ENDIF}
  FYValSeriesMajTickCol.Width := FYValSeriesMajFontSize.Width;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMajTickSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMajTickSize.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajTickSize.Min := 0;
  FYValSeriesMajTickSize.Position.X := FYValSeriesMajFontName.Position.X;
  FYValSeriesMajTickSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesMajTickSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMajTickSize.MinValue := 0;
  FYValSeriesMajTickSize.Left := FYValSeriesMajFontName.Left;
  FYValSeriesMajTickSize.Top := lbl3.Top + (lbl3.Height - FYValSeriesMajTickSize.Height) div 2;
  {$ENDIF}
  FYValSeriesMajTickSize.Width := FYValSeriesMajTickCol.Width;

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FYValSeriesMajFontSize.Position.X + FYValSeriesMajFontSize.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFont);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FYValSeriesMajFontSize.Left + FYValSeriesMajFontSize.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFont);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMinFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYValuesPanel);
  FYValSeriesMinFontName.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYValSeriesMinFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesMinFontName.Height)/2;
  FYValSeriesMinFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMinFontName.Left := lbl3.Left + SMALLHORSPACE;
  FYValSeriesMinFontName.Top := lbl3.Top + (lbl3.Height - FYValSeriesMinFontName.Height) div 2;
  {$ENDIF}
  FYValSeriesMinFontName.Width := FYValSeriesMajFontSize.Width;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesMinFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesYValuesPanel);
  FYValSeriesMinFontCol.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinFontCol.Position.X := FYValSeriesMinFontName.Position.X;
  FYValSeriesMinFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesMinFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FYValSeriesMinFontCol);
  FYValSeriesMinFontCol.Left := FYValSeriesMinFontName.Left;
  FYValSeriesMinFontCol.Top := lbl4.Top + (lbl4.Height - FYValSeriesMinFontCol.Height) div 2;
  {$ENDIF}
  FYValSeriesMinFontCol.Width := FYValSeriesMajFontSize.Width;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMinFontSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMinFontSize.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinFontSize.Min := 0;
  FYValSeriesMinFontSize.Position.X := FYValSeriesMinFontName.Position.X;
  FYValSeriesMinFontSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FLegSeriesSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMinFontSize.MinValue := 0;
  FYValSeriesMinFontSize.Left := FYValSeriesMinFontName.Left;
  FYValSeriesMinFontSize.Top := lbl3.Top + (lbl3.Height - FLegSeriesSize.Height) div 2;
  {$ENDIF}
  FYValSeriesMinFontSize.Width := FYValSeriesMinFontName.Width;

  lbl5 := TLabel.Create(FSeriesYValuesPanel);
  lbl5.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl5.Position.X := lbl2.Position.X;
  lbl5.Position.Y := FYValSeriesMinFontSize.Position.Y + FYValSeriesMinFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorTickmark);
  lbl5.StyledSettings := lbl5.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl5.Left := lbl2.Left;
  lbl5.Top := FYValSeriesMinFontSize.Top + FYValSeriesMinFontSize.Height + SMALLHEIGHTSPAC;
  lbl5.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorTickmark);
  {$ENDIF}
  lbl5.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl5);

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl5.Position.X + SMALLLBLSPACE;
  lbl4.Position.Y := lbl5.Position.Y + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl5.Left + SMALLLBLSPACE;
  lbl4.Top := lbl5.Top + lbl5.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesMinTickCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesYValuesPanel);
  FYValSeriesMinTickCol.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinTickCol.Position.X := FYValSeriesMinFontName.Position.X;
  FYValSeriesMinTickCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesMinTickCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FYValSeriesMinTickCol);
  FYValSeriesMinTickCol.Left := FYValSeriesMinFontName.Left;
  FYValSeriesMinTickCol.Top := lbl4.Top + (lbl4.Height - FYValSeriesMinTickCol.Height) div 2;
  {$ENDIF}
  FYValSeriesMinTickCol.Width := FYValSeriesMinFontSize.Width;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMinTickSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMinTickSize.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinTickSize.Min := 0;
  FYValSeriesMinTickSize.Position.X := FYValSeriesMinFontName.Position.X;
  FYValSeriesMinTickSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesMinTickSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMinTickSize.MinValue := 0;
  FYValSeriesMinTickSize.Left := FYValSeriesMinFontName.Left;
  FYValSeriesMinTickSize.Top := lbl3.Top + (lbl3.Height - FYValSeriesMinTickSize.Height) div 2;
  {$ENDIF}
  FYValSeriesMinTickSize.Width := FYValSeriesMinTickCol.Width;

  lbl1 := TLabel.Create(FSeriesYValuesPanel);
  lbl1.Parent := FSeriesYValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;;
  lbl1.Position.Y := FYValSeriesMinSpacing.Position.Y + FYValSeriesMinSpacing.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValues);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;;
  lbl1.Top := FYValSeriesMinSpacing.Top + FYValSeriesMinSpacing.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValues);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorUnits);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorUnits);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAuto);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAuto);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesAutoCheck := TCheckBox.Create(FSeriesYValuesPanel);
  FYValSeriesAutoCheck.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesAutoCheck.Position.X := lbl3.Position.X + BIGHORSPACE;
  FYValSeriesAutoCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesAutoCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesAutoCheck.Height := CHECKBOXSIZE;
  FYValSeriesAutoCheck.Width := CHECKBOXSIZE;
  FYValSeriesAutoCheck.Left := lbl3.Left + BIGHORSPACE;
  FYValSeriesAutoCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesUnitMajor := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesUnitMajor.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesUnitMajor.DecimalDigits := 3;
  FYValSeriesUnitMajor.Position.X := FYValSeriesMajSpacing.Position.X;
  FYValSeriesUnitMajor.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesUnitMajor.Height)/2;
  FYValSeriesUnitMajor.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesUnitMajor.Left := FYValSeriesMajSpacing.Left;
  FYValSeriesUnitMajor.Top := lbl4.Top + (lbl4.Height - FYValSeriesUnitMajor.Height) div 2;
  {$ENDIF}
  FYValSeriesUnitMajor.Width := FYValSeriesMajSpacing.Width;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesUnitMinor := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesUnitMinor.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesUnitMinor.DecimalDigits := 3;
  FYValSeriesUnitMinor.Position.X := FYValSeriesUnitMajor.Position.X;
  FYValSeriesUnitMinor.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesUnitMinor.Height)/2;
  FYValSeriesUnitMinor.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesUnitMinor.Left := FYValSeriesUnitMajor.Left;
  FYValSeriesUnitMinor.Top := lbl3.Top + (lbl3.Height - FYValSeriesUnitMinor.Height) div 2;
  {$ENDIF}
  FYValSeriesUnitMinor.Width := FYValSeriesUnitMajor.Width;

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FYValSeriesUnitMinor.Position.X + FYValSeriesUnitMinor.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFormat);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FYValSeriesUnitMinor.Left + FYValSeriesUnitMinor.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMajorFormat);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMajFormatType := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYValuesPanel);
  FYValSeriesMajFormatType.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajFormatType.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYValSeriesMajFormatType.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesMajFormatType.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMajFormatType.Left := lbl3.Left + SMALLHORSPACE;
  FYValSeriesMajFormatType.Top := lbl3.Top + (lbl3.Height - FYValSeriesMajFormatType.Height) div 2;
  {$ENDIF}
  FYValSeriesMajFormatType.Items.Add('Normal');
  FYValSeriesMajFormatType.Items.Add('Float');
  FYValSeriesMajFormatType.Items.Add('DateTime');
  FYValSeriesMajFormatType.Width := FYValSeriesUnitMinor.Width;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesMajFormatValue := TEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMajFormatValue.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMajFormatValue.Position.X := FYValSeriesMajFormatType.Position.X;
  FYValSeriesMajFormatValue.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesMajFormatValue.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMajFormatValue.Left := FYValSeriesMajFormatType.Left;
  FYValSeriesMajFormatValue.Top := lbl4.Top + (lbl4.Height - FYValSeriesMajFormatValue.Height) div 2;
  {$ENDIF}
  FYValSeriesMajFormatValue.Width := FYValSeriesMajFormatType.Width;

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FYValSeriesMajFormatValue.Position.X + FYValSeriesMajFormatValue.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFormat);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FYValSeriesMajFormatValue.Left + FYValSeriesMajFormatValue.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMinorFormat);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesMinFormatType := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYValuesPanel);
  FYValSeriesMinFormatType.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinFormatType.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYValSeriesMinFormatType.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesMinFormatType.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMinFormatType.Left := lbl3.Left + SMALLHORSPACE;
  FYValSeriesMinFormatType.Top := lbl3.Top + (lbl3.Height - FYValSeriesMinFormatType.Height) div 2;
  {$ENDIF}
  FYValSeriesMinFormatType.Items.Add('Normal');
  FYValSeriesMinFormatType.Items.Add('Float');
  FYValSeriesMinFormatType.Items.Add('DateTime');
  FYValSeriesMinFormatType.Width := FYValSeriesUnitMinor.Width;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesMinFormatValue := TEdit.Create(FSeriesYValuesPanel);
  FYValSeriesMinFormatValue.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesMinFormatValue.Position.X := FYValSeriesMinFormatType.Position.X;
  FYValSeriesMinFormatValue.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesMinFormatValue.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesMinFormatValue.Left := FYValSeriesMinFormatType.Left;
  FYValSeriesMinFormatValue.Top := lbl4.Top + (lbl4.Height - FYValSeriesMinFormatValue.Height) div 2;
  {$ENDIF}
  FYValSeriesMinFormatValue.Width := FYValSeriesMinFormatType.Width;

  lbl1 := TLabel.Create(FSeriesYValuesPanel);
  lbl1.Parent := FSeriesYValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;;
  lbl1.Position.Y := FYValSeriesUnitMinor.Position.Y + FYValSeriesUnitMinor.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTitleText);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;;
  lbl1.Top := FYValSeriesUnitMinor.Top + FYValSeriesUnitMinor.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTitleText);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorText);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorValue);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesTitleValue := TEdit.Create(FSeriesYValuesPanel);
  FYValSeriesTitleValue.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTitleValue.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYValSeriesTitleValue.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesTitleValue.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTitleValue.Left := lbl3.Left + SMALLHORSPACE;
  FYValSeriesTitleValue.Top := lbl3.Top + (lbl3.Height - FYValSeriesTitleValue.Height) div 2;
  {$ENDIF}
  FYValSeriesTitleValue.Width := FYValSeriesMinFormatType.Width;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorHAlign);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorHAlign);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesTitleHAlign := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYValuesPanel);
  FYValSeriesTitleHAlign.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTitleHAlign.Position.X := FYValSeriesTitleValue.Position.X;
  FYValSeriesTitleHAlign.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesTitleHAlign.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTitleHAlign.Left := FYValSeriesTitleValue.Left;
  FYValSeriesTitleHAlign.Top := lbl4.Top + (lbl4.Height - FYValSeriesTitleHAlign.Height) div 2;
  {$ENDIF}
  FYValSeriesTitleHAlign.Items.Add('Center');
  FYValSeriesTitleHAlign.Items.Add('Left');
  FYValSeriesTitleHAlign.Items.Add('Right');
  FYValSeriesTitleHAlign.Width := FYValSeriesTitleValue.Width;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorVAlign);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorVAlign);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesTitleVAlign := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYValuesPanel);
  FYValSeriesTitleVAlign.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTitleVAlign.Position.X := FYValSeriesTitleHAlign.Position.X;
  FYValSeriesTitleVAlign.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesTitleVAlign.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTitleVAlign.Left := FYValSeriesTitleHAlign.Left;
  FYValSeriesTitleVAlign.Top := lbl3.Top + (lbl3.Height - FYValSeriesTitleVAlign.Height) div 2;
  {$ENDIF}
  FYValSeriesTitleVAlign.Items.Add('Center');
  FYValSeriesTitleVAlign.Items.Add('Top');
  FYValSeriesTitleVAlign.Items.Add('Bottom');
  FYValSeriesTitleVAlign.Width := FYValSeriesTitleHAlign.Width;

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FYValSeriesTitleVAlign.Position.X + FYValSeriesTitleVAlign.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTextMargins);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FYValSeriesTitleVAlign.Left + FYValSeriesTitleVAlign.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTextMargins);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + MIDLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesTextLeft := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesTextLeft.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTextLeft.DecimalDigits := 1;
  FYValSeriesTextLeft.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYValSeriesTextLeft.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesTextLeft.Height)/2;
  FYValSeriesTextLeft.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTextLeft.Left := lbl3.Left + SMALLHORSPACE;
  FYValSeriesTextLeft.Top := lbl3.Top + (lbl3.Height - FYValSeriesTextLeft.Height) div 2;
  {$ENDIF}
  FYValSeriesTextLeft.Width := LARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesTextTop := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesTextTop.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTextTop.DecimalDigits := 1;
  FYValSeriesTextTop.Position.X := FYValSeriesTextLeft.Position.X;
  FYValSeriesTextTop.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesTextTop.Height)/2;
  FYValSeriesTextTop.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTextTop.Left := FYValSeriesTextLeft.Left;
  FYValSeriesTextTop.Top := lbl4.Top + (lbl4.Height - FYValSeriesTextTop.Height) div 2;
  {$ENDIF}
  FYValSeriesTextTop.Width := LARGECONTROLWIDTH;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesTextRight := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesTextRight.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTextRight.DecimalDigits := 1;
  FYValSeriesTextRight.Position.X := FYValSeriesTextLeft.Position.X;
  FYValSeriesTextRight.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesTextRight.Height)/2;
  FYValSeriesTextRight.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTextRight.Left := FYValSeriesTextLeft.Left;
  FYValSeriesTextRight.Top := lbl3.Top + (lbl3.Height - FYValSeriesTextRight.Height) div 2;
  {$ENDIF}
  FYValSeriesTextRight.Width := LARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesTextBottom := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesTextBottom.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTextBottom.DecimalDigits := 1;
  FYValSeriesTextBottom.Position.X := FYValSeriesTextLeft.Position.X;
  FYValSeriesTextBottom.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesTextBottom.Height)/2;
  FYValSeriesTextBottom.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTextBottom.Left := FYValSeriesTextLeft.Left;
  FYValSeriesTextBottom.Top := lbl4.Top + (lbl4.Height - FYValSeriesTextBottom.Height) div 2;
  {$ENDIF}
  FYValSeriesTextBottom.Width := LARGECONTROLWIDTH;

  lbl2 := TLabel.Create(FSeriesYValuesPanel);
  lbl2.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FYValSeriesTextBottom.Position.X + FYValSeriesTextBottom.Width + 10;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FYValSeriesTextBottom.Left + FYValSeriesTextBottom.Width + 10;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorFont);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorName);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesTitleFontName := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesYValuesPanel);
  FYValSeriesTitleFontName.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTitleFontName.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FYValSeriesTitleFontName.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesTitleFontName.Height)/2;
  FYValSeriesTitleFontName.ItemWidth := 240;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTitleFontName.Left := lbl3.Left + SMALLHORSPACE;
  FYValSeriesTitleFontName.Top := lbl3.Top + (lbl3.Height - FYValSeriesTitleFontName.Height) div 2;
  {$ENDIF}
  FYValSeriesTitleFontName.Width := FYValSeriesTextBottom.Width;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorColor);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesTitleFontCol := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesYValuesPanel);
  FYValSeriesTitleFontCol.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTitleFontCol.Position.X := FYValSeriesTitleFontName.Position.X;
  FYValSeriesTitleFontCol.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesTitleFontCol.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FYValSeriesTitleFontCol);
  FYValSeriesTitleFontCol.Left := FYValSeriesTitleFontName.Left;
  FYValSeriesTitleFontCol.Top := lbl4.Top + (lbl4.Height - FYValSeriesTitleFontCol.Height) div 2;
  {$ENDIF}
  FYValSeriesTitleFontCol.Width := FYValSeriesTitleFontName.Width;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesTitleFontSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesTitleFontSize.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesTitleFontSize.Min := 0;
  FYValSeriesTitleFontSize.Position.X := FYValSeriesTitleFontName.Position.X;
  FYValSeriesTitleFontSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesTitleFontSize.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesTitleFontSize.MinValue := 0;
  FYValSeriesTitleFontSize.Left := FYValSeriesTitleFontName.Left;
  FYValSeriesTitleFontSize.Top := lbl3.Top + (lbl3.Height - FYValSeriesTitleFontSize.Height) div 2;
  {$ENDIF}
  FYValSeriesTitleFontSize.Width := FYValSeriesTitleFontName.Width;

  // SmartLabels section
  lbl1 := TLabel.Create(FSeriesYValuesPanel);
  lbl1.Parent := FSeriesYValuesPanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FYValSeriesTextBottom.Position.Y + FYValSeriesTextBottom.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartLabels);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FYValSeriesTextBottom.Top + FYValSeriesTextBottom.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartLabels);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartEnabled);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl1.Left + SMALLLBLSPACE;
  lbl3.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartEnabled);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesSmartEnabledCheck := TCheckBox.Create(FSeriesYValuesPanel);
  FYValSeriesSmartEnabledCheck.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesSmartEnabledCheck.Position.X := lbl3.Position.X + BIGHORSPACE;
  FYValSeriesSmartEnabledCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesSmartEnabledCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesSmartEnabledCheck.Height := CHECKBOXSIZE;
  FYValSeriesSmartEnabledCheck.Width := CHECKBOXSIZE;
  FYValSeriesSmartEnabledCheck.Left := lbl3.Left + BIGHORSPACE;
  FYValSeriesSmartEnabledCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartAutoRotate);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartAutoRotate);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesSmartAutoRotateCheck := TCheckBox.Create(FSeriesYValuesPanel);
  FYValSeriesSmartAutoRotateCheck.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesSmartAutoRotateCheck.Position.X := FYValSeriesSmartEnabledCheck.Position.X;
  FYValSeriesSmartAutoRotateCheck.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesSmartAutoRotateCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesSmartAutoRotateCheck.Height := CHECKBOXSIZE;
  FYValSeriesSmartAutoRotateCheck.Width := CHECKBOXSIZE;
  FYValSeriesSmartAutoRotateCheck.Left := FYValSeriesSmartEnabledCheck.Left;
  FYValSeriesSmartAutoRotateCheck.Top := lbl4.Top + (lbl4.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinSpacing);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinSpacing);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesSmartMinSpacing := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesSmartMinSpacing.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesSmartMinSpacing.DecimalDigits := 1;
  FYValSeriesSmartMinSpacing.Min := 0;
  FYValSeriesSmartMinSpacing.Position.X := FYValSeriesSmartEnabledCheck.Position.X;
  FYValSeriesSmartMinSpacing.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesSmartMinSpacing.Height)/2;
  FYValSeriesSmartMinSpacing.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesSmartMinSpacing.MinValue := 0;
  FYValSeriesSmartMinSpacing.Left := FYValSeriesSmartEnabledCheck.Left;
  FYValSeriesSmartMinSpacing.Top := lbl3.Top + (lbl3.Height - FYValSeriesSmartMinSpacing.Height) div 2;
  {$ENDIF}
  FYValSeriesSmartMinSpacing.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesYValuesPanel);
  lbl4.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinLabels);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMinLabels);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FYValSeriesSmartMinLabels := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesSmartMinLabels.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesSmartMinLabels.Min := 0;
  FYValSeriesSmartMinLabels.Position.X := FYValSeriesSmartMinSpacing.Position.X;
  FYValSeriesSmartMinLabels.Position.Y := lbl4.Position.Y + (lbl4.Height - FYValSeriesSmartMinLabels.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesSmartMinLabels.MinValue := 0;
  FYValSeriesSmartMinLabels.Left := FYValSeriesSmartMinSpacing.Left;
  FYValSeriesSmartMinLabels.Top := lbl4.Top + (lbl4.Height - FYValSeriesSmartMinLabels.Height) div 2;
  {$ENDIF}
  FYValSeriesSmartMinLabels.Width := SERIESLARGECONTROLWIDTH;

  lbl3 := TLabel.Create(FSeriesYValuesPanel);
  lbl3.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMaxLabels);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSmartMaxLabels);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FYValSeriesSmartMaxLabels := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesYValuesPanel);
  FYValSeriesSmartMaxLabels.Parent := FSeriesYValuesPanel;
  {$IFDEF FMXLIB}
  FYValSeriesSmartMaxLabels.Min := 0;
  FYValSeriesSmartMaxLabels.Position.X := FYValSeriesSmartMinLabels.Position.X;
  FYValSeriesSmartMaxLabels.Position.Y := lbl3.Position.Y + (lbl3.Height - FYValSeriesSmartMaxLabels.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FYValSeriesSmartMaxLabels.MinValue := 0;
  FYValSeriesSmartMaxLabels.Left := FYValSeriesSmartMinLabels.Left;
  FYValSeriesSmartMaxLabels.Top := lbl3.Top + (lbl3.Height - FYValSeriesSmartMaxLabels.Height) div 2;
  {$ENDIF}
  FYValSeriesSmartMaxLabels.Width := SERIESLARGECONTROLWIDTH;

  {$IFDEF FMXLIB}
  FSeriesYValuesPanel.Height := FYValSeriesSmartMaxLabels.Position.Y + FYValSeriesSmartMaxLabels.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesYValuesPanel.Height := FYValSeriesSmartMaxLabels.Top + FYValSeriesSmartMaxLabels.Height + SMALLHEIGHTSPAC;
  {$ENDIF}

  //              Series Type Specific Panel
  //-----------------------------------------------
//  FSeriesTypeSpecificPanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
//  {$IFDEF FMXLIB}
//  FSeriesTypeSpecificPanel.Align := TAlignLayout.Top;
//  FSeriesTypeSpecificPanel.PanelPosition := eppBottom;
//  {$ENDIF}
//  {$IFDEF CMNWEBLIB}
//  FSeriesTypeSpecificPanel.PanelPosition := eppCenter;
//  FSeriesTypeSpecificPanel.Align := alTop;
//  FSeriesTypeSpecificPanel.Top := 0;
//  {$ENDIF}
//  FSeriesTypeSpecificPanel.Parent := FVertScrlBox;
//


  //             Series Pie Panel
  //-----------------------------------------------
  FSeriesPiePanel := TTMSFNCEditorPanel.Create(FVertScrlBox);
  {$IFDEF FMXLIB}
  FSeriesPiePanel.Align := TAlignLayout.Top;
  FSeriesPiePanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesPiePanel.PanelPosition := eppCenter;
  FSeriesPiePanel.Align := alTop;
  FSeriesPiePanel.Top := 0;
  {$ENDIF}
  FSeriesPiePanel.Parent := FVertScrlBox;

  lbl1 := TLabel.Create(FSeriesPiePanel);
  lbl1.Parent := FSeriesPiePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorPie);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorPie);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMargins);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMargins);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + SMALLLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + SMALLLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorLeft);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FPieSeriesLeft := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesLeft.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesLeft.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FPieSeriesLeft.Position.Y := lbl3.Position.Y + (lbl3.Height - FPieSeriesLeft.Height)/2;
  FPieSeriesLeft.ValueType := TNumValuetype.Float;
  FPieSeriesLeft.DecimalDigits := 1;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesLeft.Left := lbl3.Left + SMALLHORSPACE;
  FPieSeriesLeft.Top := lbl3.Top + (lbl3.Height - FPieSeriesLeft.Height) div 2;
  {$ENDIF}
  FPieSeriesLeft.Width := SERIESLARGECONTROLWIDTH;

  lbl4 := TLabel.Create(FSeriesPiePanel);
  lbl4.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorTop);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FPieSeriesTop := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesTop.Parent := FSeriesPiePanel;

  {$IFDEF FMXLIB}
  FPieSeriesTop.Position.X := FPieSeriesLeft.Position.X;
  FPieSeriesTop.Position.Y := lbl4.Position.Y + (lbl4.Height - FPieSeriesTop.Height)/2;
  FPieSeriesTop.ValueType := TNumValuetype.Float;
  FPieSeriesTop.DecimalDigits := 1;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesTop.Left := FPieSeriesLeft.Left;
  FPieSeriesTop.Top := lbl4.Top + (lbl4.Height - FPieSeriesTop.Height) div 2;
  {$ENDIF}
  FPieSeriesTop.Width := FPieSeriesLeft.Width;

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorRight);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FPieSeriesRight := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesRight.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesRight.DecimalDigits := 1;
  FPieSeriesRight.Position.X := FPieSeriesLeft.Position.X;
  FPieSeriesRight.Position.Y := lbl3.Position.Y + (lbl3.Height - FPieSeriesLeft.Height)/2;
  FPieSeriesRight.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesRight.Left := FPieSeriesLeft.Left;
  FPieSeriesRight.Top := lbl3.Top + (lbl3.Height - FPieSeriesLeft.Height) div 2;
  {$ENDIF}
  FPieSeriesRight.Width := FPieSeriesLeft.Width;

  lbl4 := TLabel.Create(FSeriesPiePanel);
  lbl4.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorBottom);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FPieSeriesBottom := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesBottom.Parent := FSeriesPiePanel;

  {$IFDEF FMXLIB}
  FPieSeriesBottom.Position.X := FPieSeriesLeft.Position.X;
  FPieSeriesBottom.Position.Y := lbl4.Position.Y + (lbl4.Height - FPieSeriesTop.Height)/2;
  FPieSeriesBottom.ValueType := TNumValuetype.Float;
  FPieSeriesBottom.DecimalDigits := 1;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesBottom.Left := FPieSeriesLeft.Left;
  FPieSeriesBottom.Top := lbl4.Top + (lbl4.Height - FPieSeriesTop.Height) div 2;
  {$ENDIF}
  FPieSeriesBottom.Width := FPieSeriesLeft.Width;

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FPieSeriesBottom.Position.X + FPieSeriesBottom.Width + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorLayout);
  lbl2.StyledSettings := lbl2.StyledSettings - [TStyledSetting.Style];
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FPieSeriesBottom.Left + FPieSeriesBottom.Width + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorLayout);
  {$ENDIF}
  lbl2.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl2);

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X + MIDLBLSPACE;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left + MIDLBLSPACE;
  lbl3.Top := lbl2.Top + lbl2.Height + SMALLHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FPieSeriesSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesSize.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesSize.Position.X := lbl3.Position.X + BIGHORSPACE;
  FPieSeriesSize.Position.Y := lbl3.Position.Y + (lbl3.Height - FPieSeriesLeft.Height)/2;
  FPieSeriesSize.ValueType := TNumValuetype.Float;
  FPieSeriesSize.Min := 0;
  FPieSeriesSize.DecimalDigits := 1;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesSize.MinValue := 0;
  FPieSeriesSize.Left := lbl3.Left + BIGHORSPACE;
  FPieSeriesSize.Top := lbl3.Top + (lbl3.Height - FPieSeriesLeft.Height) div 2;
  {$ENDIF}
  FPieSeriesSize.Width := FPieSeriesBottom.Width;

  lbl4 := TLabel.Create(FSeriesPiePanel);
  lbl4.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorInnerSize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorInnerSize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FPieSeriesInnerSize := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesInnerSize.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesInnerSize.Position.X := FPieSeriesSize.Position.X;
  FPieSeriesInnerSize.Position.Y := lbl4.Position.Y + (lbl4.Height - FPieSeriesInnerSize.Height)/2;
  FPieSeriesInnerSize.ValueType := TNumValuetype.Float;
  FPieSeriesInnerSize.Min := 0;
  FPieSeriesInnerSize.DecimalDigits := 1;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesInnerSize.MinValue := 0;
  FPieSeriesInnerSize.Left := FPieSeriesSize.Left;
  FPieSeriesInnerSize.Top := lbl4.Top + (lbl4.Height - FPieSeriesInnerSize.Height) div 2;
  {$ENDIF}
  FPieSeriesInnerSize.Width := FPieSeriesLeft.Width;

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorAutosize);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorAutosize);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FPieSeriesAutoSizeCheck := TCheckBox.Create(FSeriesPiePanel);
  FPieSeriesAutoSizeCheck.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesAutoSizeCheck.Position.X := FPieSeriesInnerSize.Position.X;
  FPieSeriesAutoSizeCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FPieSeriesAutoSizeCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesAutoSizeCheck.Height := CHECKBOXSIZE;
  FPieSeriesAutoSizeCheck.Width := CHECKBOXSIZE;
  FPieSeriesAutoSizeCheck.Left := FPieSeriesInnerSize.Left;
  FPieSeriesAutoSizeCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl4 := TLabel.Create(FSeriesPiePanel);
  lbl4.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorPosition);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FPieSeriesPosition := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesPiePanel);
  FPieSeriesPosition.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesPosition.Position.X := FPieSeriesAutoSizeCheck.Position.X;
  FPieSeriesPosition.Position.Y := lbl4.Position.Y + (lbl4.Height - FPieSeriesPosition.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesPosition.Left := FPieSeriesAutoSizeCheck.Left;
  FPieSeriesPosition.Top := lbl4.Top + (lbl4.Height - FPieSeriesPosition.Height) div 2;
  {$ENDIF}
  FPieSeriesPosition.Items.Add('Top Left');
  FPieSeriesPosition.Items.Add('Top Center');
  FPieSeriesPosition.Items.Add('Top Right');
  FPieSeriesPosition.Items.Add('Center Left');
  FPieSeriesPosition.Items.Add('Center Center');
  FPieSeriesPosition.Items.Add('Center Right');
  FPieSeriesPosition.Items.Add('Bottom Left');
  FPieSeriesPosition.Items.Add('Bottom Center');
  FPieSeriesPosition.Items.Add('Bottom Right');
  FPieSeriesPosition.Width := FPieSeriesInnerSize.Width;

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorStartAngle);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorStartAngle);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FPieSeriesStartAngle := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesStartAngle.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesStartAngle.Position.X := FPieSeriesPosition.Position.X;
  FPieSeriesStartAngle.Position.Y := lbl3.Position.Y + (lbl3.Height - FPieSeriesStartAngle.Height)/2;
  FPieSeriesStartAngle.ValueType := TNumValuetype.Float;
  FPieSeriesStartAngle.Max := 360;
  FPieSeriesStartAngle.Min := -360;
  FPieSeriesStartAngle.DecimalDigits := 1;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesStartAngle.MaxValue := 360;
  FPieSeriesStartAngle.MinValue := -360;
  FPieSeriesStartAngle.Left := FPieSeriesPosition.Left;
  FPieSeriesStartAngle.Top := lbl3.Top + (lbl3.Height - FPieSeriesStartAngle.Height) div 2;
  {$ENDIF}
  FPieSeriesStartAngle.Width := FPieSeriesPosition.Width;

  lbl4 := TLabel.Create(FSeriesPiePanel);
  lbl4.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl4.Position.X := lbl3.Position.X;
  lbl4.Position.Y := lbl3.Position.Y + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSweepAngle);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl4.Left := lbl3.Left;
  lbl4.Top := lbl3.Top + lbl3.Height + MIDHEIGHTSPAC;
  lbl4.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSweepAngle);
  {$ENDIF}
  SetEditorLabelAppearance(lbl4);

  FPieSeriesSweepAngle := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FPieSeriesSweepAngle.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesSweepAngle.Position.X := FPieSeriesSize.Position.X;
  FPieSeriesSweepAngle.Position.Y := lbl4.Position.Y + (lbl4.Height - FPieSeriesSweepAngle.Height)/2;
  FPieSeriesSweepAngle.ValueType := TNumValuetype.Float;
  FPieSeriesSweepAngle.Max := 360;
  FPieSeriesSweepAngle.Min := -360;
  FPieSeriesSweepAngle.DecimalDigits := 1;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesSweepAngle.MaxValue := 360;
  FPieSeriesSweepAngle.MinValue := -360;
  FPieSeriesSweepAngle.Left := FPieSeriesSize.Left;
  FPieSeriesSweepAngle.Top := lbl4.Top + (lbl4.Height - FPieSeriesSweepAngle.Height) div 2;
  {$ENDIF}
  FPieSeriesSweepAngle.Width := FPieSeriesStartAngle.Width;

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl4.Position.X;
  lbl3.Position.Y := lbl4.Position.Y + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorStacked);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl4.Left;
  lbl3.Top := lbl4.Top + lbl4.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorStacked);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FPieSeriesStackedCheck := TCheckBox.Create(FSeriesPiePanel);
  FPieSeriesStackedCheck.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FPieSeriesStackedCheck.Position.X := FPieSeriesSize.Position.X;
  FPieSeriesStackedCheck.Position.Y := lbl3.Position.Y + (lbl3.Height - FPieSeriesStackedCheck.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPieSeriesStackedCheck.Height := CHECKBOXSIZE;
  FPieSeriesStackedCheck.Width := CHECKBOXSIZE;
  FPieSeriesStackedCheck.Left := FPieSeriesSize.Left;
  FPieSeriesStackedCheck.Top := lbl3.Top + (lbl3.Height - (CHECKBOXSIZE + CHECKBOXOFFSET)) div 2;
  {$ENDIF}

  lbl1 := TLabel.Create(FSeriesPiePanel);
  lbl1.Parent := FSeriesPiePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FPieSeriesStackedCheck.Position.Y + FPieSeriesStackedCheck.Height + MIDHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorBar);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FPieSeriesStackedCheck.Top + FPieSeriesStackedCheck.Height + MIDHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorBar);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesBarType := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesPiePanel);
  FGenSeriesBarType.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesBarType.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesBarType.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesBarType.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesBarType.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesBarType.Top := lbl2.Top + (lbl2.Height - FGenSeriesBarType.Height) div 2;
  {$ENDIF}
  FGenSeriesBarType.Items.Add('Percentage');
  FGenSeriesBarType.Items.Add('Pixels');
  FGenSeriesBarType.Width := FGenSeriesZRV.Width;

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FGenSeriesBarType.Position.X + FGenSeriesBarType.Width + MIDLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FGenSeriesBarType.Left + FGenSeriesBarType.Width + MIDLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesBarWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FGenSeriesBarWidth.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesBarWidth.Min := 0;
  FGenSeriesBarWidth.DecimalDigits := 1;
  FGenSeriesBarWidth.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesBarWidth.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesBarWidth.Height)/2;
  FGenSeriesBarWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesBarWidth.MinValue := 0;
  FGenSeriesBarWidth.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesBarWidth.Top := lbl2.Top + (lbl2.Height - FGenSeriesBarWidth.Height) div 2;
  {$ENDIF}
  FGenSeriesBarWidth.Width := FGenSeriesMaxYOff.Width;

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FGenSeriesBarWidth.Position.X + FGenSeriesBarWidth.Width + MIDLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorSpacing);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FGenSeriesBarWidth.Left + FGenSeriesBarWidth.Width + MIDLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorSpacing);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesBarSpacing := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FGenSeriesBarSpacing.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesBarSpacing.Min := 0;
  FGenSeriesBarSpacing.DecimalDigits := 1;
  FGenSeriesBarSpacing.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesBarSpacing.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesBarSpacing.Height)/2;
  FGenSeriesBarSpacing.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesBarSpacing.MinValue := 0;
  FGenSeriesBarSpacing.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesBarSpacing.Top := lbl2.Top + (lbl2.Height - FGenSeriesBarSpacing.Height) div 2;
  {$ENDIF}
  FGenSeriesBarSpacing.Width := FGenSeriesMaxYOff.Width;

  lbl1 := TLabel.Create(FSeriesPiePanel);
  lbl1.Parent := FSeriesPiePanel;
  lbl1.AutoSize := True;
  {$IFDEF FMXLIB}
  lbl1.Position.X := BIGLBLSPACE;
  lbl1.Position.Y := FGenSeriesBarSpacing.Position.Y + FGenSeriesBarSpacing.Height + BIGHEIGHTSPAC;
  lbl1.Text := TranslateTextEx(sTMSFNCChartSeriesEditorMultiPoint);
  lbl1.StyledSettings := lbl1.StyledSettings - [TStyledSetting.Size, TStyledSetting.Style];
  lbl1.Font.Size := 18;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl1.Left := BIGLBLSPACE;
  lbl1.Top := FGenSeriesBarSpacing.Top + FGenSeriesBarSpacing.Height + BIGHEIGHTSPAC;
  lbl1.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorMultiPoint);
  lbl1.Font.Size := 15;
  {$ENDIF}
  lbl1.Font.Style := [TFontStyle.fsBold];
  SetEditorLabelAppearance(lbl1);

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := lbl1.Position.X + SMALLLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height +  + BIGHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := lbl1.Left + SMALLLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + BIGHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorType);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesMultiType := TTMSFNCChartSeriesEditorComboBox.Create(FSeriesPiePanel);
  FGenSeriesMultiType.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesMultiType.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesMultiType.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesMultiType.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMultiType.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesMultiType.Top := lbl2.Top + (lbl2.Height - FGenSeriesMultiType.Height) div 2;
  {$ENDIF}
  FGenSeriesMultiType.Items.Add('Percentage');
  FGenSeriesMultiType.Items.Add('Pixels');
  FGenSeriesMultiType.Width := FGenSeriesBarType.Width;

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorWidth);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesMultiWidth := TTMSFNCChartSeriesEditorSpinEdit.Create(FSeriesPiePanel);
  FGenSeriesMultiWidth.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesMultiWidth.Min := 0;
  FGenSeriesMultiWidth.DecimalDigits := 1;
  FGenSeriesMultiWidth.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FGenSeriesMultiWidth.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesMultiWidth.Height)/2;
  FGenSeriesMultiWidth.ValueType := TNumValuetype.Float;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FGenSeriesMultiWidth.MinValue := 0;
  FGenSeriesMultiWidth.Left := lbl3.Left + SMALLHORSPACE;
  FGenSeriesMultiWidth.Top := lbl3.Top + (lbl3.Height - FGenSeriesMultiWidth.Height) div 2;
  {$ENDIF}
  FGenSeriesMultiWidth.Width := FGenSeriesMultiType.Width;

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FGenSeriesMultiWidth.Position.X + FGenSeriesMultiWidth.Width + MIDLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorIncreaseFill);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FGenSeriesMultiWidth.Left + FGenSeriesMultiWidth.Width + MIDLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorIncreaseFill);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesIncFill := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesPiePanel);
  FGenSeriesIncFill.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesIncFill.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesIncFill.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesIncFill.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FGenSeriesIncFill);
  FGenSeriesIncFill.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesIncFill.Top := lbl2.Top + (lbl2.Height - FGenSeriesIncFill.Height) div 2;
  {$ENDIF}
  FGenSeriesIncFill.Width := FGenSeriesBarWidth.Width;

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorDecreaseFill);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorDecreaseFill);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesDecFill := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesPiePanel);
  FGenSeriesDecFill.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesDecFill.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FGenSeriesDecFill.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesIncFill.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FGenSeriesDecFill);
  FGenSeriesDecFill.Left := lbl3.Left + SMALLHORSPACE;
  FGenSeriesDecFill.Top := lbl3.Top + (lbl3.Height - FGenSeriesDecFill.Height) div 2;
  {$ENDIF}
  FGenSeriesDecFill.Width := FGenSeriesIncFill.Width;

  lbl2 := TLabel.Create(FSeriesPiePanel);
  lbl2.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl2.Position.X := FGenSeriesDecFill.Position.X + FGenSeriesDecFill.Width + MIDLBLSPACE;
  lbl2.Position.Y := lbl1.Position.Y + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Text := TranslateTextEx(sTMSFNCChartSeriesEditorIncreaseStroke);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl2.Left := FGenSeriesDecFill.Left + FGenSeriesDecFill.Width + MIDLBLSPACE;
  lbl2.Top := lbl1.Top + lbl1.Height + SMALLHEIGHTSPAC;
  lbl2.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorIncreaseStroke);
  {$ENDIF}
  SetEditorLabelAppearance(lbl2);

  FGenSeriesIncStroke := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesPiePanel);
  FGenSeriesIncStroke.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesIncStroke.Position.X := lbl2.Position.X + SMALLHORSPACE;
  FGenSeriesIncStroke.Position.Y := lbl2.Position.Y + (lbl2.Height - FGenSeriesIncFill.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FGenSeriesIncStroke);
  FGenSeriesIncStroke.Left := lbl2.Left + SMALLHORSPACE;
  FGenSeriesIncStroke.Top := lbl2.Top + (lbl2.Height - FGenSeriesIncStroke.Height) div 2;
  {$ENDIF}
  FGenSeriesIncStroke.Width := FGenSeriesDecFill.Width;

  lbl3 := TLabel.Create(FSeriesPiePanel);
  lbl3.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  lbl3.Position.X := lbl2.Position.X;
  lbl3.Position.Y := lbl2.Position.Y + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Text := TranslateTextEx(sTMSFNCChartSeriesEditorDecreaseStroke);
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  lbl3.Left := lbl2.Left;
  lbl3.Top := lbl2.Top + lbl2.Height + MIDHEIGHTSPAC;
  lbl3.Caption := TranslateTextEx(sTMSFNCChartSeriesEditorDecreaseStroke);
  {$ENDIF}
  SetEditorLabelAppearance(lbl3);

  FGenSeriesDecStroke := TTMSFNCChartSeriesEditorColorCombo.Create(FSeriesPiePanel);
  FGenSeriesDecStroke.Parent := FSeriesPiePanel;
  {$IFDEF FMXLIB}
  FGenSeriesDecStroke.Position.X := lbl3.Position.X + SMALLHORSPACE;
  FGenSeriesDecStroke.Position.Y := lbl3.Position.Y + (lbl3.Height - FGenSeriesDecStroke.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  SetColorComboStyle(FGenSeriesDecStroke);
  FGenSeriesDecStroke.Left := lbl3.Left + SMALLHORSPACE;
  FGenSeriesDecStroke.Top := lbl3.Top + (lbl3.Height - FGenSeriesDecStroke.Height) div 2;
  {$ENDIF}
  FGenSeriesDecStroke.Width := FGenSeriesIncFill.Width;

  {$IFDEF FMXLIB}
  FSeriesPiePanel.Height := FGenSeriesDecStroke.Position.Y + FGenSeriesDecStroke.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FSeriesPiePanel.Height := FGenSeriesDecStroke.Top + FGenSeriesDecStroke.Height + SMALLHEIGHTSPAC;
  {$ENDIF}
end;

procedure TTMSFNCChartSeriesEditor.BuildSeriesSelectionPanel(AParent: TTMSFNCChartSeriesEditorParent);
var
  bs: TBytesStream;
  {$IFDEF VCLLIB}
  fc: TColor;
  {$ENDIF}
begin
  //                     Top Panel
  //-------------------------------------------------------
  FTopPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FTopPanel.Align := TAlignLayout.Top;
  FTopPanel.PanelPosition := eppTop;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FTopPanel.PanelPosition := eppCenter;
  FTopPanel.Align := alTop;
  {$ENDIF}
  FTopPanel.Parent := AParent;

  FTopPanel.Height := 37;

  FSeriesSelectCombo := TTMSFNCChartSeriesEditorComboBox.Create(FTopPanel);
  FSeriesSelectCombo.Parent := FTopPanel;
  FSeriesSelectCombo.Height := BIGHEIGHTSPAC;
  {$IFDEF FMXLIB}
  FSeriesSelectCombo.Position.X := BIGLBLSPACE;
  FSeriesSelectCombo.Position.Y := (FTopPanel.Height - FSeriesSelectCombo.Height) / 2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesSelectCombo.Left := BIGLBLSPACE;
  FSeriesSelectCombo.Top := 7;
  {$ENDIF}

  FSeriesSelectCombo.Width := LARGECONTROLWIDTH * 2;

  FSeriesButtonsPanel := TTMSFNCEditorPanel.Create(FTopPanel);
  {$IFDEF FMXLIB}
  FSeriesButtonsPanel.Align := TAlignLayout.Right;
  FSeriesButtonsPanel.PanelPosition := eppCenter;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonsPanel.PanelPosition := eppCenter;
  FSeriesButtonsPanel.Align := alRight;
  {$ENDIF}
  FSeriesButtonsPanel.Parent := FTopPanel;

  FAddSeriesButton := TTMSFNCEditorButton.Create(FSeriesButtonsPanel);
  FAddSeriesButton.Parent := FSeriesButtonsPanel;
  FAddSeriesButton.Text := '';
  FAddSeriesButton.Width := 26;
  FAddSeriesButton.Height := 26;
  FAddSeriesButton.BitmapMargins.Top := 2;
  FAddSeriesButton.BitmapMargins.Bottom := 2;
  FAddSeriesButton.BitmapMargins.Left := 2;
  FAddSeriesButton.BitmapMargins.Right := 2;
  FAddSeriesButton.ShowHint := True;
  {$IFDEF FMXLIB}
  FAddSeriesButton.Position.X := SMALLLBLSPACE;
  FAddSeriesButton.Position.Y := (FSeriesButtonsPanel.Height - FAddSeriesButton.Height)/2;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FAddSeriesButton.Left := SMALLLBLSPACE;
  FAddSeriesButton.Top := 5;
  {$ENDIF}
  FAddSeriesButton.Hint := TranslateTextEx(sTMSFNCChartSeriesEditorAdd);
  FAddSeriesButton.OnClick := @{$IFDEF LCLWEBLIB}@{$ENDIF}DoAddSeries;
  {$IFDEF WEBLIB}
  FAddSeriesButton.Bitmap.LoadFromResource(TTMSFNCADDBITMAP, HInstance);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCADDBITMAP));
  try
    FAddSeriesButton.Bitmap.LoadFromStream(bs);
  finally
    bs.Free
  end;
  {$ENDIF};

  FDeleteSeriesButton := TTMSFNCEditorButton.Create(FSeriesButtonsPanel);
  FDeleteSeriesButton.Parent := FSeriesButtonsPanel;
  FDeleteSeriesButton.Text := '';
  FDeleteSeriesButton.Width := 26;
  FDeleteSeriesButton.Height := 26;
  FDeleteSeriesButton.ShowHint := True;
  FDeleteSeriesButton.Hint := TranslateTextEx(sTMSFNCChartSeriesEditorRemove);
  FDeleteSeriesButton.OnClick := @{$IFDEF LCLWEBLIB}@{$ENDIF}DoDeleteSeries;
  {$IFDEF FMXLIB}
  FDeleteSeriesButton.Position.X := FAddSeriesButton.Position.X + FAddSeriesButton.Width + SMALLLBLSPACE;
  FDeleteSeriesButton.Position.Y := FAddSeriesButton.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FDeleteSeriesButton.Left := FAddSeriesButton.Left + FAddSeriesButton.Width + SMALLLBLSPACE;
  FDeleteSeriesButton.Top := FAddSeriesButton.Top;
  {$ENDIF}
  {$IFDEF WEBLIB}
  FDeleteSeriesButton.Bitmap.LoadFromResource(TTMSFNCREMOVEBITMAP, HInstance);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCREMOVEBITMAP));
  try
    FDeleteSeriesButton.Bitmap.LoadFromStream(bs);
  finally
    bs.Free
  end;
  {$ENDIF};

  FClearSeriesButton := TTMSFNCEditorButton.Create(FSeriesButtonsPanel);
  FClearSeriesButton.Parent := FSeriesButtonsPanel;
  FClearSeriesButton.Text := '';
  FClearSeriesButton.Height := 26;
  FClearSeriesButton.Width := 26;
  FClearSeriesButton.BitmapMargins.Top := 2;
  FClearSeriesButton.BitmapMargins.Bottom := 2;
  FClearSeriesButton.BitmapMargins.Left := 2;
  FClearSeriesButton.BitmapMargins.Right := 2;
  FClearSeriesButton.ShowHint := True;
  FClearSeriesButton.Hint := TranslateTextEx(sTMSFNCChartSeriesEditorClear);
  FClearSeriesButton.OnClick := @{$IFDEF LCLWEBLIB}@{$ENDIF}DoClearSeries;
  {$IFDEF FMXLIB}
  FClearSeriesButton.Position.X := FDeleteSeriesButton.Position.X + FDeleteSeriesButton.Width + SMALLLBLSPACE;
  FClearSeriesButton.Position.Y := FDeleteSeriesButton.Position.Y;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FClearSeriesButton.Left := FDeleteSeriesButton.Left + FDeleteSeriesButton.Width + SMALLLBLSPACE;
  FClearSeriesButton.Top := FDeleteSeriesButton.Top;
  {$ENDIF}
  {$IFDEF WEBLIB}
  FClearSeriesButton.Bitmap.LoadFromResource(TTMSFNCCLEARBITMAP, HInstance);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  bs := TBytesStream.Create(TTMSFNCUtils.Decode64ToBytes(TTMSFNCCLEARBITMAP));
  try
    FClearSeriesButton.Bitmap.LoadFromStream(bs);
  finally
    bs.Free
  end;
  {$ENDIF};

  {$IFDEF FMXLIB}
  FSeriesButtonsPanel.Width := FClearSeriesButton.Position.X + FClearSeriesButton.Width + SMALLLBLSPACE;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FSeriesButtonsPanel.Width := FClearSeriesButton.Left + FDeleteSeriesButton.Width + SMALLLBLSPACE;
  {$ENDIF}
  UpdateSeriesCombo;

  {$IFDEF VCLLIB}
  fc := TTMSFNCChartOpen(FChart).GetEditorButtonTextColor(FAddSeriesButton);
  if (fc <> clNone) and (fc <> EDITORPRIMCOLOR) then
  begin
    FAddSeriesButton.Bitmap.SVG.CustomFillColor := fc;
    FDeleteSeriesButton.Bitmap.SVG.CustomFillColor := fc;
    FClearSeriesButton.Bitmap.SVG.CustomFillColor := fc;
//    FAddSeriesButton.Appearance.Font.Color := fc;
  end;
  {$ENDIF}
end;

procedure TTMSFNCChartSeriesEditor.DoButtonOKClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if SaveChartMessage then
    {$ENDIF}
      frm.ModalResult := mrOk;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrOk;
    {$ENDIF}
  end;
end;

procedure TTMSFNCChartSeriesEditor.DoAddSeries(Sender: TObject);
var
  s: TTMSFNCChartSerie;
begin
  s := FChart.Series.Add;
  UpdateSeriesCombo(s.Index);
  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoAfterDraw(Sender: TObject;
  AGraphics: TTMSFNCGraphics; ARect: TRectF);
begin
  if (FSerieIndex >= 0) and (FSerieIndex < FChart.Series.Count) and Assigned(FChart.Series[FSerieIndex].Markers.Bitmap) and not IsBitmapEmpty(FChart.Series[FSerieIndex].Markers.Bitmap) then
  begin
    AGraphics.DrawBitmap(ARect, FChart.Series[FSerieIndex].Markers.Bitmap);
  end;
end;

procedure TTMSFNCChartSeriesEditor.DoChartSelectorClick(Sender: TObject);
begin
  FChartSelectorLine.Selected := False;
  FChartSelectorDigitalLine.Selected := False;
  FChartSelectorXYLine.Selected := False;
  FChartSelectorArea.Selected := False;
  FChartSelectorStackedArea.Selected := False;
  FChartSelectorStackedPercArea.Selected := False;
  FChartSelectorBand.Selected := False;
  FChartSelectorBar.Selected := False;
  FChartSelectorStackedBar.Selected := False;
  FChartSelectorPercBar.Selected := False;
  FChartSelectorOHLC.Selected := False;
  FChartSelectorCandleStick.Selected := False;
  FChartSelectorBoxPlot.Selected := False;
  FChartSelectorMarker.Selected := False;
  FChartSelectorXYMarker.Selected := False;
  FChartSelectorPie.Selected := False;
  FChartSelectorSizedPie.Selected := False;
  FChartSelectorVarRadiusPie.Selected := False;
  FChartSelectorSpider.Selected := False;

  TTMSFNCChartEditorSelector(Sender).Selected := True;

  if Assigned(FChart) and (FSerieIndex >= 0) and (FSerieIndex < FChart.Series.Count) then
  begin
    FChart.Series[FSerieIndex].ChartType := TTMSFNCChartEditorSelector(Sender).ChartType;
  end;
end;

procedure TTMSFNCChartSeriesEditor.DoClearSeries(Sender: TObject);
begin
  if ClearSeriesMessage then
  begin
    FChart.Series.Clear;
    FSerieIndex := -1;
    FPointIndex := -1;
    FAnnoIndex := -1;
    UpdateSeriesCombo;

    FModified := True;
  end;
end;

procedure TTMSFNCChartSeriesEditor.DoDeleteSeries(Sender: TObject);
begin
  if (FSerieIndex >= 0) and (FSerieIndex < FChart.Series.Count) then
  begin
    FChart.Series.Delete(FSerieIndex);
    UpdateSeriesCombo;

    FModified := True;
  end;
end;

procedure TTMSFNCChartSeriesEditor.DoButtonCancelClick(Sender: TObject);
begin
  if Assigned(frm) then
  begin
    {$IFNDEF WEBLIB}
    if FModified then
    begin
      if CancelChartMessage then
    {$ENDIF}
      frm.ModalResult := mrCancel;
    {$IFNDEF WEBLIB}
    end
    else
      frm.ModalResult := mrCancel;
    {$ENDIF}
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartSeriesEditor.ApplyCSS(ACSS: string);
begin
//  FButtonOK.ElementClassName := 'IDEButton IDEFont';
//  FButtonCancel.ElementClassName := 'IDEButton IDEFont';
//  FButtonOpen.ElementClassName := 'IDEButton IDEFont';
//  FButtonClear.ElementClassName := 'IDEButton IDEFont';
//
//  FTopPanel.ElementClassName := 'IDEBkg';
//  FPanel.ElementClassName := 'IDEBkg';
end;
{$ENDIF}

function TTMSFNCChartSeriesEditor.CancelChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartSeriesEditorCancelChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;


procedure TTMSFNCChartSeriesEditor.ClearSeriesEvents;
begin
  //  General Series Panel

  FSeriesSelectCombo.OnChange := nil;

  FGenSeriesFillKind.OnChange := nil;
  FGenSeriesFillGradient.OnChange := nil;
  {$IFDEF WEBLIB}
  FGenSeriesFillCol1.OnSelect := nil;
  FGenSeriesFillCol2.OnSelect := nil;
  FGenSeriesStrokeCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FGenSeriesFillCol1.OnChange := nil;
  FGenSeriesFillCol2.OnChange := nil;
  FGenSeriesStrokeCol.OnChange := nil;
  {$ENDIF}
  {$IFDEF FMXLIB}
  FGenSeriesFillOpacity.OnChange := nil;
  FGenSeriesStrokeOpacity.OnChange := nil;
  {$ENDIF}
  FGenSeriesStrokeWidth.OnChange := nil;
  FGenSeriesStrokeKind.OnChange := nil;

  FGenSeriesOffsetX.OnChange := nil;
  FGenSeriesOffsetY.OnChange := nil;
  {$IFDEF FMXLIB}
  FGenSeriesEnabledCheck.OnChange := nil;
  FGenSeriesEnabledCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenSeriesEnabledCheck.OnClick := nil;
  FGenSeriesEnabledCheck.OnClick := nil;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FGenSeriesVisibleCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenSeriesVisibleCheck.OnClick := nil;
  {$ENDIF}
  FGenSeriesGroup.OnChange := nil;
  FGenSeriesMode.OnChange := nil;

  FGenSeriesXRange.OnChange := nil;
  FGenSeriesYRange.OnChange := nil;
  FGenSeriesZRV.OnChange := nil;

  FGenSeriesMinX.OnChange := nil;
  FGenSeriesMinY.OnChange := nil;
  FGenSeriesMaxX.OnChange := nil;
  FGenSeriesMaxY.OnChange := nil;

  FGenSeriesMinXOff.OnChange := nil;
  FGenSeriesMaxXOff.OnChange := nil;
  FGenSeriesMinYOff.OnChange := nil;
  FGenSeriesMaxYOff.OnChange := nil;

//  FGenSeriesBarType.OnChange := nil;
//  FGenSeriesBarWidth.OnChange := nil;
//  FGenSeriesBarSpacing.OnChange := nil;
//
//  FGenSeriesMultiType.OnChange := nil;
//  FGenSeriesMultiWidth.OnChange := nil;
//  {$IFDEF WEBLIB}
//  FGenSeriesIncFill.OnSelect := nil;
//  FGenSeriesIncStroke.OnSelect := nil;
//  FGenSeriesDecFill.OnSelect := nil;
//  FGenSeriesDecStroke.OnSelect := nil;
//  {$ENDIF}
//  {$IFNDEF WEBLIB}
//  FGenSeriesIncFill.OnChange := nil;
//  FGenSeriesIncStroke.OnChange := nil;
//  FGenSeriesDecFill.OnChange := nil;
//  FGenSeriesDecStroke.OnChange := nil;
//  {$ENDIF}

  FGenSeriesFactor.OnChange := nil;
  {$IFDEF FMXLIB}
  FGenSeriesFlowCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenSeriesFlowCheck.OnClick := nil;
  {$ENDIF}

  //  Legend Series Panel
  FLegSeriesValue.OnChange := nil;
  FLegSeriesAppLeft.OnChange := nil;
  FLegSeriesAppTop.OnChange := nil;
  {$IFDEF FMXLIB}
  FLegSeriesVisibleCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegSeriesVisibleCheck.OnClick := nil;
  {$ENDIF}

  FLegSeriesFillKind.OnChange := nil;
  FLegSeriesFillGradient.OnChange := nil;
  {$IFDEF FMXLIB}
  FLegSeriesFillOpacity.OnChange := nil;
  FLegSeriesStrokeOpacity.OnChange := nil;
  {$ENDIF}
  FLegSeriesStrokeWidth.OnChange := nil;
  FLegSeriesStrokeKind.OnChange := nil;

  {$IFDEF WEBLIB}
  FLegSeriesFillCol1.OnSelect := nil;
  FLegSeriesFillCol2.OnSelect := nil;
  FLegSeriesFontCol.OnSelect := nil;
  FLegSeriesStrokeCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FLegSeriesFillCol1.OnChange := nil;
  FLegSeriesFillCol2.OnChange := nil;
  FLegSeriesFontCol.OnChange := nil;
  FLegSeriesStrokeCol.OnChange := nil;
  {$ENDIF}

  FLegSeriesFontName.OnChange := nil;
  FLegSeriesSize.OnChange := nil;

  FLegSeriesText.OnChange := nil;
  {$IFDEF FMXLIB}
  FLegSeriesShowCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegSeriesShowCheck.OnClick := nil;
  {$ENDIF}

  // Label Series Panel
  FLabelSeriesOffsetX.OnChange := nil;
  FLabelSeriesOffsetY.OnChange := nil;
  {$IFDEF FMXLIB}
  FLabelSeriesVisibleCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLabelSeriesVisibleCheck.OnClick := nil;
  {$ENDIF}

  FLabelSeriesFillKind.OnChange := nil;
  FLabelSeriesFillGradient.OnChange := nil;
  {$IFDEF FMXLIB}
  FLabelSeriesFillOpacity.OnChange := nil;
  FLabelSeriesStrokeOpacity.OnChange := nil;
  {$ENDIF}
  FLabelSeriesStrokeWidth.OnChange := nil;
  FLabelSeriesStrokeKind.OnChange := nil;

  {$IFDEF WEBLIB}
  FLabelSeriesFillCol1.OnSelect := nil;
  FLabelSeriesFillCol2.OnSelect := nil;
  FLabelSeriesStrokeCol.OnSelect := nil;
  FLabelSeriesFontCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FLabelSeriesFillCol1.OnChange := nil;
  FLabelSeriesFillCol2.OnChange := nil;
  FLabelSeriesStrokeCol.OnChange := nil;
  FLabelSeriesFontCol.OnChange := nil;
  {$ENDIF}

  FLabelSeriesFontName.OnChange := nil;
  FLabelSeriesSize.OnChange := nil;

  FLabelSeriesType.OnChange := nil;
  FLabelSeriesMode.OnChange := nil;
  FLabelSeriesText.OnChange := nil;

  // Markes Series Panel
  FMarkersSeriesWidth.OnChange := nil;
  FMarkersSeriesHeight.OnChange := nil;
  {$IFDEF FMXLIB}
  FMarkersSeriesVisibleCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FMarkersSeriesVisibleCheck.OnClick := nil;
  {$ENDIF}

  FMarkersSeriesFillKind.OnChange := nil;
  FMarkersSeriesFillGradient.OnChange := nil;
  {$IFDEF FMXLIB}
  FMarkersSeriesFillOpacity.OnChange := nil;
  {$ENDIF}

  {$IFDEF WEBLIB}
  FMarkersSeriesFillCol1.OnSelect := nil;
  FMarkersSeriesFillCol2.OnSelect := nil;
  FMarkersSeriesStrokeCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FMarkersSeriesFillCol1.OnChange := nil;
  FMarkersSeriesFillCol2.OnChange := nil;
  FMarkersSeriesStrokeCol.OnChange := nil;
  {$ENDIF}

  FMarkersSeriesStrokeKind.OnChange := nil;
  FMarkersSeriesStrokeWidth.OnChange := nil;
  {$IFDEF FMXLIB}
  FMarkersSeriesStrokeOpacity.OnChange := nil;
  {$ENDIF}

  FMarkersSeriesShape.OnChange := nil;

  // X-Grid Series Panel
  {$IFDEF FMXLIB}
  FXGridSeriesVisibleCheck.OnChange := nil;
  FXGridSeriesExtendedCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXGridSeriesVisibleCheck.OnClick := nil;
  FXGridSeriesExtendedCheck.OnClick := nil;
  {$ENDIF}

  FXGridSeriesMajorStrokeKind.OnChange := nil;
  FXGridSeriesMajorStrokeWidth.OnChange := nil;
  {$IFDEF FMXLIB}
  FXGridSeriesMajorStrokeOpacity.OnChange := nil;
  {$ENDIF}

  FXGridSeriesMinorStrokeKind.OnChange := nil;
  FXGridSeriesMinorStrokeWidth.OnChange := nil;
  {$IFDEF FMXLIB}
  FXGridSeriesMinorStrokeOpacity.OnChange := nil;
  {$ENDIF}

  {$IFDEF WEBLIB}
  FXGridSeriesMajorStrokeCol.OnSelect := nil;
  FXGridSeriesMinorStrokeCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FXGridSeriesMajorStrokeCol.OnChange := nil;
  FXGridSeriesMinorStrokeCol.OnChange := nil;
  {$ENDIF}

  // X-Values Series Panel
  FXValSeriesAngle.OnChange := nil;
  FXValSeriesMajSpacing.OnChange := nil;
  FXValSeriesMinSpacing.OnChange := nil;
  {$IFDEF FMXLIB}
  FXValSeriesTopCheck.OnChange := nil;
  FXValSeriesCenterCheck.OnChange := nil;
  FXValSeriesBottomCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXValSeriesTopCheck.OnClick := nil;
  FXValSeriesCenterCheck.OnClick := nil;
  FXValSeriesBottomCheck.OnClick := nil;
  {$ENDIF}

  FXValSeriesMajFontName.OnChange := nil;
  FXValSeriesMajFontSize.OnChange := nil;

  FXValSeriesMinFontName.OnChange := nil;
  FXValSeriesMinFontSize.OnChange := nil;

  FXValSeriesMajTickSize.OnChange := nil;

  FXValSeriesMinTickSize.OnChange := nil;

  {$IFDEF WEBLIB}
  FXValSeriesMajFontCol.OnSelect := nil;
  FXValSeriesMinFontCol.OnSelect := nil;
  FXValSeriesMajTickCol.OnSelect := nil;
  FXValSeriesMinTickCol.OnSelect := nil;
  FXValSeriesTitleFontCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FXValSeriesMajFontCol.OnChange := nil;
  FXValSeriesMinFontCol.OnChange := nil;
  FXValSeriesMajTickCol.OnChange := nil;
  FXValSeriesMinTickCol.OnChange := nil;
  FXValSeriesTitleFontCol.OnChange := nil;
  {$ENDIF}

  FXValSeriesUnitMajor.OnChange := nil;
  FXValSeriesUnitMinor.OnChange := nil;
  {$IFDEF FMXLIB}
  FXValSeriesAutoCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXValSeriesAutoCheck.OnClick := nil;
  {$ENDIF}

  FXValSeriesMajFormatType.OnChange := nil;
  FXValSeriesMajFormatValue.OnChange := nil;
  FXValSeriesMinFormatType.OnChange := nil;
  FXValSeriesMinFormatValue.OnChange := nil;

  FXValSeriesTitleValue.OnChange := nil;
  FXValSeriesTitleHAlign.OnChange := nil;
  FXValSeriesTitleVAlign.OnChange := nil;

  FXValSeriesTextLeft.OnChange := nil;
  FXValSeriesTextTop.OnChange := nil;
  FXValSeriesTextRight.OnChange := nil;
  FXValSeriesTextBottom.OnChange := nil;

  FXValSeriesTitleFontName.OnChange := nil;
  FXValSeriesTitleFontSize.OnChange := nil;

  // X-Values SmartLabels
  {$IFDEF FMXLIB}
  FXValSeriesSmartEnabledCheck.OnChange := nil;
  FXValSeriesSmartAutoRotateCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXValSeriesSmartEnabledCheck.OnClick := nil;
  FXValSeriesSmartAutoRotateCheck.OnClick := nil;
  {$ENDIF}
  FXValSeriesSmartMinSpacing.OnChange := nil;
  FXValSeriesSmartMinLabels.OnChange := nil;
  FXValSeriesSmartMaxLabels.OnChange := nil;

  // Y-Grid Series Panel
  {$IFDEF FMXLIB}
  FYGridSeriesVisibleCheck.OnChange := nil;
  FYGridSeriesExtendedCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYGridSeriesVisibleCheck.OnClick := nil;
  FYGridSeriesExtendedCheck.OnClick := nil;
  {$ENDIF}

  FYGridSeriesMajorStrokeKind.OnChange := nil;
  FYGridSeriesMajorStrokeWidth.OnChange := nil;
  {$IFDEF FMXLIB}
  FYGridSeriesMajorStrokeOpacity.OnChange := nil;
  {$ENDIF}

  FYGridSeriesMinorStrokeKind.OnChange := nil;
  FYGridSeriesMinorStrokeWidth.OnChange := nil;
  {$IFDEF FMXLIB}
  FYGridSeriesMinorStrokeOpacity.OnChange := nil;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FYGridSeriesSpiderVisibleCheck.OnChange := nil;
  FYGridSeriesLegendTextCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYGridSeriesSpiderVisibleCheck.OnClick := nil;
  FYGridSeriesLegendTextCheck.OnClick := nil;
  {$ENDIF}
  FYGridSeriesSpiderKind.OnChange := nil;

  {$IFDEF WEBLIB}
  FYGridSeriesMajorStrokeCol.OnSelect := nil;
  FYGridSeriesMinorStrokeCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FYGridSeriesMajorStrokeCol.OnChange := nil;
  FYGridSeriesMinorStrokeCol.OnChange := nil;
  {$ENDIF}

  // Y-Values Series Panel
  FYValSeriesMajSpacing.OnChange := nil;
  FYValSeriesMinSpacing.OnChange := nil;
  {$IFDEF FMXLIB}
  FYValSeriesLeftCheck.OnChange := nil;
  FYValSeriesCenterCheck.OnChange := nil;
  FYValSeriesRightCheck.OnChange := nil;
  FYValSeriesValuesCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYValSeriesLeftCheck.OnClick := nil;
  FYValSeriesCenterCheck.OnClick := nil;
  FYValSeriesRightCheck.OnClick := nil;
  FYValSeriesValuesCheck.OnClick := nil;
  {$ENDIF}

  FYValSeriesMajFontName.OnChange := nil;
  FYValSeriesMajFontSize.OnChange := nil;

  FYValSeriesMinFontName.OnChange := nil;
  FYValSeriesMinFontSize.OnChange := nil;

  FYValSeriesMajTickSize.OnChange := nil;
  FYValSeriesMinTickSize.OnChange := nil;

  {$IFDEF WEBLIB}
  FYValSeriesMajFontCol.OnSelect := nil;
  FYValSeriesMinFontCol.OnSelect := nil;
  FYValSeriesMajTickCol.OnSelect := nil;
  FYValSeriesMinTickCol.OnSelect := nil;
  FYValSeriesTitleFontCol.OnSelect := nil;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FYValSeriesMajFontCol.OnChange := nil;
  FYValSeriesMinFontCol.OnChange := nil;
  FYValSeriesMajTickCol.OnChange := nil;
  FYValSeriesMinTickCol.OnChange := nil;
  FYValSeriesTitleFontCol.OnChange := nil;
  {$ENDIF}

  FYValSeriesUnitMajor.OnChange := nil;
  FYValSeriesUnitMinor.OnChange := nil;
  {$IFDEF FMXLIB}
  FYValSeriesAutoCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYValSeriesAutoCheck.OnClick := nil;
  {$ENDIF}

  FYValSeriesMajFormatType.OnChange := nil;
  FYValSeriesMajFormatValue.OnChange := nil;
  FYValSeriesMinFormatType.OnChange := nil;
  FYValSeriesMinFormatValue.OnChange := nil;

  FYValSeriesTitleValue.OnChange := nil;
  FYValSeriesTitleHAlign.OnChange := nil;
  FYValSeriesTitleVAlign.OnChange := nil;

  FYValSeriesTextLeft.OnChange := nil;
  FYValSeriesTextTop.OnChange := nil;
  FYValSeriesTextRight.OnChange := nil;
  FYValSeriesTextBottom.OnChange := nil;

  FYValSeriesTitleFontName.OnChange := nil;
  FYValSeriesTitleFontSize.OnChange := nil;

  // Y-Values SmartLabels
  {$IFDEF FMXLIB}
  FYValSeriesSmartEnabledCheck.OnChange := nil;
  FYValSeriesSmartAutoRotateCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYValSeriesSmartEnabledCheck.OnClick := nil;
  FYValSeriesSmartAutoRotateCheck.OnClick := nil;
  {$ENDIF}
  FYValSeriesSmartMinSpacing.OnChange := nil;
  FYValSeriesSmartMinLabels.OnChange := nil;
  FYValSeriesSmartMaxLabels.OnChange := nil;

   // Pie Series Panel
  FPieSeriesLeft.OnChange := nil;
  FPieSeriesTop.OnChange := nil;
  FPieSeriesRight.OnChange := nil;
  FPieSeriesBottom.OnChange := nil;

  FPieSeriesSize.OnChange := nil;
  FPieSeriesInnerSize.OnChange := nil;
  FPieSeriesStartAngle.OnChange := nil;
  FPieSeriesSweepAngle.OnChange := nil;
  {$IFDEF FMXLIB}
  FPieSeriesAutoSizeCheck.OnChange := nil;
  FPieSeriesStackedCheck.OnChange := nil;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FPieSeriesAutoSizeCheck.OnClick := nil;
  FPieSeriesStackedCheck.OnClick := nil;
  {$ENDIF}
  FPieSeriesPosition.OnChange := nil;
end;

function TTMSFNCChartSeriesEditor.ClearSeriesMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;

  res := TTMSFNCUtils.Message(sTMSFNCChartSeriesEditorClearSeriesMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

constructor TTMSFNCChartSeriesEditor.Create(AOwner: TComponent);
begin
  inherited;
  FBitmapEditor := TTMSFNCBitmapEditor.Create(Self);
end;

procedure TTMSFNCChartSeriesEditor.CreateBottomPanel(AParent: TTMSFNCChartSeriesEditorParent);
begin
  FPanel := TTMSFNCEditorPanel.Create(AParent);
  {$IFDEF FMXLIB}
  FPanel.Align := TAlignLayout.Bottom;
  FPanel.PanelPosition := eppBottom;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FPanel.PanelPosition := eppCenter;
  FPanel.Align := alBottom;
  {$ENDIF}
  FPanel.Parent := AParent;

  FPanel.Height := 37;

  FButtonCancel := TTMSFNCEditorButton.Create(FPanel);
//    FButtonCancel.ModalResult := mrCancel;
  FButtonCancel.Parent := FPanel;
  FButtonCancel.Text := TranslateTextEx(sTMSFNCChartSeriesEditorCancel);
  {$IFDEF FMXLIB}
  FButtonCancel.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonCancel.Align := alRight;
  FButtonCancel.Left := 99;
  {$IFDEF VCLWEBLIB}
  FButtonCancel.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonCancel.BorderSpacing.Right := 5;
  FButtonCancel.BorderSpacing.Top := 5;
  FButtonCancel.BorderSpacing.Bottom := 5;
  FButtonCancel.BorderSpacing.Left := 5;
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonCancel.Margins.Right := 5;
  FButtonCancel.Margins.Top := 5;
  FButtonCancel.Margins.Bottom := 5;
  FButtonCancel.Margins.Left := 5;
  {$ENDIF}
  FButtonCancel.OnClick := @DoButtonCancelClick;

  FButtonOK := TTMSFNCEditorButton.Create(FPanel);
//    FButtonOK.ModalResult := mrOk;
  FButtonOK.Parent := FPanel;
  FButtonOK.Text := TranslateTextEx(sTMSFNCChartSeriesEditorOK);
  {$IFDEF FMXLIB}
  FButtonOk.Align := TAlignLayout.Right;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  FButtonOk.Align := alRight;
  FButtonOk.Left := 98;
  {$IFDEF VCLWEBLIB}
  FButtonOK.AlignWithMargins := True;
  {$ENDIF}
  {$ENDIF}
  {$IFNDEF LCLLIB}
  FButtonOK.Margins.Right := 0;
  FButtonOK.Margins.Top := 5;
  FButtonOK.Margins.Bottom := 5;
  FButtonOK.Margins.Left := 5;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FButtonOK.BorderSpacing.Right := 0;
  FButtonOK.BorderSpacing.Top := 5;
  FButtonOK.BorderSpacing.Bottom := 5;
  FButtonOK.BorderSpacing.Left := 5;
  {$ENDIF}
  FButtonOK.OnClick := @DoButtonOKClick;
end;

destructor TTMSFNCChartSeriesEditor.Destroy;
begin
  FBitmapEditor.Free;
  inherited;
end;

{$IFNDEF FMXLIB}
procedure TTMSFNCChartSeriesEditor.DoFormKeyDown(Sender: TObject; var Key: Word; Shift: TShiftState);
{$ENDIF}
{$IFDEF FMXLIB}
procedure TTMSFNCChartSeriesEditor.DoFormKeyDown(Sender: TObject; var Key: Word; var KeyChar: Char; Shift: TShiftState);
{$ENDIF}
begin
  inherited;

  if Key = KEY_ESCAPE then
    DoButtonCancelClick(Self)
  else if Key = KEY_RETURN then
    DoButtonOKClick(Self);
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeries3DChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Offset3DX := FGenSeriesOffsetX.Value;
  FChart.Series[FSerieIndex].Offset3DY := FGenSeriesOffsetY.Value;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Enable3D := FGenSeriesEnabledCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Enable3D := FGenSeriesEnabledCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesAnimationChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].AnimationFactor := FGenSeriesFactor.Value;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].AnimationFlow := FGenSeriesFlowCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].AnimationFlow := FGenSeriesFlowCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesBarChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Bar.WidthType := TTMSFNCChartSerieBarWidthType(FGenSeriesBarType.ItemIndex);
  FChart.Series[FSerieIndex].Bar.Width := FGenSeriesBarWidth.Value;
  FChart.Series[FSerieIndex].Bar.Spacing := FGenSeriesBarSpacing.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesFillChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Fill.Kind := TTMSFNCGraphicsFillKind(FGenSeriesFillKind.ItemIndex);
  FChart.Series[FSerieIndex].Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FGenSeriesFillGradient.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Fill.Opacity := FGenSeriesFillOpacity.Value;
  FChart.Series[FSerieIndex].Fill.Color := FGenSeriesFillCol1.Color;
  FChart.Series[FSerieIndex].Fill.ColorTo := FGenSeriesFillCol2.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Fill.Color := FGenSeriesFillCol1.Selected;
  FChart.Series[FSerieIndex].Fill.ColorTo := FGenSeriesFillCol2.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesMultiPointChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].MultiPoint.WidthType := TTMSFNCChartSerieBarWidthType(FGenSeriesMultiType.ItemIndex);
  FChart.Series[FSerieIndex].MultiPoint.Width := FGenSeriesMultiWidth.Value;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].MultiPoint.IncreaseFillColor := FGenSeriesIncFill.Color;
  FChart.Series[FSerieIndex].MultiPoint.IncreaseStrokeColor := FGenSeriesIncStroke.Color;
  FChart.Series[FSerieIndex].MultiPoint.DecreaseFillColor := FGenSeriesDecFill.Color;
  FChart.Series[FSerieIndex].MultiPoint.DecreaseStrokeColor := FGenSeriesDecStroke.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].MultiPoint.IncreaseFillColor := FGenSeriesIncFill.Selected;
  FChart.Series[FSerieIndex].MultiPoint.IncreaseStrokeColor := FGenSeriesIncStroke.Selected;
  FChart.Series[FSerieIndex].MultiPoint.DecreaseFillColor := FGenSeriesDecFill.Selected;
  FChart.Series[FSerieIndex].MultiPoint.DecreaseStrokeColor := FGenSeriesDecStroke.Selected;
  {$ENDIF}
  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesOtherChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Visible := FGenSeriesVisibleCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Visible := FGenSeriesVisibleCheck.Checked;
  {$ENDIF}
  FChart.Series[FSerieIndex].GroupIndex := Round(FGenSeriesGroup.Value);
  FChart.Series[FSerieIndex].Mode := TTMSFNCChartSerieMode(FGenSeriesMode.ItemIndex);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesRangeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].AutoXRange := TTMSFNCChartSerieAutoRange(FGenSeriesXRange.ItemIndex);
  FChart.Series[FSerieIndex].AutoYRange := TTMSFNCChartSerieAutoRange(FGenSeriesYRange.ItemIndex);
  FChart.Series[FSerieIndex].ZeroReferenceValue := FGenSeriesZRV.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesRangeMinMax(Sender: TObject);
begin
  FChart.Series[FSerieIndex].MinX := FGenSeriesMinX.Value;
  FChart.Series[FSerieIndex].MinY := FGenSeriesMinY.Value;
  FChart.Series[FSerieIndex].MaxX := FGenSeriesMaxX.Value;
  FChart.Series[FSerieIndex].MaxY := FGenSeriesMaxY.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesRangeOffsetChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].MinXOffsetPercentage := FGenSeriesMinXOff.Value;
  FChart.Series[FSerieIndex].MaxXOffsetPercentage := FGenSeriesMaxXOff.Value;
  FChart.Series[FSerieIndex].MinYOffsetPercentage := FGenSeriesMinYOff.Value;
  FChart.Series[FSerieIndex].MaxYOffsetPercentage := FGenSeriesMaxYOff.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoGenSeriesStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Stroke.Kind := TTMSFNCGraphicsStrokeKind(FGenSeriesStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Stroke.Color := FGenSeriesStrokeCol.Color;
  FChart.Series[FSerieIndex].Stroke.Opacity := FGenSeriesStrokeOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Stroke.Color := FGenSeriesStrokeCol.Selected;
  {$ENDIF}
  FChart.Series[FSerieIndex].Stroke.Width := FGenSeriesStrokeWidth.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLblSeriesFillChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Labels.Fill.Kind := TTMSFNCGraphicsFillKind(FLabelSeriesFillKind.ItemIndex);
  FChart.Series[FSerieIndex].Labels.Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FLabelSeriesFillGradient.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Fill.Color := FLabelSeriesFillCol1.Color;
  FChart.Series[FSerieIndex].Labels.Fill.ColorTo := FLabelSeriesFillCol2.Color;
  FChart.Series[FSerieIndex].Labels.Fill.Opacity := FLabelSeriesFillOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Fill.Color := FLabelSeriesFillCol1.Selected;
  FChart.Series[FSerieIndex].Labels.Fill.ColorTo := FLabelSeriesFillCol2.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLblSeriesFontChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Font.Color := FLabelSeriesFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Font.Color := FLabelSeriesFontCol.Selected;
  {$ENDIF}
  FChart.Series[FSerieIndex].Labels.Font.Name := FLabelSeriesFontName.Items[FLabelSeriesFontName.ItemIndex];
  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].Labels.Font.Size := FLabelSeriesSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].Labels.Font.Size := Round(FLabelSeriesSize.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLblSeriesFormatChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Labels.FormatType := TTMSFNCChartSerieValueFormatType(FLabelSeriesType.ItemIndex);
  FChart.Series[FSerieIndex].Labels.Mode := TTMSFNCChartSerieLabelsMode(FLabelSeriesMode.ItemIndex);
  FChart.Series[FSerieIndex].Labels.Format := FLabelSeriesText.Text;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLblSeriesPositionChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Labels.OffsetX := FLabelSeriesOffsetX.Value;
  FChart.Series[FSerieIndex].Labels.OffsetY := FLabelSeriesOffsetY.Value;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Visible := FLabelSeriesVisibleCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Visible := FLabelSeriesVisibleCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLblSeriesStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Labels.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FLabelSeriesStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Stroke.Color := FLabelSeriesStrokeCol.Color;
  FChart.Series[FSerieIndex].Labels.Stroke.Opacity := FLabelSeriesStrokeOpacity.Value;
  FChart.Series[FSerieIndex].Labels.Stroke.Width := FLabelSeriesStrokeWidth.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Labels.Stroke.Color := FLabelSeriesStrokeCol.Selected;
  FChart.Series[FSerieIndex].Labels.Stroke.Width := Trunc(FLabelSeriesStrokeWidth.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLegSeriesFillChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Legend.Fill.Kind := TTMSFNCGraphicsFillKind(FLegSeriesFillKind.ItemIndex);
  FChart.Series[FSerieIndex].Legend.Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FLegSeriesFillGradient.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Fill.Color := FLegSeriesFillCol1.Color;
  FChart.Series[FSerieIndex].Legend.Fill.ColorTo := FLegSeriesFillCol2.Color;
  FChart.Series[FSerieIndex].Legend.Fill.Opacity := FLegSeriesFillOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Fill.Color := FLegSeriesFillCol1.Selected;
  FChart.Series[FSerieIndex].Legend.Fill.ColorTo := FLegSeriesFillCol2.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLegSeriesFontChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Legend.Font.Name := FLegSeriesFontName.Items[FLegSeriesFontName.ItemIndex];
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Font.Color := FLegSeriesFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Font.Color := FLegSeriesFontCol.Selected;
  {$ENDIF}

  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].Legend.Font.Size := FLegSeriesSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].Legend.Font.Size := Round(FLegSeriesSize.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLegSeriesPositionChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Legend.Position := TTMSFNCChartLegendPosition(FLegSeriesValue.ItemIndex);
  FChart.Series[FSerieIndex].Legend.Left := FLegSeriesAppLeft.Value;
  FChart.Series[FSerieIndex].Legend.Top := FLegSeriesAppTop.Value;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Visible := FLegSeriesVisibleCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Visible := FLegSeriesVisibleCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLegSeriesStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Legend.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FLegSeriesStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Stroke.Color := FLegSeriesStrokeCol.Color;
  FChart.Series[FSerieIndex].Legend.Stroke.Opacity := FLegSeriesStrokeOpacity.Value;
  FChart.Series[FSerieIndex].Legend.Stroke.Width := FLegSeriesStrokeWidth.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Legend.Stroke.Color := FLegSeriesStrokeCol.Selected;
  FChart.Series[FSerieIndex].Legend.Stroke.Width := Trunc(FLegSeriesStrokeWidth.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoLegSeriesTextChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].LegendText := FLegSeriesText.Text;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].ShowInLegend := FLegSeriesShowCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].ShowInLegend := FLegSeriesShowCheck.Checked;
  {$ENDIF}

  FModified := True;
end;
procedure TTMSFNCChartSeriesEditor.DoMarkersSeriesFillChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Markers.Fill.Kind := TTMSFNCGraphicsFillKind(FMarkersSeriesFillKind.ItemIndex);
  FChart.Series[FSerieIndex].Markers.Fill.GradientOrientation := TTMSFNCGraphicsFillOrientation(FMarkersSeriesFillGradient.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Markers.Fill.Color := FMarkersSeriesFillCol1.Color;
  FChart.Series[FSerieIndex].Markers.Fill.ColorTo := FMarkersSeriesFillCol2.Color;
  FChart.Series[FSerieIndex].Markers.Fill.Opacity := FMarkersSeriesFillOpacity.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Markers.Fill.Color := FMarkersSeriesFillCol1.Selected;
  FChart.Series[FSerieIndex].Markers.Fill.ColorTo := FMarkersSeriesFillCol2.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoMarkersSeriesShapeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Markers.Shape := TTMSFNCChartSerieMarkerShape(FMarkersSeriesShape.ItemIndex);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoMarkersSeriesSizeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Markers.Width := FMarkersSeriesWidth.Value;
  FChart.Series[FSerieIndex].Markers.Height := FMarkersSeriesHeight.Value;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Markers.Visible := FMarkersSeriesVisibleCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Markers.Visible := FMarkersSeriesVisibleCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoMarkersSeriesStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Markers.Stroke.Kind := TTMSFNCGraphicsStrokeKind(FMarkersSeriesStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Markers.Stroke.Color := FMarkersSeriesStrokeCol.Color;
  FChart.Series[FSerieIndex].Markers.Stroke.Opacity := FMarkersSeriesStrokeOpacity.Value;
  FChart.Series[FSerieIndex].Markers.Stroke.Width := FMarkersSeriesStrokeWidth.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Markers.Stroke.Color := FMarkersSeriesStrokeCol.Selected;
  FChart.Series[FSerieIndex].Markers.Stroke.Width := Trunc(FMarkersSeriesStrokeWidth.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoOpenFile(Sender: TObject);
begin
  if (FSerieIndex >= 0) and (FSerieIndex < FChart.Series.Count) then
  begin
  FBitmapEditor.Bitmap := FChart.Series[FSerieIndex].Markers.Bitmap;
  {$IFDEF WEBLIB}
  FBitmapEditor.Execute(@AssignBitmapCallBack);
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FBitmapEditor.Execute;
  Invalidate;
  {$ENDIF}
  end;
end;

{$IFDEF WEBLIB}
procedure TTMSFNCChartSeriesEditor.AssignBitmapCallback(AValue: TModalResult);
begin
  if (AValue = mrOk) and (FSerieIndex >= 0) and (FSerieIndex < FChart.Series.Count) then
  begin
    FChart.Series[FSerieIndex].Markers.Bitmap.Assign(FBitmapEditor.Bitmap);
  end;

  Invalidate;
end;
{$ENDIF}

procedure TTMSFNCChartSeriesEditor.DoPieSeriesLayoutChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Pie.Size := FPieSeriesSize.Value;
  FChart.Series[FSerieIndex].Pie.InnerSize := FPieSeriesInnerSize.Value;
  FChart.Series[FSerieIndex].Pie.StartAngle := FPieSeriesStartAngle.Value;
  FChart.Series[FSerieIndex].Pie.SweepAngle := FPieSeriesSweepAngle.Value;

  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].Pie.AutoSize := FPieSeriesAutoSizeCheck.IsChecked;
  FChart.Series[FSerieIndex].Pie.Stacked := FPieSeriesStackedCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].Pie.AutoSize := FPieSeriesAutoSizeCheck.Checked;
  FChart.Series[FSerieIndex].Pie.Stacked := FPieSeriesStackedCheck.Checked;
  {$ENDIF}
  FChart.Series[FSerieIndex].Pie.Position := TTMSFNCChartSeriePiePosition(FPieSeriesPosition.ItemIndex);
end;

procedure TTMSFNCChartSeriesEditor.DoPieSeriesMarginsChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].Pie.Margins.Left := Round(FPieSeriesLeft.Value);
  FChart.Series[FSerieIndex].Pie.Margins.Top := Round(FPieSeriesTop.Value);
  FChart.Series[FSerieIndex].Pie.Margins.Right := Round(FPieSeriesRight.Value);
  FChart.Series[FSerieIndex].Pie.Margins.Bottom := Round(FPieSeriesBottom.Value);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoSeriesChangeTab(Sender: TObject);
begin
  if FSeriesButtonGeneral.Selected or FSeriesButtonLegend.Selected or FSeriesButtonType.Selected or FSeriesButtonLabels.Selected or FSeriesButtonMarkers.Selected
    or FSeriesButtonXGrid.Selected or FSeriesButtonXValues.Selected or FSeriesButtonYGrid.Selected or FSeriesButtonYValues.Selected or FSeriesButtonPie.Selected then
  begin
    FSeriesGeneralPanel.Visible := FSeriesButtonGeneral.Selected;
    FSeriesLegendPanel.Visible := FSeriesButtonLegend.Selected;
    FSeriesTypePanel.Visible := FSeriesButtonType.Selected;
    FSeriesLabelsPanel.Visible := FSeriesButtonLabels.Selected;
    FSeriesMarkersPanel	.Visible := FSeriesButtonMarkers.Selected;
    FSeriesXGridPanel.Visible := FSeriesButtonXGrid.Selected;
    FSeriesXValuesPanel.Visible := FSeriesButtonXValues.Selected;
    FSeriesYGridPanel.Visible := FSeriesButtonYGrid.Selected;
    FSeriesYValuesPanel.Visible := FSeriesButtonYValues.Selected;
    FSeriesPiePanel.Visible := FSeriesButtonPie.Selected;
  end
  else
  begin
    FSeriesButtonGeneral.Selected := FSeriesGeneralPanel.Visible;
    FSeriesButtonLegend.Selected := FSeriesLegendPanel.Visible;
    FSeriesButtonType.Selected := FSeriesTypePanel.Visible;
    FSeriesButtonLabels.Selected := FSeriesLabelsPanel.Visible;
    FSeriesButtonMarkers.Selected := FSeriesMarkersPanel.Visible;
    FSeriesButtonXGrid.Selected := FSeriesXGridPanel.Visible;
    FSeriesButtonXValues.Selected := FSeriesXValuesPanel.Visible;
    FSeriesButtonYGrid.Selected := FSeriesYGridPanel.Visible;
    FSeriesButtonYValues.Selected := FSeriesYValuesPanel.Visible;
    FSeriesButtonPie.Selected := FSeriesPiePanel.Visible;
  end;
end;

procedure TTMSFNCChartSeriesEditor.DoSeriesComboChange(Sender: TObject);
begin
  FSerieIndex := FSeriesSelectCombo.ItemIndex;
  InitSeriesValues;
end;

procedure TTMSFNCChartSeriesEditor.DoXGridSeriesMajorStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Kind := TTMSFNCGraphicsStrokeKind(FXGridSeriesMajorStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Color := FXGridSeriesMajorStrokeCol.Color;
  FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Opacity := FXGridSeriesMajorStrokeOpacity.Value;
  FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Width := FXGridSeriesMajorStrokeWidth.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Color := FXGridSeriesMajorStrokeCol.Selected;
  FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Width := Trunc(FXGridSeriesMajorStrokeWidth.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXGridSeriesMinorStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Kind := TTMSFNCGraphicsStrokeKind(FXGridSeriesMinorStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Color := FXGridSeriesMinorStrokeCol.Color;
  FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Opacity := FXGridSeriesMinorStrokeOpacity.Value;
  FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Width := FXGridSeriesMinorStrokeWidth.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Color := FXGridSeriesMinorStrokeCol.Selected;
  FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Width := Trunc(FXGridSeriesMinorStrokeWidth.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXGridSeriesVisibilityChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XGrid.Visible := FXGridSeriesVisibleCheck.IsChecked;
  FChart.Series[FSerieIndex].XGrid.Extended := FXGridSeriesExtendedCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XGrid.Visible := FXGridSeriesVisibleCheck.Checked;
  FChart.Series[FSerieIndex].XGrid.Extended := FXGridSeriesExtendedCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesMajorFontChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XValues.MajorUnitFont.Name := FXValSeriesMajFontName.Items[FXValSeriesMajFontName.ItemIndex];

  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].XValues.MajorUnitFont.Size := FXValSeriesMajFontSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].XValues.MajorUnitFont.Size := Round(FXValSeriesMajFontSize.Value);
  {$ENDIF}
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MajorUnitFont.Color := FXValSeriesMajFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MajorUnitFont.Color := FXValSeriesMajFontCol.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesMajorFormatChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XValues.MajorUnitFormatType := TTMSFNCChartSerieValueFormatType(FXValSeriesMajFormatType.ItemIndex);
  FChart.Series[FSerieIndex].XValues.MajorUnitFormat := FXValSeriesMajFormatValue.Text;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesMajorTickmarkChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MajorUnitTickMarkColor := FXValSeriesMajTickCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MajorUnitTickMarkColor := FXValSeriesMajTickCol.Selected;
  {$ENDIF}
  FChart.Series[FSerieIndex].XValues.MajorUnitTickMarkSize := FXValSeriesMajTickSize.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesMinorFontChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XValues.MinorUnitFont.Name := FXValSeriesMinFontName.Items[FXValSeriesMinFontName.ItemIndex];

  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].XValues.MinorUnitFont.Size := FXValSeriesMinFontSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].XValues.MinorUnitFont.Size := Round(FXValSeriesMinFontSize.Value);
  {$ENDIF}
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MinorUnitFont.Color := FXValSeriesMinFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MinorUnitFont.Color := FXValSeriesMinFontCol.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesMinorFormatChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XValues.MinorUnitFormatType := TTMSFNCChartSerieValueFormatType(FXValSeriesMinFormatType.ItemIndex);
  FChart.Series[FSerieIndex].XValues.MinorUnitFormat := FXValSeriesMinFormatValue.Text;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesMinorTickmarkChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MinorUnitTickMarkColor := FXValSeriesMinTickCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.MinorUnitTickMarkColor := FXValSeriesMinTickCol.Selected;
  {$ENDIF}
  FChart.Series[FSerieIndex].XValues.MinorUnitTickMarkSize := FXValSeriesMinTickSize.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesPositionChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  if FXValSeriesTopCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FXValSeriesTopCheck.Checked then
  {$ENDIF}
    FChart.Series[FSerieIndex].XValues.Positions := FChart.Series[FSerieIndex].XValues.Positions + [xpTop]
  else
    FChart.Series[FSerieIndex].XValues.Positions := FChart.Series[FSerieIndex].XValues.Positions - [xpTop];

  {$IFDEF FMXLIB}
  if FXValSeriesCenterCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FXValSeriesCenterCheck.Checked then
  {$ENDIF}
    FChart.Series[FSerieIndex].XValues.Positions := FChart.Series[FSerieIndex].XValues.Positions + [xpCenter]
  else
    FChart.Series[FSerieIndex].XValues.Positions := FChart.Series[FSerieIndex].XValues.Positions - [xpCenter];

  {$IFDEF FMXLIB}
  if FXValSeriesBottomCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FXValSeriesBottomCheck.Checked then
  {$ENDIF}
    FChart.Series[FSerieIndex].XValues.Positions := FChart.Series[FSerieIndex].XValues.Positions + [xpBottom]
  else
    FChart.Series[FSerieIndex].XValues.Positions := FChart.Series[FSerieIndex].XValues.Positions - [xpBottom];

  FChart.Series[FSerieIndex].XValues.Angle := FXValSeriesAngle.Value;
  FChart.Series[FSerieIndex].XValues.MinorUnitSpacing := FXValSeriesMajSpacing.Value;
  FChart.Series[FSerieIndex].XValues.MinorUnitSpacing := FXValSeriesMinSpacing.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesTextMarginsChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XValues.Title.TextMargins.Left := Round(FXValSeriesTextLeft.Value);
  FChart.Series[FSerieIndex].XValues.Title.TextMargins.Top := Round(FXValSeriesTextTop.Value);
  FChart.Series[FSerieIndex].XValues.Title.TextMargins.Right := Round(FXValSeriesTextRight.Value);
  FChart.Series[FSerieIndex].XValues.Title.TextMargins.Bottom := Round(FXValSeriesTextBottom.Value);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesTitleChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XValues.Title.Text := FXValSeriesTitleValue.Text;
  FChart.Series[FSerieIndex].XValues.Title.TextHorizontalAlignment := TTMSFNCGraphicsTextAlign(FXValSeriesTitleHAlign.ItemIndex);
  FChart.Series[FSerieIndex].XValues.Title.TextVerticalAlignment := TTMSFNCGraphicsTextAlign(FXValSeriesTitleVAlign.ItemIndex);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesTitleFontChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].XValues.Title.Font.Name := FXValSeriesTitleFontName.Items[FXValSeriesTitleFontName.ItemIndex];
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.Title.Font.Color := FXValSeriesTitleFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.Title.Font.Color := FXValSeriesTitleFontCol.Selected;
  {$ENDIF}

  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].XValues.Title.Font.Size := FXValSeriesTitleFontSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].XValues.Title.Font.Size := Round(FXValSeriesTitleFontSize.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesSmartLabelsChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.SmartLabels.Enabled := FXValSeriesSmartEnabledCheck.IsChecked;
  FChart.Series[FSerieIndex].XValues.SmartLabels.AutoRotate := FXValSeriesSmartAutoRotateCheck.IsChecked;
  FChart.Series[FSerieIndex].XValues.SmartLabels.MinLabelSpacing := FXValSeriesSmartMinSpacing.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.SmartLabels.Enabled := FXValSeriesSmartEnabledCheck.Checked;
  FChart.Series[FSerieIndex].XValues.SmartLabels.AutoRotate := FXValSeriesSmartAutoRotateCheck.Checked;
  FChart.Series[FSerieIndex].XValues.SmartLabels.MinLabelSpacing := FXValSeriesSmartMinSpacing.Value;
  {$ENDIF}
  FChart.Series[FSerieIndex].XValues.SmartLabels.MinLabels := Round(FXValSeriesSmartMinLabels.Value);
  FChart.Series[FSerieIndex].XValues.SmartLabels.MaxLabels := Round(FXValSeriesSmartMaxLabels.Value);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoXValSeriesUnitsChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.AutoUnits := FXValSeriesAutoCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].XValues.AutoUnits := FXValSeriesAutoCheck.Checked;
  {$ENDIF}
  FChart.Series[FSerieIndex].XValues.MajorUnit := FXValSeriesUnitMajor.Value;
  FChart.Series[FSerieIndex].XValues.MinorUnit := FXValSeriesUnitMinor.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYGridSeriesMajorStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Kind := TTMSFNCGraphicsStrokeKind(FYGridSeriesMajorStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Color := FYGridSeriesMajorStrokeCol.Color;
  FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Opacity := FYGridSeriesMajorStrokeOpacity.Value;
  FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Width := FYGridSeriesMajorStrokeWidth.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Color := FYGridSeriesMajorStrokeCol.Selected;
  FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Width := Trunc(FYGridSeriesMajorStrokeWidth.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYGridSeriesMinorStrokeChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Kind := TTMSFNCGraphicsStrokeKind(FYGridSeriesMinorStrokeKind.ItemIndex);
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Color := FYGridSeriesMinorStrokeCol.Color;
  FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Opacity := FYGridSeriesMinorStrokeOpacity.Value;
  FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Width := FYGridSeriesMinorStrokeWidth.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Color := FYGridSeriesMinorStrokeCol.Selected;
  FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Width := Trunc(FYGridSeriesMinorStrokeWidth.Value);
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYGridSeriesVisibilityChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.Visible := FYGridSeriesVisibleCheck.IsChecked;
  FChart.Series[FSerieIndex].YGrid.Extended := FYGridSeriesExtendedCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.Visible := FYGridSeriesVisibleCheck.Checked;
  FChart.Series[FSerieIndex].YGrid.Extended := FYGridSeriesExtendedCheck.Checked;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesMajorFontChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.MajorUnitFont.Name := FYValSeriesMajFontName.Items[FYValSeriesMajFontName.ItemIndex];

  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].YValues.MajorUnitFont.Size := FYValSeriesMajFontSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].YValues.MajorUnitFont.Size := Round(FYValSeriesMajFontSize.Value);
  {$ENDIF}
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MajorUnitFont.Color := FYValSeriesMajFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MajorUnitFont.Color := FYValSeriesMajFontCol.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesMajorFormatChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.MajorUnitFormatType := TTMSFNCChartSerieValueFormatType(FYValSeriesMajFormatType.ItemIndex);
  FChart.Series[FSerieIndex].YValues.MajorUnitFormat := FYValSeriesMajFormatValue.Text;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesMajorTickmarkChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MajorUnitTickMarkColor := FYValSeriesMajTickCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MajorUnitTickMarkColor := FYValSeriesMajTickCol.Selected;
  {$ENDIF}
  FChart.Series[FSerieIndex].YValues.MajorUnitTickMarkSize := FYValSeriesMajTickSize.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesMinorFontChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.MinorUnitFont.Name := FYValSeriesMinFontName.Items[FYValSeriesMinFontName.ItemIndex];

  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].YValues.MinorUnitFont.Size := FYValSeriesMinFontSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].YValues.MinorUnitFont.Size := Round(FYValSeriesMinFontSize.Value);
  {$ENDIF}
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MinorUnitFont.Color := FYValSeriesMinFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MinorUnitFont.Color := FYValSeriesMinFontCol.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesMinorFormatChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.MinorUnitFormatType := TTMSFNCChartSerieValueFormatType(FYValSeriesMinFormatType.ItemIndex);
  FChart.Series[FSerieIndex].YValues.MinorUnitFormat := FYValSeriesMinFormatValue.Text;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesMinorTickmarkChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.MinorUnitTickMarkSize := FYValSeriesMinTickSize.Value;
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MinorUnitTickMarkColor := FYValSeriesMinTickCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.MinorUnitTickMarkColor := FYValSeriesMinTickCol.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesPositionChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  if FYValSeriesLeftCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FYValSeriesLeftCheck.Checked then
  {$ENDIF}
    FChart.Series[FSerieIndex].YValues.Positions := FChart.Series[FSerieIndex].YValues.Positions + [ypLeft]
  else
    FChart.Series[FSerieIndex].YValues.Positions := FChart.Series[FSerieIndex].YValues.Positions - [ypLeft];

  {$IFDEF FMXLIB}
  if FYValSeriesCenterCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FYValSeriesCenterCheck.Checked then
  {$ENDIF}
    FChart.Series[FSerieIndex].YValues.Positions := FChart.Series[FSerieIndex].YValues.Positions + [ypCenter]
  else
    FChart.Series[FSerieIndex].YValues.Positions := FChart.Series[FSerieIndex].YValues.Positions - [ypCenter];

  {$IFDEF FMXLIB}
  if FYValSeriesRightCheck.IsChecked then
  {$ENDIF}
  {$IFNDEF FMXLIB}
  if FYValSeriesRightCheck.Checked then
  {$ENDIF}
    FChart.Series[FSerieIndex].YValues.Positions := FChart.Series[FSerieIndex].YValues.Positions + [ypRight]
  else
    FChart.Series[FSerieIndex].YValues.Positions := FChart.Series[FSerieIndex].YValues.Positions - [ypRight];

  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.SpiderValues := FYValSeriesValuesCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.SpiderValues := FYValSeriesValuesCheck.Checked;
  {$ENDIF}

  FChart.Series[FSerieIndex].YValues.MinorUnitSpacing := FYValSeriesMajSpacing.Value;
  FChart.Series[FSerieIndex].YValues.MinorUnitSpacing := FYValSeriesMinSpacing.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesTextMarginsChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.Title.TextMargins.Left := Round(FYValSeriesTextLeft.Value);
  FChart.Series[FSerieIndex].YValues.Title.TextMargins.Top := Round(FYValSeriesTextTop.Value);
  FChart.Series[FSerieIndex].YValues.Title.TextMargins.Right := Round(FYValSeriesTextRight.Value);
  FChart.Series[FSerieIndex].YValues.Title.TextMargins.Bottom := Round(FYValSeriesTextBottom.Value);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesTitleChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.Title.Text := FYValSeriesTitleValue.Text;
  FChart.Series[FSerieIndex].YValues.Title.TextHorizontalAlignment := TTMSFNCGraphicsTextAlign(FYValSeriesTitleHAlign.ItemIndex);
  FChart.Series[FSerieIndex].YValues.Title.TextVerticalAlignment := TTMSFNCGraphicsTextAlign(FYValSeriesTitleVAlign.ItemIndex);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesTitleFontChange(Sender: TObject);
begin
  FChart.Series[FSerieIndex].YValues.Title.Font.Name := FYValSeriesTitleFontName.Items[FYValSeriesTitleFontName.ItemIndex];

  {$IFNDEF LCLLIB}
  FChart.Series[FSerieIndex].YValues.Title.Font.Size := FYValSeriesTitleFontSize.Value;
  {$ENDIF}
  {$IFDEF LCLLIB}
  FChart.Series[FSerieIndex].YValues.Title.Font.Size := Round(FYValSeriesTitleFontSize.Value);
  {$ENDIF}
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.Title.Font.Color := FYValSeriesTitleFontCol.Color;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.Title.Font.Color := FYValSeriesTitleFontCol.Selected;
  {$ENDIF}

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesSmartLabelsChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.SmartLabels.Enabled := FYValSeriesSmartEnabledCheck.IsChecked;
  FChart.Series[FSerieIndex].YValues.SmartLabels.AutoRotate := FYValSeriesSmartAutoRotateCheck.IsChecked;
  FChart.Series[FSerieIndex].YValues.SmartLabels.MinLabelSpacing := FYValSeriesSmartMinSpacing.Value;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.SmartLabels.Enabled := FYValSeriesSmartEnabledCheck.Checked;
  FChart.Series[FSerieIndex].YValues.SmartLabels.AutoRotate := FYValSeriesSmartAutoRotateCheck.Checked;
  FChart.Series[FSerieIndex].YValues.SmartLabels.MinLabelSpacing := FYValSeriesSmartMinSpacing.Value;
  {$ENDIF}
  FChart.Series[FSerieIndex].YValues.SmartLabels.MinLabels := Round(FYValSeriesSmartMinLabels.Value);
  FChart.Series[FSerieIndex].YValues.SmartLabels.MaxLabels := Round(FYValSeriesSmartMaxLabels.Value);

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYValSeriesUnitsChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.AutoUnits := FYValSeriesAutoCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YValues.AutoUnits := FYValSeriesAutoCheck.Checked;
  {$ENDIF}
  FChart.Series[FSerieIndex].YValues.MajorUnit := FYValSeriesUnitMajor.Value;
  FChart.Series[FSerieIndex].YValues.MinorUnit := FYValSeriesUnitMinor.Value;

  FModified := True;
end;

procedure TTMSFNCChartSeriesEditor.DoYGridSeriesSpiderChange(Sender: TObject);
begin
  {$IFDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.SpiderVisible := FYGridSeriesSpiderVisibleCheck.IsChecked;
  FChart.Series[FSerieIndex].YGrid.SpiderLegend := FYGridSeriesLegendTextCheck.IsChecked;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FChart.Series[FSerieIndex].YGrid.SpiderVisible := FYGridSeriesSpiderVisibleCheck.Checked;
  FChart.Series[FSerieIndex].YGrid.SpiderLegend := FYGridSeriesLegendTextCheck.Checked;
  {$ENDIF}
  FChart.Series[FSerieIndex].YGrid.SpiderKind := TTMSFNCChartSerieSpiderGridKind(FYGridSeriesSpiderKind.ItemIndex);

  FModified := True;
end;


{$IFDEF WEBLIB}
procedure TTMSFNCChartSeriesEditor.Execute(AProc: TModalResultProc = nil);
{$ELSE}
function TTMSFNCChartSeriesEditor.Execute: TModalResult;
{$ENDIF}
begin
  if not Assigned(Chart) then
  begin
    raise Exception.Create('No chart was assigned to the editor!');
    Exit;
  end;

  {$IFDEF WEBLIB}
  frm := TTMSFNCChartSeriesEditorForm.CreateDialogNew(Self, 'Chart Series Editor');
  {$ELSE}
  frm := TTMSFNCChartSeriesEditorForm.CreateNew(Application);
  frm.Caption := 'Chart Series Editor';
  frm.BorderIcons := [TBorderIcon.biSystemMenu, TBorderIcon.biMinimize];
  {$ENDIF}

  FCopyChart := TTMSFNCChart.Create(frm);
  FCopyChart.Assign(Chart);

  frm.Width := 730;
  frm.Height := 700;
  {$IFDEF FMXLIB}
  frm.Position := TFormPosition.ScreenCenter;
  frm.Fill.Kind := TBrushKind.Solid;
  if IsLightTheme then
    frm.Fill.Color := EDITORSUBBACKCOLORLIGHT
  else
    frm.Fill.Color := EDITORSUBBACKCOLORDARK;
  {$ENDIF}
  {$IFDEF CMNLIB}
  frm.KeyPreview := True;
  {$ENDIF}
  frm.OnKeyDown := @DoFormKeyDown;
  {$IFDEF CMNWEBLIB}
  frm.Position := poScreenCenter;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  BuildEditor(frm);
  Cursor := crDefault;
  frm.ActiveControl := FSeriesPanel;
  {$ENDIF}
  TTMSFNCUtils.ScaleForCurrentDPI(frm);
  {$IFNDEF WEBLIB}
  Result := frm.ShowModal;
  if (Result <> mrOk) and Assigned(Chart) then
  begin
    Chart.Assign(nil);
    Chart.BeginUpdate;
    Chart.Assign(FCopyChart);
    Chart.EndUpdate;
    FCopyChart := nil;
  end;
  frm.Free;
  {$ELSE}
  frm.ShowModal(
  procedure(AResult: TModalResult)
  begin
    if (AResult <> mrOk) and Assigned(Chart) then
    begin
      Chart.Assign(nil);
      Chart.BeginUpdate;
      Chart.Assign(FCopyChart);
      Chart.EndUpdate;
      FCopyChart := nil;
    end;
    frm := nil;
    if Assigned(AProc) then
      AProc(AResult);
  end);
  {$ENDIF}
end;

procedure TTMSFNCChartSeriesEditor.FillFonts;
var
  sl: TStringList;
begin
  sl := TStringList.Create;
  try
    TTMSFNCUtils.GetFonts(sl);
    FLegSeriesFontName.Items.Assign(sl);
    FLabelSeriesFontName.Items.Assign(sl);
    FXValSeriesMajFontName.Items.Assign(sl);
    FXValSeriesMinFontName.Items.Assign(sl);
    FXValSeriesTitleFontName.Items.Assign(sl);
    FYValSeriesMajFontName.Items.Assign(sl);
    FYValSeriesMinFontName.Items.Assign(sl);
    FYValSeriesTitleFontName.Items.Assign(sl);
  finally
    sl.Free;
  end;
end;

function TTMSFNCChartSeriesEditor.GetDocURL: string;
begin
  Result := TTMSFNCBaseDocURL + 'tmsfncchart';
end;

function TTMSFNCChartSeriesEditor.GetInstance: NativeUInt;
begin
  Result := HInstance;
end;

function TTMSFNCChartSeriesEditor.GetTipsURL: string;
begin
  Result := 'https://www.tmssoftware.com/site/tmsfncchart.asp?s=faq';
end;

procedure TTMSFNCChartSeriesEditor.Initialize;
begin
  InitSeriesValues;
end;

procedure TTMSFNCChartSeriesEditor.InitSeriesValues;
begin
  if Assigned(FChart) and (FSerieIndex >= 0) and (FSerieIndex < FChart.Series.Count) then
  begin
    ClearSeriesEvents;

//    FSeriesMainPanel.Visible := True;

    //  General Series Panel
    FGenSeriesFillKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Fill.Kind);
    FGenSeriesFillGradient.ItemIndex := Integer(FChart.Series[FSerieIndex].Fill.GradientOrientation);
    {$IFDEF FMXLIB}
    FGenSeriesFillCol1.Color := FChart.Series[FSerieIndex].Fill.Color;
    FGenSeriesFillCol2.Color := FChart.Series[FSerieIndex].Fill.ColorTo;
    FGenSeriesFillOpacity.Value := FChart.Series[FSerieIndex].Fill.Opacity;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FGenSeriesFillCol1.Selected := FChart.Series[FSerieIndex].Fill.Color;
    FGenSeriesFillCol2.Selected := FChart.Series[FSerieIndex].Fill.ColorTo;
    {$ENDIF}

    FGenSeriesStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Stroke.Kind);
    {$IFDEF FMXLIB}
    FGenSeriesStrokeCol.Color := FChart.Series[FSerieIndex].Stroke.Color;
    FGenSeriesStrokeOpacity.Value := FChart.Series[FSerieIndex].Stroke.Opacity;
    FGenSeriesStrokeWidth.Value := FChart.Series[FSerieIndex].Stroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FGenSeriesStrokeCol.Selected := FChart.Series[FSerieIndex].Stroke.Color;
    FGenSeriesStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].Stroke.Width);
    {$ENDIF}

    {$IFDEF FMXLIB}
    FGenSeriesEnabledCheck.IsChecked := FChart.Series[FSerieIndex].Enable3D;
    FGenSeriesOffsetX.Value := FChart.Series[FSerieIndex].Offset3DX;
    FGenSeriesOffsetY.Value := FChart.Series[FSerieIndex].Offset3DY;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FGenSeriesEnabledCheck.Checked := FChart.Series[FSerieIndex].Enable3D;
    FGenSeriesOffsetX.Value := Round(FChart.Series[FSerieIndex].Offset3DX);
    FGenSeriesOffsetY.Value := Round(FChart.Series[FSerieIndex].Offset3DY);
    {$ENDIF}

    {$IFDEF FMXLIB}
    FGenSeriesVisibleCheck.IsChecked := FChart.Series[FSerieIndex].Visible;
    FGenSeriesZRV.Value := FChart.Series[FSerieIndex].ZeroReferenceValue;
    FGenSeriesMinX.Value := FChart.Series[FSerieIndex].MinX;
    FGenSeriesMinY.Value := FChart.Series[FSerieIndex].MinY;
    FGenSeriesMaxX.Value := FChart.Series[FSerieIndex].MaxX;
    FGenSeriesMaxY.Value := FChart.Series[FSerieIndex].MaxY;
    FGenSeriesMinXOff.Value := FChart.Series[FSerieIndex].MinXOffsetPercentage;
    FGenSeriesMaxXOff.Value := FChart.Series[FSerieIndex].MaxXOffsetPercentage;
    FGenSeriesMinYOff.Value := FChart.Series[FSerieIndex].MinYOffsetPercentage;
    FGenSeriesMaxYOff.Value := FChart.Series[FSerieIndex].MaxYOffsetPercentage;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FGenSeriesVisibleCheck.Checked := FChart.Series[FSerieIndex].Visible;
    FGenSeriesZRV.Value := Round(FChart.Series[FSerieIndex].ZeroReferenceValue);
    FGenSeriesMinX.Value := Round(FChart.Series[FSerieIndex].MinX);
    FGenSeriesMinY.Value := Round(FChart.Series[FSerieIndex].MinY);
    FGenSeriesMaxX.Value := Round(FChart.Series[FSerieIndex].MaxX);
    FGenSeriesMaxY.Value := Round(FChart.Series[FSerieIndex].MaxY);
    FGenSeriesMinXOff.Value := Round(FChart.Series[FSerieIndex].MinXOffsetPercentage);
    FGenSeriesMaxXOff.Value := Round(FChart.Series[FSerieIndex].MaxXOffsetPercentage);
    FGenSeriesMinYOff.Value := Round(FChart.Series[FSerieIndex].MinYOffsetPercentage);
    FGenSeriesMaxYOff.Value := Round(FChart.Series[FSerieIndex].MaxYOffsetPercentage);
    {$ENDIF}
    FGenSeriesGroup.Value := FChart.Series[FSerieIndex].GroupIndex;
    FGenSeriesMode.ItemIndex := Integer(FChart.Series[FSerieIndex].Mode);

    FGenSeriesXRange.ItemIndex := Integer(FChart.Series[FSerieIndex].AutoXRange);
    FGenSeriesYRange.ItemIndex := Integer(FChart.Series[FSerieIndex].AutoYRange);

//    FGenSeriesBarType.ItemIndex := Integer(FChart.Series[FSerieIndex].Bar.WidthType);
//    {$IFDEF FMXLIB}
//    FGenSeriesBarWidth.Value := FChart.Series[FSerieIndex].Bar.Width;
//    FGenSeriesBarSpacing.Value := FChart.Series[FSerieIndex].Bar.Spacing;
//    {$ENDIF}
//    {$IFNDEF FMXLIB}
//    FGenSeriesBarWidth.Value := Round(FChart.Series[FSerieIndex].Bar.Width);
//    FGenSeriesBarSpacing.Value := Round(FChart.Series[FSerieIndex].Bar.Spacing);
//    {$ENDIF}
//
//    FGenSeriesMultiType.ItemIndex := Integer(FChart.Series[FSerieIndex].MultiPoint.WidthType);
//    {$IFDEF FMXLIB}
//    FGenSeriesIncFill.Color := FChart.Series[FSerieIndex].MultiPoint.IncreaseFillColor;
//    FGenSeriesIncStroke.Color := FChart.Series[FSerieIndex].MultiPoint.IncreaseStrokeColor;
//    FGenSeriesDecFill.Color := FChart.Series[FSerieIndex].MultiPoint.DecreaseFillColor;
//    FGenSeriesDecStroke.Color := FChart.Series[FSerieIndex].MultiPoint.DecreaseStrokeColor;
//    {$ENDIF}
//    {$IFNDEF FMXLIB}
//    FGenSeriesIncFill.Selected := FChart.Series[FSerieIndex].MultiPoint.IncreaseFillColor;
//    FGenSeriesIncStroke.Selected := FChart.Series[FSerieIndex].MultiPoint.IncreaseStrokeColor;
//    FGenSeriesDecFill.Selected := FChart.Series[FSerieIndex].MultiPoint.DecreaseFillColor;
//    FGenSeriesDecStroke.Selected := FChart.Series[FSerieIndex].MultiPoint.DecreaseStrokeColor;
//    {$ENDIF}

    {$IFDEF FMXLIB}
//    FGenSeriesMultiWidth.Value := FChart.Series[FSerieIndex].MultiPoint.Width;
    FGenSeriesFactor.Value := FChart.Series[FSerieIndex].AnimationFactor;
    {$ENDIF}
    {$IFNDEF FMXLIB}
//    FGenSeriesMultiWidth.Value := Round(FChart.Series[FSerieIndex].MultiPoint.Width);
    FGenSeriesFactor.Value := Round(FChart.Series[FSerieIndex].AnimationFactor);
    {$ENDIF}

    {$IFDEF FMXLIB}
    FGenSeriesFlowCheck.IsChecked := FChart.Series[FSerieIndex].AnimationFlow;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FGenSeriesFlowCheck.Checked := FChart.Series[FSerieIndex].AnimationFlow;
    {$ENDIF}

    //  Legend Series Panel
    FLegSeriesValue.ItemIndex := Integer(FChart.Series[FSerieIndex].Legend.Position);
    {$IFDEF FMXLIB}
    FLegSeriesAppLeft.Value := FChart.Series[FSerieIndex].Legend.Left;
    FLegSeriesAppTop.Value := FChart.Series[FSerieIndex].Legend.Top;
    FLegSeriesVisibleCheck.IsChecked := FChart.Series[FSerieIndex].Legend.Visible;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLegSeriesAppLeft.Value := Round(FChart.Series[FSerieIndex].Legend.Left);
    FLegSeriesAppTop.Value := Round(FChart.Series[FSerieIndex].Legend.Top);
    FLegSeriesVisibleCheck.Checked := FChart.Series[FSerieIndex].Legend.Visible;
    {$ENDIF}

    FLegSeriesFillKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Legend.Fill.Kind);
    FLegSeriesFillGradient.ItemIndex := Integer(FChart.Series[FSerieIndex].Legend.Fill.GradientOrientation);
    {$IFDEF FMXLIB}
    FLegSeriesFillCol1.Color := FChart.Series[FSerieIndex].Legend.Fill.Color;
    FLegSeriesFillCol2.Color := FChart.Series[FSerieIndex].Legend.Fill.ColorTo;
    FLegSeriesFillOpacity.Value := FChart.Series[FSerieIndex].Legend.Fill.Opacity;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLegSeriesFillCol1.Selected := FChart.Series[FSerieIndex].Legend.Fill.Color;
    FLegSeriesFillCol2.Selected := FChart.Series[FSerieIndex].Legend.Fill.ColorTo;
    {$ENDIF}

    FLegSeriesStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Legend.Stroke.Kind);
    {$IFDEF FMXLIB}
    FLegSeriesStrokeCol.Color := FChart.Series[FSerieIndex].Legend.Stroke.Color;
    FLegSeriesStrokeOpacity.Value := FChart.Series[FSerieIndex].Legend.Stroke.Opacity;
    FLegSeriesStrokeWidth.Value := FChart.Series[FSerieIndex].Legend.Stroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLegSeriesStrokeCol.Selected := FChart.Series[FSerieIndex].Legend.Stroke.Color;
    FLegSeriesStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].Legend.Stroke.Width);
    {$ENDIF}

    FLegSeriesFontName.ItemIndex := FLegSeriesFontName.Items.IndexOf(FChart.Series[FSerieIndex].Legend.Font.Name);

    FLegSeriesSize.Value := FChart.Series[FSerieIndex].Legend.Font.Size;
    {$IFDEF FMXLIB}
    FLegSeriesFontCol.Color := FChart.Series[FSerieIndex].Legend.Font.Color;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLegSeriesFontCol.Selected := FChart.Series[FSerieIndex].Legend.Font.Color;
    {$ENDIF}

    FLegSeriesText.Text := FChart.Series[FSerieIndex].LegendText;
    {$IFDEF FMXLIB}
    FLegSeriesShowCheck.IsChecked := FChart.Series[FSerieIndex].ShowInLegend;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLegSeriesShowCheck.Checked := FChart.Series[FSerieIndex].ShowInLegend;
    {$ENDIF}

    // Type Series Panel
    SetCharTypeSelector(FChart.Series[FSerieIndex].ChartType);

    // Label Series Panel
    {$IFDEF FMXLIB}
    FLabelSeriesOffsetX.Value := FChart.Series[FSerieIndex].Labels.OffsetX;
    FLabelSeriesOffsetY.Value := FChart.Series[FSerieIndex].Labels.OffsetY;
    FLabelSeriesVisibleCheck.IsChecked := FChart.Series[FSerieIndex].Labels.Visible;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLabelSeriesOffsetX.Value := Round(FChart.Series[FSerieIndex].Labels.OffsetX);
    FLabelSeriesOffsetY.Value := Round(FChart.Series[FSerieIndex].Labels.OffsetY);
    FLabelSeriesVisibleCheck.Checked := FChart.Series[FSerieIndex].Labels.Visible;
    {$ENDIF}

    FLabelSeriesFillKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Labels.Fill.Kind);
    FLabelSeriesFillGradient.ItemIndex := Integer(FChart.Series[FSerieIndex].Labels.Fill.GradientOrientation);
    {$IFDEF FMXLIB}
    FLabelSeriesFillCol1.Color := FChart.Series[FSerieIndex].Labels.Fill.Color;
    FLabelSeriesFillCol2.Color := FChart.Series[FSerieIndex].Labels.Fill.ColorTo;
    FLabelSeriesFillOpacity.Value := FChart.Series[FSerieIndex].Labels.Fill.Opacity;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLabelSeriesFillCol1.Selected := FChart.Series[FSerieIndex].Labels.Fill.Color;
    FLabelSeriesFillCol2.Selected := FChart.Series[FSerieIndex].Labels.Fill.ColorTo;
    {$ENDIF}

    FLabelSeriesStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Labels.Stroke.Kind);
    {$IFDEF FMXLIB}
    FLabelSeriesStrokeCol.Color := FChart.Series[FSerieIndex].Labels.Stroke.Color;
    FLabelSeriesStrokeOpacity.Value := FChart.Series[FSerieIndex].Labels.Stroke.Opacity;
    FLabelSeriesStrokeWidth.Value := FChart.Series[FSerieIndex].Labels.Stroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLabelSeriesStrokeCol.Selected := FChart.Series[FSerieIndex].Labels.Stroke.Color;
    FLabelSeriesStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].Labels.Stroke.Width);
    {$ENDIF}

    FLabelSeriesType.ItemIndex := Integer(FChart.Series[FSerieIndex].Labels.FormatType);
    FLabelSeriesMode.ItemIndex := Integer(FChart.Series[FSerieIndex].Labels.Mode);
    FLabelSeriesText.Text := FChart.Series[FSerieIndex].Labels.Format;

    FLabelSeriesFontName.ItemIndex := FLabelSeriesFontName.Items.IndexOf(FChart.Series[FSerieIndex].Labels.Font.Name);
    FLabelSeriesSize.Value := FChart.Series[FSerieIndex].Labels.Font.Size;
    {$IFDEF FMXLIB}
    FLabelSeriesFontCol.Color := FChart.Series[FSerieIndex].Labels.Font.Color;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FLabelSeriesFontCol.Selected := FChart.Series[FSerieIndex].Labels.Font.Color;
    {$ENDIF}

    // Label Series Panel
    {$IFDEF FMXLIB}
    FMarkersSeriesWidth.Value := FChart.Series[FSerieIndex].Markers.Width;
    FMarkersSeriesHeight.Value := FChart.Series[FSerieIndex].Markers.Height;
    FMarkersSeriesVisibleCheck.IsChecked := FChart.Series[FSerieIndex].Markers.Visible;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FMarkersSeriesWidth.Value := Round(FChart.Series[FSerieIndex].Markers.Width);
    FMarkersSeriesHeight.Value := Round(FChart.Series[FSerieIndex].Markers.Height);
    FMarkersSeriesVisibleCheck.Checked := FChart.Series[FSerieIndex].Markers.Visible;
    {$ENDIF}

    FMarkersSeriesFillKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Markers.Fill.Kind);
    FMarkersSeriesFillGradient.ItemIndex := Integer(FChart.Series[FSerieIndex].Markers.Fill.GradientOrientation);
    {$IFDEF FMXLIB}
    FMarkersSeriesFillCol1.Color := FChart.Series[FSerieIndex].Markers.Fill.Color;
    FMarkersSeriesFillCol2.Color := FChart.Series[FSerieIndex].Markers.Fill.ColorTo;
    FMarkersSeriesFillOpacity.Value := FChart.Series[FSerieIndex].Markers.Fill.Opacity;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FMarkersSeriesFillCol1.Selected := FChart.Series[FSerieIndex].Markers.Fill.Color;
    FMarkersSeriesFillCol2.Selected := FChart.Series[FSerieIndex].Markers.Fill.ColorTo;
    {$ENDIF}

    FMarkersSeriesStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].Markers.Stroke.Kind);
    {$IFDEF FMXLIB}
    FMarkersSeriesStrokeCol.Color := FChart.Series[FSerieIndex].Markers.Stroke.Color;
    FMarkersSeriesStrokeOpacity.Value := FChart.Series[FSerieIndex].Markers.Stroke.Opacity;
    FMarkersSeriesStrokeWidth.Value := FChart.Series[FSerieIndex].Markers.Stroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FMarkersSeriesStrokeCol.Selected := FChart.Series[FSerieIndex].Markers.Stroke.Color;
    FMarkersSeriesStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].Markers.Stroke.Width);
    {$ENDIF}

    FMarkersSeriesShape.ItemIndex := Integer(FChart.Series[FSerieIndex].Markers.Shape);
    FImage.Invalidate;

    // X-Grid Series Panel
    {$IFDEF FMXLIB}
    FXGridSeriesVisibleCheck.IsChecked := FChart.Series[FSerieIndex].XGrid.Visible;
    FXGridSeriesExtendedCheck.IsChecked := FChart.Series[FSerieIndex].XGrid.Extended;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXGridSeriesVisibleCheck.Checked := FChart.Series[FSerieIndex].XGrid.Visible;
    FXGridSeriesExtendedCheck.Checked := FChart.Series[FSerieIndex].XGrid.Extended;
    {$ENDIF}

    FXGridSeriesMajorStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Kind);
    {$IFDEF FMXLIB}
    FXGridSeriesMajorStrokeCol.Color := FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Color;
    FXGridSeriesMajorStrokeOpacity.Value := FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Opacity;
    FXGridSeriesMajorStrokeWidth.Value := FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXGridSeriesMajorStrokeCol.Selected := FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Color;
    FXGridSeriesMajorStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].XGrid.MajorUnitStroke.Width);
    {$ENDIF}

    FXGridSeriesMinorStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Kind);
    {$IFDEF FMXLIB}
    FXGridSeriesMinorStrokeCol.Color := FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Color;
    FXGridSeriesMinorStrokeOpacity.Value := FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Opacity;
    FXGridSeriesMinorStrokeWidth.Value := FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXGridSeriesMinorStrokeCol.Selected := FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Color;
    FXGridSeriesMinorStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].XGrid.MinorUnitStroke.Width);
    {$ENDIF}

    // X-Values Series Panel
    {$IFDEF FMXLIB}
    FXValSeriesTopCheck.IsChecked := xpTop in FChart.Series[FSerieIndex].XValues.Positions;
    FXValSeriesCenterCheck.IsChecked := xpCenter in FChart.Series[FSerieIndex].XValues.Positions;
    FXValSeriesBottomCheck.IsChecked := xpBottom in FChart.Series[FSerieIndex].XValues.Positions;
    FXValSeriesAngle.Value := FChart.Series[FSerieIndex].XValues.Angle;
    FXValSeriesMajSpacing.Value := FChart.Series[FSerieIndex].XValues.MajorUnitSpacing;
    FXValSeriesMinSpacing.Value := FChart.Series[FSerieIndex].XValues.MinorUnitSpacing;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXValSeriesTopCheck.Checked := xpTop in FChart.Series[FSerieIndex].XValues.Positions;
    FXValSeriesCenterCheck.Checked := xpCenter in FChart.Series[FSerieIndex].XValues.Positions;
    FXValSeriesBottomCheck.Checked := xpBottom in FChart.Series[FSerieIndex].XValues.Positions;
    FXValSeriesAngle.Value := Round(FChart.Series[FSerieIndex].XValues.Angle);
    FXValSeriesMajSpacing.Value := Round(FChart.Series[FSerieIndex].XValues.MajorUnitSpacing);
    FXValSeriesMinSpacing.Value := Round(FChart.Series[FSerieIndex].XValues.MinorUnitSpacing);
    {$ENDIF}

    FXValSeriesMajFontName.ItemIndex := FXValSeriesMajFontName.Items.IndexOf(FChart.Series[FSerieIndex].XValues.MajorUnitFont.Name);
    FXValSeriesMajFontSize.Value := FChart.Series[FSerieIndex].XValues.MajorUnitFont.Size;

    FXValSeriesMinFontName.ItemIndex := FXValSeriesMinFontName.Items.IndexOf(FChart.Series[FSerieIndex].XValues.MinorUnitFont.Name);
    FXValSeriesMinFontSize.Value := FChart.Series[FSerieIndex].XValues.MinorUnitFont.Size;

    {$IFDEF FMXLIB}
    FXValSeriesMajFontCol.Color := FChart.Series[FSerieIndex].XValues.MajorUnitFont.Color;
    FXValSeriesMinFontCol.Color := FChart.Series[FSerieIndex].XValues.MinorUnitFont.Color;
    FXValSeriesMajTickCol.Color := FChart.Series[FSerieIndex].XValues.MajorUnitTickMarkColor;
    FXValSeriesMinTickCol.Color := FChart.Series[FSerieIndex].XValues.MinorUnitTickMarkColor;
    FXValSeriesMinTickSize.Value := FChart.Series[FSerieIndex].XValues.MinorUnitTickMarkSize;
    FXValSeriesMajTickSize.Value := FChart.Series[FSerieIndex].XValues.MajorUnitTickMarkSize;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXValSeriesMajFontCol.Selected := FChart.Series[FSerieIndex].XValues.MajorUnitFont.Color;
    FXValSeriesMinFontCol.Selected := FChart.Series[FSerieIndex].XValues.MinorUnitFont.Color;
    FXValSeriesMajTickCol.Selected := FChart.Series[FSerieIndex].XValues.MajorUnitTickMarkColor;
    FXValSeriesMinTickCol.Selected := FChart.Series[FSerieIndex].XValues.MinorUnitTickMarkColor;
    FXValSeriesMinTickSize.Value := Round(FChart.Series[FSerieIndex].XValues.MinorUnitTickMarkSize);
    FXValSeriesMajTickSize.Value := Round(FChart.Series[FSerieIndex].XValues.MajorUnitTickMarkSize);
    {$ENDIF}

    {$IFDEF FMXLIB}
    FXValSeriesAutoCheck.IsChecked := FChart.Series[FSerieIndex].XValues.AutoUnits;
    FXValSeriesUnitMajor.Value := FChart.Series[FSerieIndex].XValues.MajorUnit;
    FXValSeriesUnitMinor.Value := FChart.Series[FSerieIndex].XValues.MinorUnit;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXValSeriesAutoCheck.Checked := FChart.Series[FSerieIndex].XValues.AutoUnits;
    FXValSeriesUnitMajor.Value := Round(FChart.Series[FSerieIndex].XValues.MajorUnit);
    FXValSeriesUnitMinor.Value := Round(FChart.Series[FSerieIndex].XValues.MinorUnit);
    {$ENDIF}

    FXValSeriesMajFormatType.ItemIndex := Integer(FChart.Series[FSerieIndex].XValues.MajorUnitFormatType);
    FXValSeriesMajFormatValue.Text := FChart.Series[FSerieIndex].XValues.MajorUnitFormat;
    FXValSeriesMinFormatType.ItemIndex := Integer(FChart.Series[FSerieIndex].XValues.MinorUnitFormatType);
    FXValSeriesMinFormatValue.Text := FChart.Series[FSerieIndex].XValues.MinorUnitFormat;

    FXValSeriesTitleValue.Text := FChart.Series[FSerieIndex].XValues.Title.Text;
    FXValSeriesTitleHAlign.ItemIndex := Integer(FChart.Series[FSerieIndex].XValues.Title.TextHorizontalAlignment);
    FXValSeriesTitleVAlign.ItemIndex := Integer(FChart.Series[FSerieIndex].XValues.Title.TextVerticalAlignment);

    FXValSeriesTextLeft.Value := FChart.Series[FSerieIndex].XValues.Title.TextMargins.Left;
    FXValSeriesTextTop.Value := FChart.Series[FSerieIndex].XValues.Title.TextMargins.Top;
    FXValSeriesTextRight.Value := FChart.Series[FSerieIndex].XValues.Title.TextMargins.Right;
    FXValSeriesTextBottom.Value := FChart.Series[FSerieIndex].XValues.Title.TextMargins.Bottom;

    FXValSeriesTitleFontName.ItemIndex := FXValSeriesTitleFontName.Items.IndexOf(FChart.Series[FSerieIndex].XValues.Title.Font.Name);
    FXValSeriesTitleFontSize.Value := FChart.Series[FSerieIndex].XValues.Title.Font.Size;
    {$IFDEF FMXLIB}
    FXValSeriesTitleFontCol.Color := FChart.Series[FSerieIndex].XValues.Title.Font.Color;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXValSeriesTitleFontCol.Selected := FChart.Series[FSerieIndex].XValues.Title.Font.Color;
    {$ENDIF}

    // X-Values SmartLabels
    {$IFDEF FMXLIB}
    FXValSeriesSmartEnabledCheck.IsChecked := FChart.Series[FSerieIndex].XValues.SmartLabels.Enabled;
    FXValSeriesSmartAutoRotateCheck.IsChecked := FChart.Series[FSerieIndex].XValues.SmartLabels.AutoRotate;
    FXValSeriesSmartMinSpacing.Value := FChart.Series[FSerieIndex].XValues.SmartLabels.MinLabelSpacing;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FXValSeriesSmartEnabledCheck.Checked := FChart.Series[FSerieIndex].XValues.SmartLabels.Enabled;
    FXValSeriesSmartAutoRotateCheck.Checked := FChart.Series[FSerieIndex].XValues.SmartLabels.AutoRotate;
    FXValSeriesSmartMinSpacing.Value := Round(FChart.Series[FSerieIndex].XValues.SmartLabels.MinLabelSpacing);
    {$ENDIF}
    FXValSeriesSmartMinLabels.Value := FChart.Series[FSerieIndex].XValues.SmartLabels.MinLabels;
    FXValSeriesSmartMaxLabels.Value := FChart.Series[FSerieIndex].XValues.SmartLabels.MaxLabels;

    // Y-Grid Series Panel
    {$IFDEF FMXLIB}
    FYGridSeriesVisibleCheck.IsChecked := FChart.Series[FSerieIndex].YGrid.Visible;
    FYGridSeriesExtendedCheck.IsChecked := FChart.Series[FSerieIndex].YGrid.Extended;
    FYGridSeriesSpiderVisibleCheck.IsChecked := FChart.Series[FSerieIndex].YGrid.SpiderVisible;
    FYGridSeriesLegendTextCheck.IsChecked := FChart.Series[FSerieIndex].YGrid.SpiderLegend;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYGridSeriesVisibleCheck.Checked := FChart.Series[FSerieIndex].YGrid.Visible;
    FYGridSeriesExtendedCheck.Checked := FChart.Series[FSerieIndex].YGrid.Extended;
    FYGridSeriesSpiderVisibleCheck.Checked := FChart.Series[FSerieIndex].YGrid.SpiderVisible;
    FYGridSeriesLegendTextCheck.Checked := FChart.Series[FSerieIndex].YGrid.SpiderLegend;
    {$ENDIF}

    FYGridSeriesMajorStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Kind);
    {$IFDEF FMXLIB}
    FYGridSeriesMajorStrokeCol.Color := FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Color;
    FYGridSeriesMajorStrokeOpacity.Value := FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Opacity;
    FYGridSeriesMajorStrokeWidth.Value := FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYGridSeriesMajorStrokeCol.Selected := FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Color;
    FYGridSeriesMajorStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].YGrid.MajorUnitStroke.Width);
    {$ENDIF}

    FYGridSeriesMinorStrokeKind.ItemIndex := Integer(FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Kind);
    {$IFDEF FMXLIB}
    FYGridSeriesMinorStrokeCol.Color := FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Color;
    FYGridSeriesMinorStrokeOpacity.Value := FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Opacity;
    FYGridSeriesMinorStrokeWidth.Value := FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Width;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYGridSeriesMinorStrokeCol.Selected := FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Color;
    FYGridSeriesMinorStrokeWidth.Value := Trunc(FChart.Series[FSerieIndex].YGrid.MinorUnitStroke.Width);
    {$ENDIF}

    FYGridSeriesSpiderKind.ItemIndex := Integer(FChart.Series[FSerieIndex].YGrid.SpiderKind);

    // X-Values Series Panel
    {$IFDEF FMXLIB}
    FYValSeriesLeftCheck.IsChecked := ypLeft in FChart.Series[FSerieIndex].YValues.Positions;
    FYValSeriesCenterCheck.IsChecked := ypCenter in FChart.Series[FSerieIndex].YValues.Positions;
    FYValSeriesRightCheck.IsChecked := ypRight in FChart.Series[FSerieIndex].YValues.Positions;
    FYValSeriesValuesCheck.IsChecked := FChart.Series[FSerieIndex].YValues.SpiderValues;
    FYValSeriesMajSpacing.Value := FChart.Series[FSerieIndex].YValues.MajorUnitSpacing;
    FYValSeriesMinSpacing.Value := FChart.Series[FSerieIndex].YValues.MinorUnitSpacing;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYValSeriesLeftCheck.Checked := ypLeft in FChart.Series[FSerieIndex].YValues.Positions;
    FYValSeriesCenterCheck.Checked := ypCenter in FChart.Series[FSerieIndex].YValues.Positions;
    FYValSeriesRightCheck.Checked := ypRight in FChart.Series[FSerieIndex].YValues.Positions;
    FYValSeriesValuesCheck.Checked := FChart.Series[FSerieIndex].YValues.SpiderValues;
    FYValSeriesMajSpacing.Value := Round(FChart.Series[FSerieIndex].YValues.MajorUnitSpacing);
    FYValSeriesMinSpacing.Value := Round(FChart.Series[FSerieIndex].YValues.MinorUnitSpacing);
    {$ENDIF}

    FYValSeriesMajFontName.ItemIndex := FYValSeriesMajFontName.Items.IndexOf(FChart.Series[FSerieIndex].YValues.MajorUnitFont.Name);
    FYValSeriesMajFontSize.Value := FChart.Series[FSerieIndex].YValues.MajorUnitFont.Size;

    FYValSeriesMinFontName.ItemIndex := FYValSeriesMinFontName.Items.IndexOf(FChart.Series[FSerieIndex].YValues.MinorUnitFont.Name);
    FYValSeriesMinFontSize.Value := FChart.Series[FSerieIndex].YValues.MinorUnitFont.Size;

    {$IFDEF FMXLIB}
    FYValSeriesMajFontCol.Color := FChart.Series[FSerieIndex].YValues.MajorUnitFont.Color;
    FYValSeriesMinFontCol.Color := FChart.Series[FSerieIndex].YValues.MinorUnitFont.Color;
    FYValSeriesMajTickCol.Color := FChart.Series[FSerieIndex].YValues.MajorUnitTickMarkColor;
    FYValSeriesMinTickCol.Color := FChart.Series[FSerieIndex].YValues.MinorUnitTickMarkColor;
    FYValSeriesMajTickSize.Value := FChart.Series[FSerieIndex].YValues.MajorUnitTickMarkSize;
    FYValSeriesMinTickSize.Value := FChart.Series[FSerieIndex].YValues.MinorUnitTickMarkSize;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYValSeriesMajFontCol.Selected := FChart.Series[FSerieIndex].YValues.MajorUnitFont.Color;
    FYValSeriesMinFontCol.Selected := FChart.Series[FSerieIndex].YValues.MinorUnitFont.Color;
    FYValSeriesMajTickCol.Selected := FChart.Series[FSerieIndex].YValues.MajorUnitTickMarkColor;
    FYValSeriesMinTickCol.Selected := FChart.Series[FSerieIndex].YValues.MinorUnitTickMarkColor;
    FYValSeriesMajTickSize.Value := Round(FChart.Series[FSerieIndex].YValues.MajorUnitTickMarkSize);
    FYValSeriesMinTickSize.Value := Round(FChart.Series[FSerieIndex].YValues.MinorUnitTickMarkSize);
    {$ENDIF}

    {$IFDEF FMXLIB}
    FYValSeriesAutoCheck.IsChecked := FChart.Series[FSerieIndex].YValues.AutoUnits;
    FYValSeriesUnitMajor.Value := FChart.Series[FSerieIndex].YValues.MajorUnit;
    FYValSeriesUnitMinor.Value := FChart.Series[FSerieIndex].YValues.MinorUnit;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYValSeriesAutoCheck.Checked := FChart.Series[FSerieIndex].YValues.AutoUnits;
    FYValSeriesUnitMajor.Value := Round(FChart.Series[FSerieIndex].YValues.MajorUnit);
    FYValSeriesUnitMinor.Value := Round(FChart.Series[FSerieIndex].YValues.MinorUnit);
    {$ENDIF}

    FYValSeriesMajFormatType.ItemIndex := Integer(FChart.Series[FSerieIndex].YValues.MajorUnitFormatType);
    FYValSeriesMajFormatValue.Text := FChart.Series[FSerieIndex].YValues.MajorUnitFormat;
    FYValSeriesMinFormatType.ItemIndex := Integer(FChart.Series[FSerieIndex].YValues.MinorUnitFormatType);
    FYValSeriesMinFormatValue.Text := FChart.Series[FSerieIndex].YValues.MinorUnitFormat;

    FYValSeriesTitleValue.Text := FChart.Series[FSerieIndex].YValues.Title.Text;
    FYValSeriesTitleHAlign.ItemIndex := Integer(FChart.Series[FSerieIndex].YValues.Title.TextHorizontalAlignment);
    FYValSeriesTitleVAlign.ItemIndex := Integer(FChart.Series[FSerieIndex].YValues.Title.TextVerticalAlignment);

    FYValSeriesTextLeft.Value := FChart.Series[FSerieIndex].YValues.Title.TextMargins.Left;
    FYValSeriesTextTop.Value := FChart.Series[FSerieIndex].YValues.Title.TextMargins.Top;
    FYValSeriesTextRight.Value := FChart.Series[FSerieIndex].YValues.Title.TextMargins.Right;
    FYValSeriesTextBottom.Value := FChart.Series[FSerieIndex].YValues.Title.TextMargins.Bottom;

    FYValSeriesTitleFontName.ItemIndex := FYValSeriesTitleFontName.Items.IndexOf(FChart.Series[FSerieIndex].YValues.Title.Font.Name);
    FYValSeriesTitleFontSize.Value := FChart.Series[FSerieIndex].YValues.Title.Font.Size;
    {$IFDEF FMXLIB}
    FYValSeriesTitleFontCol.Color := FChart.Series[FSerieIndex].YValues.Title.Font.Color;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYValSeriesTitleFontCol.Selected := FChart.Series[FSerieIndex].YValues.Title.Font.Color;
    {$ENDIF}

    // Y-Values SmartLabels
    {$IFDEF FMXLIB}
    FYValSeriesSmartEnabledCheck.IsChecked := FChart.Series[FSerieIndex].YValues.SmartLabels.Enabled;
    FYValSeriesSmartAutoRotateCheck.IsChecked := FChart.Series[FSerieIndex].YValues.SmartLabels.AutoRotate;
    FYValSeriesSmartMinSpacing.Value := FChart.Series[FSerieIndex].YValues.SmartLabels.MinLabelSpacing;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FYValSeriesSmartEnabledCheck.Checked := FChart.Series[FSerieIndex].YValues.SmartLabels.Enabled;
    FYValSeriesSmartAutoRotateCheck.Checked := FChart.Series[FSerieIndex].YValues.SmartLabels.AutoRotate;
    FYValSeriesSmartMinSpacing.Value := Round(FChart.Series[FSerieIndex].YValues.SmartLabels.MinLabelSpacing);
    {$ENDIF}
    FYValSeriesSmartMinLabels.Value := FChart.Series[FSerieIndex].YValues.SmartLabels.MinLabels;
    FYValSeriesSmartMaxLabels.Value := FChart.Series[FSerieIndex].YValues.SmartLabels.MaxLabels;

    // Pie Series Panel
    FPieSeriesLeft.Value := FChart.Series[FSerieIndex].Pie.Margins.Left;
    FPieSeriesTop.Value := FChart.Series[FSerieIndex].Pie.Margins.Top;
    FPieSeriesRight.Value := FChart.Series[FSerieIndex].Pie.Margins.Right;
    FPieSeriesBottom.Value := FChart.Series[FSerieIndex].Pie.Margins.Bottom;

    {$IFDEF FMXLIB}
    FPieSeriesSize.Value := FChart.Series[FSerieIndex].Pie.Size;
    FPieSeriesInnerSize.Value := FChart.Series[FSerieIndex].Pie.InnerSize;
    FPieSeriesStartAngle.Value := FChart.Series[FSerieIndex].Pie.StartAngle;
    FPieSeriesSweepAngle.Value := FChart.Series[FSerieIndex].Pie.SweepAngle;
    FPieSeriesAutoSizeCheck.IsChecked := FChart.Series[FSerieIndex].Pie.AutoSize;
    FPieSeriesStackedCheck.IsChecked := FChart.Series[FSerieIndex].Pie.Stacked;
    {$ENDIF}
    {$IFNDEF FMXLIB}
    FPieSeriesSize.Value := Round(FChart.Series[FSerieIndex].Pie.Size);
    FPieSeriesInnerSize.Value := Round(FChart.Series[FSerieIndex].Pie.InnerSize);
    FPieSeriesStartAngle.Value := Round(FChart.Series[FSerieIndex].Pie.StartAngle);
    FPieSeriesSweepAngle.Value := Round(FChart.Series[FSerieIndex].Pie.SweepAngle);
    FPieSeriesAutoSizeCheck.Checked := FChart.Series[FSerieIndex].Pie.AutoSize;
    FPieSeriesStackedCheck.Checked := FChart.Series[FSerieIndex].Pie.Stacked;
    {$ENDIF}
    FPieSeriesPosition.ItemIndex := Integer(FChart.Series[FSerieIndex].Pie.Position);

    SetSeriesEvents;
  end;
end;

function TTMSFNCChartSeriesEditor.SaveChartMessage: Boolean;
var
  res: Integer;
begin
  {$IFNDEF WEBLIB}
  Result := False;
  res := TTMSFNCUtils.Message(sTMSFNCChartSeriesEditorSaveChartMessage, TMsgDlgType.mtConfirmation, [TMsgDlgBtn.mbYes, TMsgDlgBtn.mbNo], 0);
  if res = VALUE_MBYES then
  {$ENDIF}
    Result := True;
end;

procedure TTMSFNCChartSeriesEditor.SetAppearance;
var
  {$IFDEF VCLLIB}
  LDetails: TThemedElementDetails;
  clr: TTMSFNCGraphicsColor;
  {$ENDIF}
  okfntCol, fntCol, fillCol, primCol, fc: TTMSFNCGraphicsColor;
  SubPanelFillCol, SubPanelStrokecol, MainPanelCol: TTMSFNCGraphicsColor;

  procedure SetEditorTabButton(ATabBtn: TTMSFNCEditorButton);
  begin
    {$IFDEF VCLLIB}
    if TTMSFNCChartOpen(FChart).VCLStylesEnabled and (fc <> EDITORPRIMCOLOR) then
      SetEditorSubTabButtonAppearance(ATabBtn, fc, 0, fntCol, MainPanelCol)
    else
    {$ENDIF}
      SetEditorSubTabButtonAppearance(ATabBtn);
  end;

  procedure SetEditorButton(ABtn: TTMSFNCEditorButton);
  begin
    {$IFDEF VCLLIB}
    if TTMSFNCChartOpen(FChart).VCLStylesEnabled and (fc <> EDITORPRIMCOLOR) then
    begin
      SetEditorIconButtonAppearance(ABtn, fc, EDITORBUTTONROUNDING, fntCol, fillCol);
      if Assigned(ABtn.Bitmap.SVG) then
        ABtn.Bitmap.SVG.CustomFillColor := fc;
      ABtn.Appearance.Font.Color := fc;
    end
    else
    {$ENDIF}
      SetEditorIconButtonAppearance(ABtn);
    ABtn.Appearance.Rounding := 10;

    ABtn.DownBitmap.Assign(ABtn.Bitmap);
    {$IFNDEF WEBLIB}
    if Assigned(ABtn.DownBitmap.SVG) then
      ABtn.DownBitmap.SVG.CustomFillColor := ABtn.Appearance.SelectedFont.Color;
    {$ENDIF}
  end;
begin
  primCol := EDITORPRIMCOLOR;
  fillCol := EDITORAUTOCOLOR;
  fntCol := EDITORAUTOCOLOR;
  okfntCol := EDITOROKFONTCOLOR;
  SubPanelStrokeCol := EDITORAUTOCOLOR;
  SubPanelFillCol := EDITORAUTOCOLOR;
  MainPanelCol := EDITORAUTOCOLOR;
  fc := EDITORPRIMCOLOR;
  {$IFDEF VCLLIB}
  if TTMSFNCChartOpen(FChart).VCLStylesEnabled then
  begin
    clr := StyleServices.GetStyleColor(scButtonHot);
    if clr <> clNone then
      primCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonPressed);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      okfntCol := clr;

    LDetails := StyleServices.GetElementDetails(ttbButtonHot);
    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
    begin
      fc := clr;
//      okfntCol := clr;
    end;

    LDetails := StyleServices.GetElementDetails(ttbButtonNormal);

    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      fillCol := clr;

    if StyleServices.GetElementColor(LDetails, ecTextColor, clr) and (clr <> clNone) then
      fntCol := clr;

    LDetails := StyleServices.GetElementDetails(tpPanelBackground);
    if StyleServices.GetElementColor(LDetails, ecFillColor, clr) and (clr <> clNone) then
      SubPanelFillCol := clr;
    if StyleServices.GetElementColor(LDetails, ecBorderColor, clr) and (clr <> clNone) then
      SubPanelStrokeCol := clr;

    clr := StyleServices.GetSystemColor(clBtnFace);
    if (clr <> clNone) then
    begin
      MainPanelCol := clr;
    end;
  end;
  FButtonOk.StyleElements := FButtonOk.StyleElements - [seClient];
  FButtonCancel.StyleElements := FButtonCancel.StyleElements - [seClient];

  FSeriesPanel.StyleElements := FSeriesPanel.StyleElements - [seClient];
  FSeriesTopPanel.StyleElements := FSeriesTopPanel.StyleElements - [seClient];
  FSeriesGeneralPanel.StyleElements := FSeriesGeneralPanel.StyleElements - [seClient];
  FSeriesLegendPanel.StyleElements := FSeriesLegendPanel.StyleElements - [seClient];
  FSeriesTypePanel.StyleElements := FSeriesTypePanel.StyleElements - [seClient];
  FSeriesLabelsPanel.StyleElements := FSeriesLabelsPanel.StyleElements - [seClient];
  FSeriesMarkersPanel.StyleElements := FSeriesMarkersPanel.StyleElements - [seClient];
  FSeriesXGridPanel.StyleElements := FSeriesXGridPanel.StyleElements - [seClient];
  FSeriesXValuesPanel.StyleElements := FSeriesXValuesPanel.StyleElements - [seClient];
  FSeriesYGridPanel.StyleElements := FSeriesYGridPanel.StyleElements - [seClient];
  FSeriesYValuesPanel.StyleElements := FSeriesYValuesPanel.StyleElements - [seClient];
  FSeriesPiePanel.StyleElements := FSeriesPiePanel.StyleElements - [seClient];
  FPanel.StyleElements := FPanel.StyleElements - [seClient];
  FTopPanel.StyleElements := FTopPanel.StyleElements - [seClient];
  FSeriesButtonsPanel.StyleElements := FSeriesButtonsPanel.StyleElements - [seClient];

  FSeriesButtonPie.StyleElements := FSeriesButtonPie.StyleElements - [seClient];
  FSeriesButtonYValues.StyleElements := FSeriesButtonYValues.StyleElements - [seClient];
  FSeriesButtonYGrid.StyleElements := FSeriesButtonYGrid.StyleElements - [seClient];
  FSeriesButtonXValues.StyleElements := FSeriesButtonXValues.StyleElements - [seClient];
  FSeriesButtonXGrid.StyleElements := FSeriesButtonXGrid.StyleElements - [seClient];
  FSeriesButtonMarkers.StyleElements := FSeriesButtonMarkers.StyleElements - [seClient];
  FSeriesButtonLabels.StyleElements := FSeriesButtonLabels.StyleElements - [seClient];
  FSeriesButtonType.StyleElements := FSeriesButtonType.StyleElements - [seClient];
  FSeriesButtonLegend.StyleElements := FSeriesButtonLegend.StyleElements - [seClient];
  FSeriesButtonGeneral.StyleElements := FSeriesButtonGeneral.StyleElements - [seClient];

  FAddSeriesButton.StyleElements := FAddSeriesButton.StyleElements - [seClient];
  FDeleteSeriesButton.StyleElements := FDeleteSeriesButton.StyleElements - [seClient];
  FClearSeriesButton.StyleElements := FClearSeriesButton.StyleElements - [seClient];
  {$ENDIF}

  SetEditorSubPanelAppearance(FSeriesPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesTopPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesGeneralPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesLegendPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesTypePanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesLabelsPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesMarkersPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesXGridPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesXValuesPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesYGridPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesYValuesPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorSubPanelAppearance(FSeriesPiePanel, SubPanelFillCol, SubPanelStrokeCol);

  SetEditorBackPanelAppearance(FTopPanel, MainPanelCol, MainPanelCol);
  SetEditorBackPanelAppearance(FSeriesButtonsPanel, MainPanelCol, MainPanelCol);

  SetEditorTabButton(FSeriesButtonPie);
  SetEditorTabButton(FSeriesButtonYValues);
  SetEditorTabButton(FSeriesButtonYGrid);
  SetEditorTabButton(FSeriesButtonXValues);
  SetEditorTabButton(FSeriesButtonXGrid);
  SetEditorTabButton(FSeriesButtonMarkers);
  SetEditorTabButton(FSeriesButtonLabels);
  SetEditorTabButton(FSeriesButtonType);
  SetEditorTabButton(FSeriesButtonLegend);
  SetEditorTabButton(FSeriesButtonGeneral);

  SetEditorButton(FAddSeriesButton);
  SetEditorButton(FDeleteSeriesButton);
  SetEditorButton(FClearSeriesButton);

  SetEditorOKButtonAppearance(FButtonOk, primCol, EDITORBUTTONROUNDING, okfntCol);
  SetEditorCancelButtonAppearance(FButtonCancel, fc, EDITORBUTTONROUNDING, fntCol, fillCol);
  SetEditorSubPanelAppearance(FSeriesPanel, SubPanelFillCol, SubPanelStrokeCol);
  SetEditorBackPanelAppearance(FPanel, MainPanelCol, MainPanelCol);
end;

procedure TTMSFNCChartSeriesEditor.SetChart(const Value: TTMSFNCChart);
begin
  FChart := Value;
end;

procedure TTMSFNCChartSeriesEditor.SetCharTypeSelector(AChartType: TTMSFNCChartSerieType);
begin
  FChartSelectorLine.Selected := FChartSelectorLine.ChartType = AChartType;
  FChartSelectorDigitalLine.Selected := FChartSelectorDigitalLine.ChartType = AChartType;
  FChartSelectorArea.Selected := FChartSelectorArea.ChartType = AChartType;
  FChartSelectorStackedArea.Selected := FChartSelectorStackedArea.ChartType = AChartType;
  FChartSelectorStackedPercArea.Selected := FChartSelectorStackedPercArea.ChartType = AChartType;
  FChartSelectorBar.Selected := FChartSelectorBar.ChartType = AChartType;
  FChartSelectorStackedBar.Selected := FChartSelectorStackedBar.ChartType = AChartType;
  FChartSelectorPercBar.Selected := FChartSelectorPercBar.ChartType = AChartType;
  FChartSelectorMarker.Selected := FChartSelectorMarker.ChartType = AChartType;
  FChartSelectorXYLine.Selected := FChartSelectorXYLine.ChartType = AChartType;
  FChartSelectorXYMarker.Selected := FChartSelectorXYMarker.ChartType = AChartType;
  FChartSelectorPie.Selected := FChartSelectorPie.ChartType = AChartType;
  FChartSelectorVarRadiusPie.Selected := FChartSelectorVarRadiusPie.ChartType = AChartType;
  FChartSelectorSizedPie.Selected := FChartSelectorSizedPie.ChartType = AChartType;
  FChartSelectorSpider.Selected := FChartSelectorSpider.ChartType = AChartType;
  FChartSelectorBand.Selected := FChartSelectorBand.ChartType = AChartType;
  FChartSelectorOHLC.Selected := FChartSelectorOHLC.ChartType = AChartType;
  FChartSelectorCandleStick.Selected := FChartSelectorCandleStick.ChartType = AChartType;
  FChartSelectorBoxPlot.Selected := FChartSelectorBoxPlot.ChartType = AChartType;
end;

procedure TTMSFNCChartSeriesEditor.SetSerie(const Value: TTMSFNCChartSerie);
begin
  FSerie := Value;
  if Assigned(FSerie) then
    FChart := FSerie.Chart;
end;

procedure TTMSFNCChartSeriesEditor.SetSeriesEvents;
begin
  //  General Series Panel
  FSeriesSelectCombo.OnChange := @DoSeriesComboChange;

  FGenSeriesFillKind.OnChange := @DoGenSeriesFillChange;
  FGenSeriesFillGradient.OnChange := @DoGenSeriesFillChange;
  {$IFDEF WEBLIB}
  FGenSeriesFillCol1.OnSelect := @DoGenSeriesFillChange;
  FGenSeriesFillCol2.OnSelect := @DoGenSeriesFillChange;
  FGenSeriesStrokeCol.OnSelect := @DoGenSeriesStrokeChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FGenSeriesFillCol1.OnChange := @DoGenSeriesFillChange;
  FGenSeriesFillCol2.OnChange := @DoGenSeriesFillChange;
  FGenSeriesStrokeCol.OnChange := @DoGenSeriesStrokeChange;
  {$ENDIF}
  {$IFDEF FMXLIB}
  FGenSeriesFillOpacity.OnChange := @DoGenSeriesFillChange;
  FGenSeriesStrokeOpacity.OnChange := @DoGenSeriesStrokeChange;
  {$ENDIF}
  FGenSeriesStrokeWidth.OnChange := @DoGenSeriesStrokeChange;
  FGenSeriesStrokeKind.OnChange := @DoGenSeriesStrokeChange;

  FGenSeriesOffsetX.OnChange := @DoGenSeries3DChange;
  FGenSeriesOffsetY.OnChange := @DoGenSeries3DChange;
  {$IFDEF FMXLIB}
  FGenSeriesEnabledCheck.OnChange := @DoGenSeries3DChange;
  FGenSeriesEnabledCheck.OnChange := @DoGenSeries3DChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenSeriesEnabledCheck.OnClick := @DoGenSeries3DChange;
  FGenSeriesEnabledCheck.OnClick := @DoGenSeries3DChange;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FGenSeriesVisibleCheck.OnChange := @DoGenSeriesOtherChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenSeriesVisibleCheck.OnClick := @DoGenSeriesOtherChange;
  {$ENDIF}
  FGenSeriesGroup.OnChange := @DoGenSeriesOtherChange;
  FGenSeriesMode.OnChange := @DoGenSeriesOtherChange;

  FGenSeriesXRange.OnChange := @DoGenSeriesRangeChange;
  FGenSeriesYRange.OnChange := @DoGenSeriesRangeChange;
  FGenSeriesZRV.OnChange := @DoGenSeriesRangeChange;

  FGenSeriesMinX.OnChange := @DoGenSeriesRangeMinMax;
  FGenSeriesMinY.OnChange := @DoGenSeriesRangeMinMax;
  FGenSeriesMaxX.OnChange := @DoGenSeriesRangeMinMax;
  FGenSeriesMaxY.OnChange := @DoGenSeriesRangeMinMax;

  FGenSeriesMinXOff.OnChange := @DoGenSeriesRangeOffsetChange;
  FGenSeriesMaxXOff.OnChange := @DoGenSeriesRangeOffsetChange;
  FGenSeriesMinYOff.OnChange := @DoGenSeriesRangeOffsetChange;
  FGenSeriesMaxYOff.OnChange := @DoGenSeriesRangeOffsetChange;

//  FGenSeriesBarType.OnChange := @DoGenSeriesBarChange;
//  FGenSeriesBarWidth.OnChange := @DoGenSeriesBarChange;
//  FGenSeriesBarSpacing.OnChange := @DoGenSeriesBarChange;
//
//  FGenSeriesMultiType.OnChange := @DoGenSeriesMultiPointChange;
//  FGenSeriesMultiWidth.OnChange := @DoGenSeriesMultiPointChange;
//  {$IFDEF WEBLIB}
//  FGenSeriesIncFill.OnSelect := @DoGenSeriesMultiPointChange;
//  FGenSeriesIncStroke.OnSelect := @DoGenSeriesMultiPointChange;
//  FGenSeriesDecFill.OnSelect := @DoGenSeriesMultiPointChange;
//  FGenSeriesDecStroke.OnSelect := @DoGenSeriesMultiPointChange;
//  {$ENDIF}
//  {$IFNDEF WEBLIB}
//  FGenSeriesIncFill.OnChange := @DoGenSeriesMultiPointChange;
//  FGenSeriesIncStroke.OnChange := @DoGenSeriesMultiPointChange;
//  FGenSeriesDecFill.OnChange := @DoGenSeriesMultiPointChange;
//  FGenSeriesDecStroke.OnChange := @DoGenSeriesMultiPointChange;
//  {$ENDIF}

  FGenSeriesFactor.OnChange := @DoGenSeriesAnimationChange;
  {$IFDEF FMXLIB}
  FGenSeriesFlowCheck.OnChange := @DoGenSeriesAnimationChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FGenSeriesFlowCheck.OnClick := @DoGenSeriesAnimationChange;
  {$ENDIF}

  //  Legend Series Panel
  FLegSeriesValue.OnChange := @DoLegSeriesPositionChange;
  FLegSeriesAppLeft.OnChange := @DoLegSeriesPositionChange;
  FLegSeriesAppTop.OnChange := @DoLegSeriesPositionChange;
  {$IFDEF FMXLIB}
  FLegSeriesVisibleCheck.OnChange := @DoLegSeriesPositionChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegSeriesVisibleCheck.OnClick := @DoLegSeriesPositionChange;
  {$ENDIF}

  FLegSeriesFillKind.OnChange := @DoLegSeriesFillChange;
  FLegSeriesFillGradient.OnChange := @DoLegSeriesFillChange;
  {$IFDEF FMXLIB}
  FLegSeriesFillOpacity.OnChange := @DoLegSeriesFillChange;
  FLegSeriesStrokeOpacity.OnChange := @DoLegSeriesStrokeChange;
  {$ENDIF}
  FLegSeriesStrokeWidth.OnChange := @DoLegSeriesStrokeChange;
  FLegSeriesStrokeKind.OnChange := @DoLegSeriesStrokeChange;

  {$IFDEF WEBLIB}
  FLegSeriesFillCol1.OnSelect := @DoLegSeriesFillChange;
  FLegSeriesFillCol2.OnSelect := @DoLegSeriesFillChange;
  FLegSeriesFontCol.OnSelect := @DoLegSeriesFontChange;
  FLegSeriesStrokeCol.OnSelect := @DoLegSeriesStrokeChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FLegSeriesFillCol1.OnChange := @DoLegSeriesFillChange;
  FLegSeriesFillCol2.OnChange := @DoLegSeriesFillChange;
  FLegSeriesFontCol.OnChange := @DoLegSeriesFontChange;
  FLegSeriesStrokeCol.OnChange := @DoLegSeriesStrokeChange;
  {$ENDIF}

  FLegSeriesFontName.OnChange := @DoLegSeriesFontChange;
  FLegSeriesSize.OnChange := @DoLegSeriesFontChange;

  FLegSeriesText.OnChange := @DoLegSeriesTextChange;
  {$IFDEF FMXLIB}
  FLegSeriesShowCheck.OnChange := @DoLegSeriesTextChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLegSeriesShowCheck.OnClick := @DoLegSeriesTextChange;
  {$ENDIF}

  // Label Series Panel
  FLabelSeriesOffsetX.OnChange := @DoLblSeriesPositionChange;
  FLabelSeriesOffsetY.OnChange := @DoLblSeriesPositionChange;
  {$IFDEF FMXLIB}
  FLabelSeriesVisibleCheck.OnChange := @DoLblSeriesPositionChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FLabelSeriesVisibleCheck.OnClick := @DoLblSeriesPositionChange;
  {$ENDIF}


  FLabelSeriesFillKind.OnChange := @DoLblSeriesFillChange;
  FLabelSeriesFillGradient.OnChange := @DoLblSeriesFillChange;
  {$IFDEF FMXLIB}
  FLabelSeriesFillOpacity.OnChange := @DoLblSeriesFillChange;
  FLabelSeriesStrokeOpacity.OnChange := @DoLblSeriesStrokeChange;
  {$ENDIF}
  FLabelSeriesStrokeWidth.OnChange := @DoLblSeriesStrokeChange;
  FLabelSeriesStrokeKind.OnChange := @DoLblSeriesStrokeChange;

  {$IFDEF WEBLIB}
  FLabelSeriesFillCol1.OnSelect := @DoLblSeriesFillChange;
  FLabelSeriesFillCol2.OnSelect := @DoLblSeriesFillChange;
  FLabelSeriesStrokeCol.OnSelect := @DoLblSeriesStrokeChange;
  FLabelSeriesFontCol.OnSelect := @DoLblSeriesFontChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FLabelSeriesFillCol1.OnChange := @DoLblSeriesFillChange;
  FLabelSeriesFillCol2.OnChange := @DoLblSeriesFillChange;
  FLabelSeriesStrokeCol.OnChange := @DoLblSeriesStrokeChange;
  FLabelSeriesFontCol.OnChange := @DoLblSeriesFontChange;
  {$ENDIF}

  FLabelSeriesFontName.OnChange := @DoLblSeriesFontChange;
  FLabelSeriesSize.OnChange := @DoLblSeriesFontChange;

  FLabelSeriesType.OnChange := @DoLblSeriesFormatChange;
  FLabelSeriesMode.OnChange := @DoLblSeriesFormatChange;
  FLabelSeriesText.OnChange := @DoLblSeriesFormatChange;

  // Markes Series Panel
  FMarkersSeriesWidth.OnChange := @DoMarkersSeriesSizeChange;
  FMarkersSeriesHeight.OnChange := @DoMarkersSeriesSizeChange;
  {$IFDEF FMXLIB}
  FMarkersSeriesVisibleCheck.OnChange := @DoMarkersSeriesSizeChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FMarkersSeriesVisibleCheck.OnClick := @DoMarkersSeriesSizeChange;
  {$ENDIF}

  FMarkersSeriesFillKind.OnChange := @DoMarkersSeriesFillChange;
  FMarkersSeriesFillGradient.OnChange := @DoMarkersSeriesFillChange;
  {$IFDEF FMXLIB}
  FMarkersSeriesFillOpacity.OnChange := @DoMarkersSeriesFillChange;
  {$ENDIF}

  {$IFDEF WEBLIB}
  FMarkersSeriesFillCol1.OnSelect := @DoMarkersSeriesFillChange;
  FMarkersSeriesFillCol2.OnSelect := @DoMarkersSeriesFillChange;
  FMarkersSeriesStrokeCol.OnSelect := @DoMarkersSeriesStrokeChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FMarkersSeriesFillCol1.OnChange := @DoMarkersSeriesFillChange;
  FMarkersSeriesFillCol2.OnChange := @DoMarkersSeriesFillChange;
  FMarkersSeriesStrokeCol.OnChange := @DoMarkersSeriesStrokeChange;
  {$ENDIF}

  FMarkersSeriesStrokeKind.OnChange := @DoMarkersSeriesStrokeChange;
  FMarkersSeriesStrokeWidth.OnChange := @DoMarkersSeriesStrokeChange;
  {$IFDEF FMXLIB}
  FMarkersSeriesStrokeOpacity.OnChange := @DoMarkersSeriesStrokeChange;
  {$ENDIF}

  FMarkersSeriesShape.OnChange := @DoMarkersSeriesShapeChange;

  // X-Grid Series Panel
  {$IFDEF FMXLIB}
  FXGridSeriesVisibleCheck.OnChange := @DoXGridSeriesVisibilityChange;
  FXGridSeriesExtendedCheck.OnChange := @DoXGridSeriesVisibilityChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXGridSeriesVisibleCheck.OnClick := @DoXGridSeriesVisibilityChange;
  FXGridSeriesExtendedCheck.OnClick := @DoXGridSeriesVisibilityChange;
  {$ENDIF}


  FXGridSeriesMajorStrokeKind.OnChange := @DoXGridSeriesMajorStrokeChange;
  FXGridSeriesMajorStrokeWidth.OnChange := @DoXGridSeriesMajorStrokeChange;
  {$IFDEF FMXLIB}
  FXGridSeriesMajorStrokeOpacity.OnChange := @DoXGridSeriesMajorStrokeChange;
  {$ENDIF}

  FXGridSeriesMinorStrokeKind.OnChange := @DoXGridSeriesMinorStrokeChange;
  FXGridSeriesMinorStrokeWidth.OnChange := @DoXGridSeriesMinorStrokeChange;
  {$IFDEF FMXLIB}
  FXGridSeriesMinorStrokeOpacity.OnChange := @DoXGridSeriesMinorStrokeChange;
  {$ENDIF}

  {$IFDEF WEBLIB}
  FXGridSeriesMajorStrokeCol.OnSelect := @DoXGridSeriesMajorStrokeChange;
  FXGridSeriesMinorStrokeCol.OnSelect := @DoXGridSeriesMinorStrokeChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FXGridSeriesMajorStrokeCol.OnChange := @DoXGridSeriesMajorStrokeChange;
  FXGridSeriesMinorStrokeCol.OnChange := @DoXGridSeriesMinorStrokeChange;
  {$ENDIF}

  // X-Values Series Panel
  FXValSeriesAngle.OnChange := @DoXValSeriesPositionChange;
  FXValSeriesMajSpacing.OnChange := @DoXValSeriesPositionChange;
  FXValSeriesMinSpacing.OnChange := @DoXValSeriesPositionChange;
  {$IFDEF FMXLIB}
  FXValSeriesTopCheck.OnChange := @DoXValSeriesPositionChange;
  FXValSeriesCenterCheck.OnChange := @DoXValSeriesPositionChange;
  FXValSeriesBottomCheck.OnChange := @DoXValSeriesPositionChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXValSeriesTopCheck.OnClick := @DoXValSeriesPositionChange;
  FXValSeriesCenterCheck.OnClick := @DoXValSeriesPositionChange;
  FXValSeriesBottomCheck.OnClick := @DoXValSeriesPositionChange;
  {$ENDIF}

  FXValSeriesMajFontName.OnChange := @DoXValSeriesMajorFontChange;
  FXValSeriesMajFontSize.OnChange := @DoXValSeriesMajorFontChange;

  FXValSeriesMinFontName.OnChange := @DoXValSeriesMinorFontChange;
  FXValSeriesMinFontSize.OnChange := @DoXValSeriesMinorFontChange;

  FXValSeriesMajTickSize.OnChange := @DoXValSeriesMajorTickmarkChange;

  FXValSeriesMinTickSize.OnChange := @DoXValSeriesMinorTickmarkChange;

  {$IFDEF WEBLIB}
  FXValSeriesMajFontCol.OnSelect := @DoXValSeriesMajorFontChange;
  FXValSeriesMinFontCol.OnSelect := @DoXValSeriesMinorFontChange;
  FXValSeriesMajTickCol.OnSelect := @DoXValSeriesMajorTickmarkChange;
  FXValSeriesMinTickCol.OnSelect := @DoXValSeriesMinorTickmarkChange;
  FXValSeriesTitleFontCol.OnSelect := @DoXValSeriesTitleFontChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FXValSeriesMajFontCol.OnChange := @DoXValSeriesMajorFontChange;
  FXValSeriesMinFontCol.OnChange := @DoXValSeriesMinorFontChange;
  FXValSeriesMajTickCol.OnChange := @DoXValSeriesMajorTickmarkChange;
  FXValSeriesMinTickCol.OnChange := @DoXValSeriesMinorTickmarkChange;
  FXValSeriesTitleFontCol.OnChange := @DoXValSeriesTitleFontChange;
  {$ENDIF}

  FXValSeriesUnitMajor.OnChange := @DoXValSeriesUnitsChange;
  FXValSeriesUnitMinor.OnChange := @DoXValSeriesUnitsChange;
  {$IFDEF FMXLIB}
  FXValSeriesAutoCheck.OnChange := @DoXValSeriesUnitsChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXValSeriesAutoCheck.OnClick := @DoXValSeriesUnitsChange;
  {$ENDIF}

  FXValSeriesMajFormatType.OnChange := @DoXValSeriesMajorFormatChange;
  FXValSeriesMajFormatValue.OnChange := @DoXValSeriesMajorFormatChange;
  FXValSeriesMinFormatType.OnChange := @DoXValSeriesMinorFormatChange;
  FXValSeriesMinFormatValue.OnChange := @DoXValSeriesMinorFormatChange;

  FXValSeriesTitleValue.OnChange := @DoXValSeriesTitleChange;
  FXValSeriesTitleHAlign.OnChange := @DoXValSeriesTitleChange;
  FXValSeriesTitleVAlign.OnChange := @DoXValSeriesTitleChange;

  FXValSeriesTextLeft.OnChange := @DoXValSeriesTextMarginsChange;
  FXValSeriesTextTop.OnChange := @DoXValSeriesTextMarginsChange;
  FXValSeriesTextRight.OnChange := @DoXValSeriesTextMarginsChange;
  FXValSeriesTextBottom.OnChange := @DoXValSeriesTextMarginsChange;

  FXValSeriesTitleFontName.OnChange := @DoXValSeriesTitleFontChange;
  FXValSeriesTitleFontSize.OnChange := @DoXValSeriesTitleFontChange;

  // X-Values SmartLabels
  {$IFDEF FMXLIB}
  FXValSeriesSmartEnabledCheck.OnChange := @DoXValSeriesSmartLabelsChange;
  FXValSeriesSmartAutoRotateCheck.OnChange := @DoXValSeriesSmartLabelsChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FXValSeriesSmartEnabledCheck.OnClick := @DoXValSeriesSmartLabelsChange;
  FXValSeriesSmartAutoRotateCheck.OnClick := @DoXValSeriesSmartLabelsChange;
  {$ENDIF}
  FXValSeriesSmartMinSpacing.OnChange := @DoXValSeriesSmartLabelsChange;
  FXValSeriesSmartMinLabels.OnChange := @DoXValSeriesSmartLabelsChange;
  FXValSeriesSmartMaxLabels.OnChange := @DoXValSeriesSmartLabelsChange;

  // Y-Grid Series Panel
  {$IFDEF FMXLIB}
  FYGridSeriesVisibleCheck.OnChange := @DoYGridSeriesVisibilityChange;
  FYGridSeriesExtendedCheck.OnChange := @DoYGridSeriesVisibilityChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYGridSeriesVisibleCheck.OnClick := @DoYGridSeriesVisibilityChange;
  FYGridSeriesExtendedCheck.OnClick := @DoYGridSeriesVisibilityChange;
  {$ENDIF}

  FYGridSeriesMajorStrokeKind.OnChange := @DoYGridSeriesMajorStrokeChange;
  FYGridSeriesMajorStrokeWidth.OnChange := @DoYGridSeriesMajorStrokeChange;
  {$IFDEF FMXLIB}
  FYGridSeriesMajorStrokeOpacity.OnChange := @DoYGridSeriesMajorStrokeChange;
  {$ENDIF}

  FYGridSeriesMinorStrokeKind.OnChange := @DoYGridSeriesMinorStrokeChange;
  FYGridSeriesMinorStrokeWidth.OnChange := @DoYGridSeriesMinorStrokeChange;
  {$IFDEF FMXLIB}
  FYGridSeriesMinorStrokeOpacity.OnChange := @DoYGridSeriesMinorStrokeChange;
  {$ENDIF}

  {$IFDEF FMXLIB}
  FYGridSeriesSpiderVisibleCheck.OnChange := @DoYGridSeriesSpiderChange;
  FYGridSeriesLegendTextCheck.OnChange := @DoYGridSeriesSpiderChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYGridSeriesSpiderVisibleCheck.OnClick := @DoYGridSeriesSpiderChange;
  FYGridSeriesLegendTextCheck.OnClick := @DoYGridSeriesSpiderChange;
  {$ENDIF}
  FYGridSeriesSpiderKind.OnChange := @DoYGridSeriesSpiderChange;

  {$IFDEF WEBLIB}
  FYGridSeriesMajorStrokeCol.OnSelect := @DoYGridSeriesMajorStrokeChange;
  FYGridSeriesMinorStrokeCol.OnSelect := @DoYGridSeriesMinorStrokeChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FYGridSeriesMajorStrokeCol.OnChange := @DoYGridSeriesMajorStrokeChange;
  FYGridSeriesMinorStrokeCol.OnChange := @DoYGridSeriesMinorStrokeChange;
  {$ENDIF}

  // Y-Values Series Panel
  FYValSeriesMajSpacing.OnChange := @DoYValSeriesPositionChange;
  FYValSeriesMinSpacing.OnChange := @DoYValSeriesPositionChange;
  {$IFDEF FMXLIB}
  FYValSeriesLeftCheck.OnChange := @DoYValSeriesPositionChange;
  FYValSeriesCenterCheck.OnChange := @DoYValSeriesPositionChange;
  FYValSeriesRightCheck.OnChange := @DoYValSeriesPositionChange;
  FYValSeriesValuesCheck.OnChange := @DoYValSeriesPositionChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYValSeriesLeftCheck.OnClick := @DoYValSeriesPositionChange;
  FYValSeriesCenterCheck.OnClick := @DoYValSeriesPositionChange;
  FYValSeriesRightCheck.OnClick := @DoYValSeriesPositionChange;
  FYValSeriesValuesCheck.OnClick := @DoYValSeriesPositionChange;
  {$ENDIF}

  FYValSeriesMajFontName.OnChange := @DoYValSeriesMajorFontChange;
  FYValSeriesMajFontSize.OnChange := @DoYValSeriesMajorFontChange;

  FYValSeriesMinFontName.OnChange := @DoYValSeriesMinorFontChange;
  FYValSeriesMinFontSize.OnChange := @DoYValSeriesMinorFontChange;

  FYValSeriesMajTickSize.OnChange := @DoYValSeriesMajorTickmarkChange;

  FYValSeriesMinTickSize.OnChange := @DoYValSeriesMinorTickmarkChange;

  {$IFDEF WEBLIB}
  FYValSeriesMajFontCol.OnSelect := @DoYValSeriesMajorFontChange;
  FYValSeriesMinFontCol.OnSelect := @DoYValSeriesMinorFontChange;
  FYValSeriesMajTickCol.OnSelect := @DoYValSeriesMajorTickmarkChange;
  FYValSeriesMinTickCol.OnSelect := @DoYValSeriesMinorTickmarkChange;
  FYValSeriesTitleFontCol.OnSelect := @DoYValSeriesTitleFontChange;
  {$ENDIF}
  {$IFNDEF WEBLIB}
  FYValSeriesMajFontCol.OnChange := @DoYValSeriesMajorFontChange;
  FYValSeriesMinFontCol.OnChange := @DoYValSeriesMinorFontChange;
  FYValSeriesMajTickCol.OnChange := @DoYValSeriesMajorTickmarkChange;
  FYValSeriesMinTickCol.OnChange := @DoYValSeriesMinorTickmarkChange;
  FYValSeriesTitleFontCol.OnChange := @DoYValSeriesTitleFontChange;
  {$ENDIF}

  FYValSeriesUnitMajor.OnChange := @DoYValSeriesUnitsChange;
  FYValSeriesUnitMinor.OnChange := @DoYValSeriesUnitsChange;
  {$IFDEF FMXLIB}
  FYValSeriesAutoCheck.OnChange := @DoYValSeriesUnitsChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYValSeriesAutoCheck.OnClick := @DoYValSeriesUnitsChange;
  {$ENDIF}

  FYValSeriesMajFormatType.OnChange := @DoYValSeriesMajorFormatChange;
  FYValSeriesMajFormatValue.OnChange := @DoYValSeriesMajorFormatChange;
  FYValSeriesMinFormatType.OnChange := @DoYValSeriesMinorFormatChange;
  FYValSeriesMinFormatValue.OnChange := @DoYValSeriesMinorFormatChange;

  FYValSeriesTitleValue.OnChange := @DoYValSeriesTitleChange;
  FYValSeriesTitleHAlign.OnChange := @DoYValSeriesTitleChange;
  FYValSeriesTitleVAlign.OnChange := @DoYValSeriesTitleChange;

  FYValSeriesTextLeft.OnChange := @DoYValSeriesTextMarginsChange;
  FYValSeriesTextTop.OnChange := @DoYValSeriesTextMarginsChange;
  FYValSeriesTextRight.OnChange := @DoYValSeriesTextMarginsChange;
  FYValSeriesTextBottom.OnChange := @DoYValSeriesTextMarginsChange;

  FYValSeriesTitleFontName.OnChange := @DoYValSeriesTitleFontChange;
  FYValSeriesTitleFontSize.OnChange := @DoYValSeriesTitleFontChange;

  // Y-Values SmartLabels
  {$IFDEF FMXLIB}
  FYValSeriesSmartEnabledCheck.OnChange := @DoYValSeriesSmartLabelsChange;
  FYValSeriesSmartAutoRotateCheck.OnChange := @DoYValSeriesSmartLabelsChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FYValSeriesSmartEnabledCheck.OnClick := @DoYValSeriesSmartLabelsChange;
  FYValSeriesSmartAutoRotateCheck.OnClick := @DoYValSeriesSmartLabelsChange;
  {$ENDIF}
  FYValSeriesSmartMinSpacing.OnChange := @DoYValSeriesSmartLabelsChange;
  FYValSeriesSmartMinLabels.OnChange := @DoYValSeriesSmartLabelsChange;
  FYValSeriesSmartMaxLabels.OnChange := @DoYValSeriesSmartLabelsChange;

   // Pie Series Panel
  FPieSeriesLeft.OnChange := @DoPieSeriesMarginsChange;
  FPieSeriesTop.OnChange := @DoPieSeriesMarginsChange;
  FPieSeriesRight.OnChange := @DoPieSeriesMarginsChange;
  FPieSeriesBottom.OnChange := @DoPieSeriesMarginsChange;

  FPieSeriesSize.OnChange := @DoPieSeriesLayoutChange;
  FPieSeriesInnerSize.OnChange := @DoPieSeriesLayoutChange;
  FPieSeriesStartAngle.OnChange := @DoPieSeriesLayoutChange;
  FPieSeriesSweepAngle.OnChange := @DoPieSeriesLayoutChange;
  {$IFDEF FMXLIB}
  FPieSeriesAutoSizeCheck.OnChange := @DoPieSeriesLayoutChange;
  FPieSeriesStackedCheck.OnChange := @DoPieSeriesLayoutChange;
  {$ENDIF}
  {$IFNDEF FMXLIB}
  FPieSeriesAutoSizeCheck.OnClick := @DoPieSeriesLayoutChange;
  FPieSeriesStackedCheck.OnClick := @DoPieSeriesLayoutChange;
  {$ENDIF}
  FPieSeriesPosition.OnChange := @DoPieSeriesLayoutChange;
end;

procedure TTMSFNCChartSeriesEditor.UpdateSeriesCombo(AIndex: Integer = -1);
var
  idx, i: Integer;
begin
  idx := FSeriesSelectCombo.ItemIndex;
  FSeriesSelectCombo.Items.Clear;
  for I := 0 to FChart.Series.Count - 1 do
  begin
    FSeriesSelectCombo.Items.AddObject(FChart.Series[I].LegendText, FChart.Series[I]);
  end;

  if (AIndex >= 0) then
    idx := AIndex;

  if (idx  > FChart.Series.Count - 1) then
    idx := FChart.Series.Count - 1
  else if (idx < 0) then
    idx := 0;

  FSeriesSelectCombo.ItemIndex := idx;

  FDeleteSeriesButton.Visible := FChart.Series.Count > 0;
  FClearSeriesButton.Visible := FChart.Series.Count > 0;
end;

{$IFDEF FMXLIB}
{ TTMSFNCChartAppearanceEditorSpinEdit }

constructor TTMSFNCChartSeriesEditorSpinEdit.Create(AOwner: TComponent);
begin
  inherited;
  Max := 100000;
  Min := -100000;
end;
{$ENDIF}

{$IFDEF CMNWEBLIB}
constructor TTMSFNCChartSeriesEditorComboBox.Create(AOwner: TComponent);
begin
  inherited;
  {$IFDEF VCLLIB}
  {$IF COMPILERVERSION > 34}
  AutoDropDownWidth := True;
  {$IFEND}
  {$ENDIF}
end;

procedure TTMSFNCChartSeriesEditor.SetColorComboStyle(AColorcombo: TTMSFNCChartSeriesEditorColorCombo);
begin
  {$IFNDEF WEBLIB}
  AColorcombo.Style := [cbStandardColors, cbExtendedColors, cbCustomColor];
  {$ENDIF}
end;
{$ENDIF}

{$IFDEF WEBLIB}

{ TTMSFNCChartSeriesEditorForm }

constructor TTMSFNCChartSeriesEditorForm.CreateDialogNew(AChartEditor: TTMSFNCChartSeriesEditor; ACaption: string);
begin
  FChartEditor := AChartEditor;
  inherited CreateDialogNew(ACaption);
end;

procedure TTMSFNCChartSeriesEditorForm.LoadDFMValues;
begin
  inherited LoadDFMValues;
  if Assigned(FChartEditor) then
  begin
    FChartEditor.BuildEditor(Self);
  end;
end;

procedure TTMSFNCChartSeriesEditorForm.Loaded;
var
  css: string;
begin
  inherited;

  css := Application.IDECSS;

  if (css <> '') then
  begin
    AddCSS('IDECSS', css);
    ElementClassName := 'IDEBkg';
    CaptionElement['class'] := 'IDECaption IDEFont';
    if Assigned(FChartEditor) then
      FChartEditor.ApplyCSS(css);
  end;
end;
{$ENDIF}

{ TTMSFNCChartEditorSelector }

constructor TTMSFNCChartEditorSelector.Create(AOwner: TComponent);
begin
  inherited;

  SelectedColor := EDITORPRIMCOLOR;
  {$IFDEF FMXLIB}
  Font.Size := 10;
  {$ENDIF}
  {$IFDEF CMNWEBLIB}
  Font.Size := 7;
  {$ENDIF}

  Width := SELECTORSIZE + 10;
  Height := SELECTORSIZE;
  {$IFDEF VCLLIB}
  InitVCLStyes;
  {$ENDIF}
end;

{$IFDEF WEBLIB}
initialization
begin
  TTMSFNCBitmap.CreateFromResource(TTMSFNCADDBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCREMOVEBITMAP);
  TTMSFNCBitmap.CreateFromResource(TTMSFNCCLEARBITMAP);
end;
{$ENDIF}

end.
